import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
};

export type AcceptProjectMemberInvitationInput = {
  projectId: Scalars['ID'];
  tenant?: InputMaybe<TenantsDetailsInput>;
};

export type AdminUpdateUserInput = {
  avatarUrl?: InputMaybe<Scalars['String']>;
  businessRole?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  status: Status;
};

export type AreaField = {
  __typename?: 'AreaField';
  /** input label displayed to usrs */
  label: Scalars['String'];
  /** internal key for answer value */
  name: Scalars['String'];
  type: Scalars['String'];
};

export type CheckboxField = {
  __typename?: 'CheckboxField';
  /** input label displayed to users */
  label: Scalars['String'];
  /** internal key for answer value */
  name: Scalars['String'];
  type: Scalars['String'];
};

/** Client */
export type Client = {
  __typename?: 'Client';
  createdBy?: Maybe<DisplayUserSchema>;
  createdOn: Scalars['DateTime'];
  id: Scalars['ID'];
  industries: Array<Industry>;
  logoUrl: Scalars['String'];
  modifiedOn: Scalars['DateTime'];
  name: Scalars['String'];
  projects?: Maybe<Array<Project>>;
};

export type ClientInput = {
  clientId?: InputMaybe<Scalars['ID']>;
  industriesIds?: InputMaybe<Array<Scalars['ID']>>;
  logoUrl: Scalars['String'];
  name: Scalars['String'];
  projectsIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type ClientProjectFilters = {
  industriesIds?: InputMaybe<Array<Scalars['ID']>>;
  memberIds?: InputMaybe<Array<Scalars['ID']>>;
  moveInDateRange?: InputMaybe<MoveInDateRange>;
};

export type CollaboratorInformation = {
  /** Email of the user to invite */
  email: Scalars['String'];
  /** First name of the user to invite */
  firstName: Scalars['String'];
};

export type CreateCommentInput = {
  /** Comment */
  comment: Scalars['String'];
  /** ID of the project */
  projectId: Scalars['ID'];
  /** List of tagged people */
  tags?: InputMaybe<Array<TaskTagInput>>;
  /** ID of the parent task */
  taskId: Scalars['ID'];
};

export type CreateProjectsIndustryDetailsInput = {
  /** Experience level */
  experienceLevel?: InputMaybe<ExperienceLevelInput>;
  /** Id of Project Industry Details */
  id?: InputMaybe<Scalars['ID']>;
  /** Other administrative goals */
  otherAdministrativeGoals?: InputMaybe<OtherAdministrativeGoalsInput>;
  /** Other Business Goals */
  otherBusinessGoals?: InputMaybe<OtherBusinessGoalsInput>;
  /** Other clinical goals */
  otherClinicalGoals?: InputMaybe<OtherClinicalGoalsInput>;
  /** Other elements */
  otherElements?: InputMaybe<OtherElementsInput>;
  /** Other facility types */
  otherFacilityTypes?: InputMaybe<OtherFacilityTypesInput>;
  /** Other home type */
  otherHomeType?: InputMaybe<OtherHomeTypeInput>;
  /** Other spaces */
  otherSpaces?: InputMaybe<OtherSpacesInput>;
  /** Other workspace type */
  otherWorkspaceType?: InputMaybe<OtherWorkspaceTypeInput>;
  /** Project size */
  projectSize?: InputMaybe<ProjectSizeInput>;
  /** Visual preferences */
  visualPreferences?: InputMaybe<Array<VisualPreferencesInput>>;
};

export type CreateSectionInput = {
  /** name of the task */
  name: Scalars['String'];
  /** ID of the parent tasklist */
  tasklistId: Scalars['ID'];
};

export type CreateServicesInput = {
  projectId: Scalars['ID'];
  servicesList: Array<CreateServicesListInput>;
};

export type CreateServicesListInput = {
  highEstimate?: InputMaybe<Scalars['Int']>;
  lowEstimate?: InputMaybe<Scalars['Int']>;
  midEstimate?: InputMaybe<Scalars['Int']>;
  percentage?: InputMaybe<Scalars['Float']>;
  templateId: Scalars['ID'];
};

export type CreateSpaceItemTemplateInput = {
  categoryId: Scalars['ID'];
  highPrice?: InputMaybe<Scalars['Float']>;
  image?: InputMaybe<Scalars['String']>;
  lowPrice?: InputMaybe<Scalars['Float']>;
  midPrice?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
};

export type CreateSpaceTemplateInput = {
  description: Scalars['String'];
  image?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type CreateSpacesInput = {
  projectId: Scalars['ID'];
  spacesList: Array<CreateSpacesListInput>;
};

export type CreateSpacesListInput = {
  quantity: Scalars['Int'];
  templateId: Scalars['ID'];
};

export type CreateTaskInput = {
  /** ID of assigned user */
  assignedUserId?: InputMaybe<Scalars['ID']>;
  /** ID of user that completed task */
  completedByUserId?: InputMaybe<Scalars['ID']>;
  /** date the task was completed */
  completedDate?: InputMaybe<Scalars['DateTime']>;
  /** date the task is due */
  dueDate?: InputMaybe<Scalars['DateTime']>;
  /** task field data */
  fields?: InputMaybe<Array<TaskFieldInput>>;
  /** name of the task */
  name: Scalars['String'];
  /** id of the parent section */
  sectionId: Scalars['ID'];
  /** ID of the template task, if applicable */
  taskTemplateId?: InputMaybe<Scalars['ID']>;
};

export type CreateTasklistInput = {
  /** IDs (generated in account DB) of assigned users */
  assignedUserIds?: InputMaybe<Array<Scalars['ID']>>;
  /** ID of associated object - like project */
  associatedObjectId: Scalars['ID'];
  /** description of the tasklist */
  description?: InputMaybe<Scalars['String']>;
  /** date the tasklist is due */
  dueDate?: InputMaybe<Scalars['DateTime']>;
  /** whether the tasklist is visible */
  isVisible?: InputMaybe<Scalars['Boolean']>;
  /** name of the tasklist */
  name: Scalars['String'];
  /** ID of the template tasklist, if applicable */
  tasklistTemplateId?: InputMaybe<Scalars['ID']>;
};

export type CreateUserInput = {
  businessRole?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  securityRoles?: InputMaybe<Array<SecurityRole>>;
  status: Status;
};

export type DateField = {
  __typename?: 'DateField';
  /** input label displayed to users */
  label: Scalars['String'];
  /** internal key for answer value */
  name: Scalars['String'];
  type: Scalars['String'];
};

export type DeleteProjectMemberInput = {
  memberId: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type DenyProjectMemberInvitationInput = {
  projectId: Scalars['ID'];
};

export type DiscIncInput = {
  discountPercentage?: InputMaybe<Scalars['Float']>;
  increasePercentage?: InputMaybe<Scalars['Float']>;
  projectId: Scalars['ID'];
};

/** Display User */
export type DisplayUser = {
  __typename?: 'DisplayUser';
  avatarUrl?: Maybe<Scalars['String']>;
  businessRole?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
};

export type DisplayUserSchema = {
  __typename?: 'DisplayUserSchema';
  avatarUrl?: Maybe<Scalars['String']>;
  businessRole?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
};

export type ExperienceLevel = {
  __typename?: 'ExperienceLevel';
  /** Other value */
  other: Scalars['String'];
  /** Array of experience level */
  values: Array<ExperienceLevelEnum>;
};

/** industry values for experience level */
export enum ExperienceLevelEnum {
  IAmNewToTheProcess = 'I_Am_New_To_The_Process',
  IHaveDoneThisBefore = 'I_Have_Done_This_Before'
}

export type ExperienceLevelInput = {
  /** Other value */
  other: Scalars['String'];
  /** Array of experience level */
  values: Array<ExperienceLevelEnum>;
};

export type FieldOption = {
  __typename?: 'FieldOption';
  /** input label displayed to user for a single radio input option */
  label: Scalars['String'];
  /** internal value that will be recorded in an answer if this option is selected */
  value: Scalars['String'];
};

export type FieldOptionInput = {
  /** input label displayed to user for a single radio input option */
  label: Scalars['String'];
  /** internal value that will be recorded in an answer if this option is selected */
  value: Scalars['String'];
};

export type Industry = {
  __typename?: 'Industry';
  covers?: Maybe<Array<IndustryCover>>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type IndustryCover = {
  __typename?: 'IndustryCover';
  id: Scalars['ID'];
  url: Scalars['String'];
};

export type IndustryInput = {
  covers?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
};

export type InviteProjectCollaboratorsListInput = {
  projectId: Scalars['ID'];
  tenant?: InputMaybe<TenantsDetailsInput>;
  usersList: Array<ProjectCollaboratorInvite>;
};

export type InviteProjectMembersListInput = {
  membersList: Array<ProjectMemberInvite>;
  projectId: Scalars['ID'];
  tenant?: InputMaybe<TenantsDetailsInput>;
};

export type Item = {
  __typename?: 'Item';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ItemCategory = {
  __typename?: 'ItemCategory';
  createdOn: Scalars['DateTime'];
  id: Scalars['ID'];
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
};

export type ItemTemplate = {
  __typename?: 'ItemTemplate';
  category?: Maybe<ItemCategory>;
  createdOn: Scalars['DateTime'];
  highPrice: Scalars['Float'];
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  lowPrice: Scalars['Float'];
  midPrice: Scalars['Float'];
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  quantity: Scalars['Int'];
};

export type Member = {
  __typename?: 'Member';
  avatarUrl?: Maybe<Scalars['String']>;
  businessRole?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  role: ProjectRole;
  status: ProjectMemberStatusEnum;
};

export type MoveInDateRange = {
  end?: InputMaybe<Scalars['DateTime']>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvitation: Scalars['Boolean'];
  addRole: Scalars['Boolean'];
  addTaskComment: TaskComment;
  addTasklistToProject: Tasklist;
  adminUpdateUser: Scalars['Boolean'];
  archiveTasklist: Scalars['Boolean'];
  completeTasksInSection: Scalars['Boolean'];
  copySpace: Scalars['Boolean'];
  createClient: Client;
  createIndustry: Industry;
  createItemTemplate: Scalars['String'];
  createNotification: Notification;
  createProject: Project;
  createSection: Section;
  createServices: Array<Service>;
  createSpaceComment: SpaceComment;
  createSpaceTemplate: Scalars['String'];
  createSpaces: Array<Space>;
  createTask: Task;
  createTasklist: Tasklist;
  createUser: Scalars['String'];
  deleteClient: Scalars['Boolean'];
  deleteIndustry: Scalars['Boolean'];
  deleteItemTemplate: Scalars['Boolean'];
  deleteMember: Scalars['Boolean'];
  deleteNotification: Scalars['Boolean'];
  deleteProject: Scalars['Boolean'];
  deleteService: Scalars['Boolean'];
  deleteSpace: Scalars['Boolean'];
  deleteSpaceTemplate: Scalars['Boolean'];
  deleteTask: Scalars['Boolean'];
  deleteTasklist: Scalars['Boolean'];
  deleteUser: Scalars['Boolean'];
  denyInvitation: Scalars['Boolean'];
  inviteCollaborators: Scalars['Boolean'];
  inviteCollaboratorsToFolio: Scalars['Boolean'];
  inviteMembers: Scalars['Boolean'];
  inviteParticipantUser: Scalars['String'];
  inviteTheoremAdmin: Scalars['String'];
  inviteUser: Scalars['String'];
  pinProject: PinnedProject;
  removeRole: Scalars['Boolean'];
  resendInvitation: Scalars['Boolean'];
  resendInviteLink: Scalars['Boolean'];
  resendTheoremAdminInviteLink: Scalars['Boolean'];
  updateClient: Client;
  updateDiscIncValues: Project;
  updateIndustry: Industry;
  updateItemIndex: Scalars['Boolean'];
  updateItemTemplate: Scalars['Boolean'];
  updateMemberRole: Scalars['Boolean'];
  updateOtherSpaces: Project;
  updateProject: Project;
  updateProjectsStage: Project;
  updateService: Scalars['Boolean'];
  updateSpace: Scalars['Boolean'];
  updateSpaceList: Scalars['Boolean'];
  updateSpaceTemplate: Scalars['Boolean'];
  updateTask: Task;
  updateTasklist: Scalars['Boolean'];
  updateTenantInfo: TenantsDetails;
  updateUser: Scalars['Boolean'];
  upsertTaskAnswer: TaskAnswer;
};


export type MutationAcceptInvitationArgs = {
  input: AcceptProjectMemberInvitationInput;
};


export type MutationAddRoleArgs = {
  id: Scalars['ID'];
  role: SecurityRole;
};


export type MutationAddTaskCommentArgs = {
  input: CreateCommentInput;
};


export type MutationAddTasklistToProjectArgs = {
  projectId: Scalars['ID'];
  templateId: Scalars['ID'];
};


export type MutationAdminUpdateUserArgs = {
  id: Scalars['ID'];
  userInfo: AdminUpdateUserInput;
};


export type MutationArchiveTasklistArgs = {
  id: Scalars['ID'];
  projectId: Scalars['ID'];
};


export type MutationCompleteTasksInSectionArgs = {
  id: Scalars['ID'];
  projectId: Scalars['ID'];
};


export type MutationCopySpaceArgs = {
  id: Scalars['ID'];
};


export type MutationCreateClientArgs = {
  clientInfo: ClientInput;
};


export type MutationCreateIndustryArgs = {
  industryInfo: IndustryInput;
};


export type MutationCreateItemTemplateArgs = {
  input: CreateSpaceItemTemplateInput;
};


export type MutationCreateNotificationArgs = {
  input: NotificationInput;
};


export type MutationCreateProjectArgs = {
  input: ProjectInput;
};


export type MutationCreateSectionArgs = {
  input: CreateSectionInput;
  projectId: Scalars['ID'];
};


export type MutationCreateServicesArgs = {
  input: CreateServicesInput;
};


export type MutationCreateSpaceCommentArgs = {
  input: SpaceCommentInput;
};


export type MutationCreateSpaceTemplateArgs = {
  input: CreateSpaceTemplateInput;
};


export type MutationCreateSpacesArgs = {
  input: CreateSpacesInput;
};


export type MutationCreateTaskArgs = {
  input: CreateTaskInput;
  projectId: Scalars['ID'];
};


export type MutationCreateTasklistArgs = {
  input: CreateTasklistInput;
};


export type MutationCreateUserArgs = {
  userInfo: CreateUserInput;
};


export type MutationDeleteClientArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteIndustryArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteItemTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMemberArgs = {
  input: DeleteProjectMemberInput;
};


export type MutationDeleteNotificationArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProjectArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteServiceArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSpaceArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSpaceTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTaskArgs = {
  id: Scalars['ID'];
  projectId: Scalars['ID'];
};


export type MutationDeleteTasklistArgs = {
  id: Scalars['ID'];
  projectId: Scalars['ID'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID'];
};


export type MutationDenyInvitationArgs = {
  input: DenyProjectMemberInvitationInput;
};


export type MutationInviteCollaboratorsArgs = {
  input: InviteProjectCollaboratorsListInput;
};


export type MutationInviteCollaboratorsToFolioArgs = {
  collaborators: Array<CollaboratorInformation>;
  tenant?: InputMaybe<TenantDetailsInput>;
};


export type MutationInviteMembersArgs = {
  input: InviteProjectMembersListInput;
};


export type MutationInviteParticipantUserArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  isAdmin?: InputMaybe<Scalars['Boolean']>;
};


export type MutationInviteTheoremAdminArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
};


export type MutationInviteUserArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  securityRoles: Array<SecurityRole>;
};


export type MutationPinProjectArgs = {
  pinProjectInfo: PinProjectInput;
};


export type MutationRemoveRoleArgs = {
  id: Scalars['ID'];
  role: SecurityRole;
};


export type MutationResendInvitationArgs = {
  input: ResendProjectMemberInvitationInput;
};


export type MutationResendInviteLinkArgs = {
  email: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationResendTheoremAdminInviteLinkArgs = {
  email: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationUpdateClientArgs = {
  clientInfo: ClientInput;
  id: Scalars['ID'];
};


export type MutationUpdateDiscIncValuesArgs = {
  input: DiscIncInput;
};


export type MutationUpdateIndustryArgs = {
  id: Scalars['ID'];
  industryInfo: IndustryInput;
};


export type MutationUpdateItemIndexArgs = {
  input: Array<UpdateItemIndexInput>;
};


export type MutationUpdateItemTemplateArgs = {
  id: Scalars['ID'];
  input: CreateSpaceItemTemplateInput;
};


export type MutationUpdateMemberRoleArgs = {
  input: UpdateProjectMemberRoleInput;
};


export type MutationUpdateOtherSpacesArgs = {
  input: OtherSpacesInput;
  projectId: Scalars['ID'];
};


export type MutationUpdateProjectArgs = {
  id: Scalars['ID'];
  input: ProjectInput;
};


export type MutationUpdateProjectsStageArgs = {
  id: Scalars['ID'];
  input: ProjectStageInput;
};


export type MutationUpdateServiceArgs = {
  id: Scalars['ID'];
  input: UpdateServicesInput;
};


export type MutationUpdateSpaceArgs = {
  id: Scalars['ID'];
  input: UpdateSpaceInput;
};


export type MutationUpdateSpaceListArgs = {
  input: Array<UpdateSpaceListInput>;
};


export type MutationUpdateSpaceTemplateArgs = {
  id: Scalars['ID'];
  input: UpdateSpaceTemplateInput;
};


export type MutationUpdateTaskArgs = {
  input: UpdateTaskInput;
  projectId: Scalars['ID'];
};


export type MutationUpdateTasklistArgs = {
  input: UpdateTasklistInput;
  projectId: Scalars['ID'];
};


export type MutationUpdateTenantInfoArgs = {
  input: UpdateTenantInfoInput;
};


export type MutationUpdateUserArgs = {
  userInfo: UpdateUserInput;
};


export type MutationUpsertTaskAnswerArgs = {
  input: UpsertTaskAnswerInput;
  projectId: Scalars['ID'];
};

export type Notification = {
  __typename?: 'Notification';
  /** ID of the user who trigger the notification */
  fromUserId: Scalars['ID'];
  id: Scalars['ID'];
  /** ID of the Project */
  projectId: Scalars['ID'];
  /** ID of the Section */
  sectionId?: Maybe<Scalars['ID']>;
  /** ID of the Task Comment */
  taskCommentId?: Maybe<Scalars['ID']>;
  /** ID of the Task */
  taskId?: Maybe<Scalars['ID']>;
  /** ID of the Tasklist */
  tasklistId?: Maybe<Scalars['ID']>;
  /** ID of the user who received notification */
  toUserId: Scalars['ID'];
  type: NotificationsTypeEnum;
};

/** Notification Client */
export type NotificationClient = {
  __typename?: 'NotificationClient';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type NotificationDetail = {
  __typename?: 'NotificationDetail';
  /** Date notification was received */
  date: Scalars['DateTime'];
  /** User who trigger the notification */
  fromUser: DisplayUserSchema;
  id: Scalars['ID'];
  /** Notification Project Detail */
  project: NotificationProject;
  /** Notification Tasklist Detail */
  tasklist?: Maybe<NotificationTasklist>;
  /** ID of the user who received the notification */
  toUserId: Scalars['String'];
  type: NotificationsTypeEnum;
};

export type NotificationInput = {
  /** ID of the user who trigger the notification */
  fromUserId: Scalars['ID'];
  /** ID of the Project */
  projectId: Scalars['ID'];
  /** ID of the Section */
  sectionId?: InputMaybe<Scalars['ID']>;
  /** ID of the Task Comment */
  taskCommentId?: InputMaybe<Scalars['ID']>;
  /** ID of the Task */
  taskId?: InputMaybe<Scalars['ID']>;
  /** ID of the Tasklist */
  tasklistId?: InputMaybe<Scalars['ID']>;
  /** ID of the user who received notification */
  toUserId: Scalars['ID'];
  type: NotificationsTypeEnum;
};

export type NotificationProject = {
  __typename?: 'NotificationProject';
  client: NotificationClient;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type NotificationSection = {
  __typename?: 'NotificationSection';
  /** Id of the section */
  id?: Maybe<Scalars['ID']>;
  /** Notification Task Detail */
  task?: Maybe<NotificationTask>;
};

export type NotificationTask = {
  __typename?: 'NotificationTask';
  comment?: Maybe<NotificationTaskComment>;
  /** Date the task was completed */
  completedDate?: Maybe<Scalars['DateTime']>;
  /** Date the task is due */
  dueDate?: Maybe<Scalars['DateTime']>;
  /** Id of the task */
  id?: Maybe<Scalars['ID']>;
  /** Name of the task */
  name?: Maybe<Scalars['String']>;
};

export type NotificationTaskComment = {
  __typename?: 'NotificationTaskComment';
  /** Comment */
  comment?: Maybe<Scalars['String']>;
  /** Id of the Task Comment */
  id?: Maybe<Scalars['ID']>;
};

export type NotificationTasklist = {
  __typename?: 'NotificationTasklist';
  /** Description of the tasklist */
  description?: Maybe<Scalars['String']>;
  /** Date the tasklist is due */
  dueDate?: Maybe<Scalars['DateTime']>;
  /** Id of the tasklist */
  id?: Maybe<Scalars['ID']>;
  /** Name of the tasklist */
  name?: Maybe<Scalars['String']>;
  /** Notification Section Detail */
  section?: Maybe<NotificationSection>;
};

export enum NotificationsTypeEnum {
  AssignedToTask = 'AssignedToTask',
  AssignedToTaskList = 'AssignedToTaskList',
  InvitedToProject = 'InvitedToProject',
  MentionedInTask = 'MentionedInTask',
  UnassignedToTask = 'UnassignedToTask',
  UnassignedToTaskList = 'UnassignedToTaskList'
}

export type OtherAdministrativeGoals = {
  __typename?: 'OtherAdministrativeGoals';
  /** Other value */
  other: Scalars['String'];
  /** Array of other administrative goals */
  values: Array<OtherAdministrativeGoalsEnum>;
};

/** industry values for other administrative */
export enum OtherAdministrativeGoalsEnum {
  DoesNotApply = 'Does_Not_Apply',
  DrivingInnovation = 'Driving_Innovation',
  HealthAndSafetyInitiatives = 'Health_and_Safety_Initiatives',
  ImprovingCommunications = 'Improving_Communications',
  IncreasingProductivity = 'Increasing_Productivity',
  LeveragingNewTechnology = 'Leveraging_New_Technology',
  ManagingPatientExperience = 'Managing_Patient_Experience',
  ManagingADistributedWorkforce = 'Managing_a_Distributed_Workforce',
  NotSure = 'Not_Sure',
  Other = 'Other',
  ReducingRealEstateCost = 'Reducing_Real_Estate_Cost',
  RefreshingTheSpace = 'Refreshing_the_Space',
  RetainingStaff = 'Retaining_Staff',
  SocialImpact = 'Social_Impact'
}

export type OtherAdministrativeGoalsInput = {
  /** Other value */
  other: Scalars['String'];
  /** Array of other administrative goals */
  values: Array<OtherAdministrativeGoalsEnum>;
};

export type OtherBusinessGoals = {
  __typename?: 'OtherBusinessGoals';
  /** Other value */
  other: Scalars['String'];
  /** Array of industry other business goals values */
  values: Array<OtherBusinessGoalsEnum>;
};

/** industry values for other business goals */
export enum OtherBusinessGoalsEnum {
  AttractingFutureStudents = 'Attracting_Future_Students',
  DrivingAgencyCulture = 'Driving_Agency_Culture',
  DrivingCulture = 'Driving_Culture',
  DrivingInnovation = 'Driving_Innovation',
  EnhancingFacultyOrStudentExperience = 'Enhancing_Faculty_Or_Student_Experience',
  FosteringStudentCollaboration = 'Fostering_Student_Collaboration',
  HealthAndSafetyInitiatives = 'Health_And_Safety_Initiatives',
  ImprovingCommunications = 'Improving_Communications',
  IncreasingProductivity = 'Increasing_Productivity',
  LeveragingNewTechnology = 'Leveraging_New_Technology',
  ManagingADistributedAgencyWorkforce = 'Managing_A_Distributed_Agency_Workforce',
  ManagingADistributedWorkforce = 'Managing_A_Distributed_Workforce',
  ManagingAShiftInAgencyFocus = 'Managing_A_Shift_In_Agency_Focus',
  ManagingAShiftInBusiness = 'Managing_A_Shift_In_Business',
  ManagingHybridLearning = 'Managing_Hybrid_Learning',
  NotSure = 'Not_Sure',
  Other = 'Other',
  PreparingStudentsForEmployment = 'Preparing_Students_For_Employment',
  ReducingRealEstateCost = 'Reducing_Real_Estate_Cost',
  ResearchInitiatives = 'Research_Initiatives',
  RetainingEmployees = 'Retaining_Employees',
  RetainingStudents = 'Retaining_Students',
  SecuringNewStudents = 'Securing_New_Students',
  SocialImpact = 'Social_Impact',
  StudentWellnessAndPersonalGrowth = 'Student_Wellness_And_Personal_Growth',
  TargetingNewAgencyEnvironments = 'Targeting_New_Agency_Environments',
  TargetingNewBusinessSegment = 'Targeting_New_Business_Segment'
}

export type OtherBusinessGoalsInput = {
  /** Other value */
  other: Scalars['String'];
  /** Array of industry other business goals values */
  values: Array<OtherBusinessGoalsEnum>;
};

export type OtherClinicalGoals = {
  __typename?: 'OtherClinicalGoals';
  /** Other value */
  other: Scalars['String'];
  /** Array of other clinical goals */
  values: Array<OtherClinicalGoalsEnum>;
};

/** industry values for other clinical goals */
export enum OtherClinicalGoalsEnum {
  DoesNotApply = 'Does_Not_Apply',
  DrivingInnovation = 'Driving_Innovation',
  ExpandingIntoRegionalCommunities = 'Expanding_Into_Regional_Communities',
  ExpandingTreatmentOfferings = 'Expanding_Treatment_Offerings',
  HealthAndSafetyInitiatives = 'Health_and_Safety_Initiatives',
  ImprovingCommunications = 'Improving_Communications',
  IncreasingCaregiverSupport = 'Increasing_Caregiver_Support',
  LeveragingNewTechnology = 'Leveraging_New_Technology',
  ManagingAShiftInCare = 'Managing_A_Shift_In_Care',
  ManagingPatientExperienceAndFlow = 'Managing_Patient_Experience_and_Flow',
  NotSure = 'Not_Sure',
  Other = 'Other',
  ReducingRealEstateCost = 'Reducing_Real_Estate_Cost',
  RefreshingTheSpace = 'Refreshing_the_Space',
  SocialImpact = 'Social_Impact',
  Telemedicine = 'Telemedicine'
}

export type OtherClinicalGoalsInput = {
  /** Other value */
  other: Scalars['String'];
  /** Array of other clinical goals */
  values: Array<OtherClinicalGoalsEnum>;
};

export type OtherElements = {
  __typename?: 'OtherElements';
  /** Other value */
  other: Scalars['String'];
  /** Array of other elements */
  values: Array<OtherElementsEnum>;
};

/** industry values for other elements */
export enum OtherElementsEnum {
  CommunicationTools = 'Communication_Tools',
  DecorativeSeating = 'Decorative_Seating',
  DesktopPower = 'Desktop_Power',
  EnhancedLighting = 'Enhanced_Lighting',
  ErgonomicTools = 'Ergonomic_Tools',
  GreatTaskSeating = 'Great_Task_Seating',
  HeightAdjustability = 'Height_Adjustability',
  OrganizationalTools = 'Organizational_Tools',
  Other = 'Other',
  PlantsAndBiophilia = 'Plants_and_Biophilia',
  RugsAndAccessories = 'Rugs_and_Accessories',
  SpaceDivision = 'Space_Division',
  StorageAndShelving = 'Storage_and_Shelving'
}

export type OtherElementsInput = {
  /** Other value */
  other: Scalars['String'];
  /** Array of other elements */
  values: Array<OtherElementsEnum>;
};

export type OtherFacilityTypes = {
  __typename?: 'OtherFacilityTypes';
  /** Other value */
  other: Scalars['String'];
  /** Array of other facility types */
  values: Array<OtherFacilityTypesEnum>;
};

/** industry values for other facility types */
export enum OtherFacilityTypesEnum {
  AdministrativeBuilding = 'Administrative_Building',
  Clinic = 'Clinic',
  Hospital = 'Hospital',
  MedicalOfficeBuilding = 'Medical_Office_Building'
}

export type OtherFacilityTypesInput = {
  /** Other value */
  other: Scalars['String'];
  /** Array of other facility types */
  values: Array<OtherFacilityTypesEnum>;
};

export type OtherHomeType = {
  __typename?: 'OtherHomeType';
  /** Other value */
  other: Scalars['String'];
  /** Array of other home type */
  values: Array<OtherHomeTypeEnum>;
};

/** industry values for other home type */
export enum OtherHomeTypeEnum {
  Apartment = 'Apartment',
  CondoOrTownhome = 'Condo_or_Townhome',
  House = 'House',
  LoftOrStudio = 'Loft_or_Studio',
  Other = 'Other'
}

export type OtherHomeTypeInput = {
  /** Other value */
  other: Scalars['String'];
  /** Array of other home type */
  values: Array<OtherHomeTypeEnum>;
};

export type OtherSpaces = {
  __typename?: 'OtherSpaces';
  /** Other value */
  other: Scalars['String'];
  /** Array of spaces with their corresponding amount */
  quantValues: Array<QuantValuesSchema>;
  /** Array of quantites associated with values at corresponding index */
  quantities: Array<Scalars['Float']>;
  /** Array of other spaces values */
  values: Array<OtherSpacesEnum>;
};

/** industry values for other spaces */
export enum OtherSpacesEnum {
  AdministrativeStations = 'Administrative_Stations',
  Athletic = 'Athletic',
  BehavioralHealth = 'Behavioral_Health',
  Benching = 'Benching',
  CafeAndBreakroom = 'Cafe_and_Breakroom',
  CheckInAndCheckOut = 'Check_In_and_Check_Out',
  Classrooms = 'Classrooms',
  Conference = 'Conference',
  Consultation = 'Consultation',
  ExamRooms = 'Exam_Rooms',
  FilingAndStorage = 'Filing_and_Storage',
  HuddleAndPhone = 'Huddle_and_Phone',
  Labs = 'Labs',
  LearningCollaborative = 'Learning_Collaborative',
  Library = 'Library',
  LobbyAndReception = 'Lobby_and_Reception',
  LobbyAndWaiting = 'Lobby_and_Waiting',
  LoungeAndBreakout = 'Lounge_and_Breakout',
  NurseStations = 'Nurse_Stations',
  OpenOffice = 'Open_Office',
  Other = 'Other',
  Outdoor = 'Outdoor',
  PatientRooms = 'Patient_Rooms',
  PhysicianOffices = 'Physician_Offices',
  PrivateOffice = 'Private_Office',
  RadiologyReadingRoom = 'Radiology_Reading_Room',
  StudentHousing = 'Student_Housing',
  Telemedicine = 'Telemedicine',
  TestingStations = 'Testing_Stations',
  Training = 'Training',
  Treatment = 'Treatment',
  WellnessAndSpecialty = 'Wellness_and_Specialty',
  WorkFromHome = 'Work_From_Home'
}

export type OtherSpacesInput = {
  /** Other value */
  other: Scalars['String'];
  /** Array of spaces with their corresponding amount */
  quantValues: Array<QuantValueSchemaInput>;
  /** Array of quantites associated with values at corresponding index */
  quantities: Array<Scalars['Float']>;
  /** Array of other spaces values */
  values: Array<OtherSpacesEnum>;
};

export type OtherWorkspaceType = {
  __typename?: 'OtherWorkspaceType';
  /** Other value */
  other: Scalars['String'];
  /** Array of other workspace type */
  values: Array<OtherWorkspaceTypeEnum>;
};

/** industry values for other workspace type */
export enum OtherWorkspaceTypeEnum {
  DedicatedClosedDoorRoom = 'Dedicated_Closed_Door_Room',
  NonDeskSetup = 'Non_Desk_Setup',
  OpenAreaWithDesignatedDesk = 'Open_Area_with_Designated_Desk',
  Other = 'Other'
}

export type OtherWorkspaceTypeInput = {
  /** Other value */
  other: Scalars['String'];
  /** Array of other workspace type */
  values: Array<OtherWorkspaceTypeEnum>;
};

export type PinProjectInput = {
  isPinned: Scalars['Boolean'];
  projectId: Scalars['ID'];
};

export type PinnedProject = {
  __typename?: 'PinnedProject';
  isPinned: Scalars['Boolean'];
  project: Project;
  userId: Scalars['ID'];
};

export type Project = {
  __typename?: 'Project';
  assignedTasklistsCount?: Maybe<Scalars['Int']>;
  budget: Scalars['Float'];
  buildingsQty: Scalars['Int'];
  client: Client;
  companyName?: Maybe<Scalars['String']>;
  coverImageUrl: Scalars['String'];
  createdOn: Scalars['DateTime'];
  datePinned?: Maybe<Scalars['DateTime']>;
  discountPercentage?: Maybe<Scalars['Float']>;
  headCount: Scalars['Float'];
  id: Scalars['ID'];
  increasePercentage?: Maybe<Scalars['Float']>;
  industry: Industry;
  industryDetails?: Maybe<ProjectIndustryDetails>;
  isPinned: Scalars['Boolean'];
  members: Array<Member>;
  modifiedOn: Scalars['DateTime'];
  moveInDate?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  notifications?: Maybe<Array<Notification>>;
  projectEstimate?: Maybe<ProjectEstimate>;
  spaces?: Maybe<Array<Space>>;
  squareFootage: Scalars['Float'];
  stage: Scalars['String'];
};

export type ProjectCollaboratorInvite = {
  email: Scalars['ID'];
  firstName: Scalars['ID'];
  roleId: Scalars['ID'];
};

export type ProjectEstimate = {
  __typename?: 'ProjectEstimate';
  antiPricePercentHigh: Scalars['Float'];
  antiPricePercentLow: Scalars['Float'];
  antiPricePercentMid: Scalars['Float'];
  freightPercentHigh: Scalars['Float'];
  freightPercentLow: Scalars['Float'];
  freightPercentMid: Scalars['Float'];
  highPrice: Scalars['Float'];
  highServiceEstimate: Scalars['Float'];
  installPercentHigh: Scalars['Float'];
  installPercentLow: Scalars['Float'];
  installPercentMid: Scalars['Float'];
  lowPrice: Scalars['Float'];
  lowServiceEstimate: Scalars['Float'];
  midPrice: Scalars['Float'];
  midServiceEstimate: Scalars['Float'];
  productTaxPercentHigh: Scalars['Float'];
  productTaxPercentLow: Scalars['Float'];
  productTaxPercentMid: Scalars['Float'];
  serviceTaxPercentHigh: Scalars['Float'];
  serviceTaxPercentLow: Scalars['Float'];
  serviceTaxPercentMid: Scalars['Float'];
  totalTaxPercentHigh: Scalars['Float'];
  totalTaxPercentLow: Scalars['Float'];
  totalTaxPercentMid: Scalars['Float'];
};

export type ProjectIndustryDetails = {
  __typename?: 'ProjectIndustryDetails';
  /** Experience level */
  experienceLevel?: Maybe<ExperienceLevel>;
  id: Scalars['ID'];
  /** Other administrative goals */
  otherAdministrativeGoals?: Maybe<OtherAdministrativeGoals>;
  /** Other business goals */
  otherBusinessGoals?: Maybe<OtherBusinessGoals>;
  /** Other clinical goals */
  otherClinicalGoals?: Maybe<OtherClinicalGoals>;
  /** Other workspace type */
  otherElements?: Maybe<OtherElements>;
  /** Other spaces */
  otherFacilityTypes?: Maybe<OtherFacilityTypes>;
  /** Other home type */
  otherHomeType?: Maybe<OtherHomeType>;
  /** Other spaces */
  otherSpaces?: Maybe<OtherSpaces>;
  /** Other workspace type */
  otherWorkspaceType?: Maybe<OtherWorkspaceType>;
  /** Project size */
  projectSize?: Maybe<ProjectSize>;
  /** Visual preferences */
  visualPreferences?: Maybe<Array<VisualPreferences>>;
};

export type ProjectInput = {
  budget: Scalars['Float'];
  buildingsQty: Scalars['Int'];
  clientId: Scalars['ID'];
  companyName?: InputMaybe<Scalars['String']>;
  coverImageUrl: Scalars['String'];
  discountPercentage?: InputMaybe<Scalars['Float']>;
  headCount: Scalars['Float'];
  increasePercentage?: InputMaybe<Scalars['Float']>;
  industryDetails?: InputMaybe<CreateProjectsIndustryDetailsInput>;
  industryId: Scalars['ID'];
  members?: InputMaybe<Array<Scalars['ID']>>;
  moveInDate?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
  squareFootage: Scalars['Float'];
  stage?: InputMaybe<Scalars['String']>;
};

export type ProjectMemberInvite = {
  roleId: Scalars['ID'];
  userId: Scalars['ID'];
};

export enum ProjectMemberStatusEnum {
  Accepted = 'Accepted',
  Denied = 'Denied',
  Pending = 'Pending'
}

export type ProjectRole = {
  __typename?: 'ProjectRole';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ProjectSize = {
  __typename?: 'ProjectSize';
  /** Other value */
  other: Scalars['String'];
  /** Array of project size */
  values: Array<ProjectSizeEnum>;
};

/** industry values for project size */
export enum ProjectSizeEnum {
  '1To_25People' = '_1_to_25_People',
  '26To_100People' = '_26_to_100_People',
  '101To_250People' = '_101_to_250_People',
  '251To_500People' = '_251_to_500_People',
  '500OrMorePeople' = '_500_or_more_People'
}

export type ProjectSizeInput = {
  /** Other value */
  other: Scalars['String'];
  /** Array of project size */
  values: Array<ProjectSizeEnum>;
};

export type ProjectStageInput = {
  stage: Scalars['String'];
};

export type ProjectsClientsSearchResults = {
  __typename?: 'ProjectsClientsSearchResults';
  clients?: Maybe<Array<Item>>;
  projects?: Maybe<Array<Item>>;
};

export type QuantValueSchemaInput = {
  /** Number of spaces */
  amount: Scalars['Float'];
  /** Quantified other value */
  other: Scalars['String'];
  values: OtherSpacesEnum;
};

export type QuantValuesSchema = {
  __typename?: 'QuantValuesSchema';
  /** Number of spaces */
  amount: Scalars['Float'];
  /** Quantified other value */
  other: Scalars['String'];
  values: OtherSpacesEnum;
};

export type Query = {
  __typename?: 'Query';
  currentUser: User;
  getAllItemTemplates: Array<ItemTemplate>;
  getAllSpaceTemplates: Array<SpaceTemplate>;
  getClient: Client;
  getCommentsBySpaceId: Array<SpaceComment>;
  getDisplayUser: DisplayUser;
  getDisplayUsersByUserIds: Array<DisplayUser>;
  getIndustry: Industry;
  getItemTemplateById: ItemTemplate;
  getItemTemplateCategories: Array<ItemCategory>;
  getNotifications: Array<NotificationDetail>;
  getProject: Project;
  getProjectEstimates: ProjectEstimate;
  getSpaceById: SpaceTemplate;
  getTaskComments: Array<TaskComment>;
  getTenantInfoByCode: TenantsDetails;
  getTenantsInfo: Array<TenantsDetails>;
  getTheoremUsers: Array<User>;
  getUser: User;
  getUsers: Array<User>;
  getUsersByUserIds: Array<User>;
  getUsersForProjectInvite: Array<User>;
  listClients: Array<Client>;
  listFolioClients: Array<Client>;
  listIndustries: Array<Industry>;
  listMemberClients: Array<Client>;
  listMembers: Array<Member>;
  listProjectServices: Array<Service>;
  listProjectSpaces: Array<Space>;
  listProjects: Array<Project>;
  listProjectsRoles: Array<ProjectRole>;
  listServicesTemplates: Array<ServiceTemplate>;
  listSpacesItemTemplates: Array<SpacesItemTemplate>;
  listSpacesTemplates: Array<SpaceTemplate>;
  listTemplateIndustries: Array<Industry>;
  listUsersForProjectInvite: Array<UserSchema>;
  predefinedTasklists: Array<TasklistTemplateListItem>;
  searchProjectsClients: ProjectsClientsSearchResults;
  sendParticipantProjectInvite: Scalars['Boolean'];
  sendWelcomeToFolioEmail: Scalars['Boolean'];
  tasklistsForProject: Array<Tasklist>;
  viewProjectCount: Scalars['Int'];
  viewProjectInvitations: Array<Member>;
  viewUserInvitations: Array<Project>;
};


export type QueryGetClientArgs = {
  id: Scalars['ID'];
};


export type QueryGetCommentsBySpaceIdArgs = {
  id: Scalars['String'];
};


export type QueryGetDisplayUserArgs = {
  id: Scalars['ID'];
};


export type QueryGetDisplayUsersByUserIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetIndustryArgs = {
  id: Scalars['ID'];
};


export type QueryGetItemTemplateByIdArgs = {
  templateId: Scalars['ID'];
};


export type QueryGetProjectArgs = {
  id: Scalars['ID'];
};


export type QueryGetProjectEstimatesArgs = {
  id: Scalars['ID'];
};


export type QueryGetSpaceByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetTaskCommentsArgs = {
  projectId: Scalars['ID'];
  taskId: Scalars['ID'];
};


export type QueryGetUserArgs = {
  id: Scalars['ID'];
};


export type QueryGetUsersByUserIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryListClientsArgs = {
  filters?: InputMaybe<ClientProjectFilters>;
};


export type QueryListMemberClientsArgs = {
  filters?: InputMaybe<ClientProjectFilters>;
};


export type QueryListMembersArgs = {
  projectId: Scalars['ID'];
};


export type QueryListProjectServicesArgs = {
  id: Scalars['ID'];
};


export type QueryListProjectSpacesArgs = {
  id: Scalars['ID'];
};


export type QueryListUsersForProjectInviteArgs = {
  projectId: Scalars['ID'];
};


export type QueryPredefinedTasklistsArgs = {
  projectId: Scalars['ID'];
};


export type QuerySearchProjectsClientsArgs = {
  fragment: Scalars['String'];
};


export type QuerySendParticipantProjectInviteArgs = {
  projectId: Scalars['String'];
  projectName: Scalars['String'];
  tenant?: InputMaybe<TenantDetailsInput>;
  userId: Scalars['String'];
};


export type QuerySendWelcomeToFolioEmailArgs = {
  projectId: Scalars['String'];
  userId: Scalars['String'];
};


export type QueryTasklistsForProjectArgs = {
  projectId: Scalars['ID'];
};


export type QueryViewProjectInvitationsArgs = {
  projectId: Scalars['ID'];
};

export type RadioField = {
  __typename?: 'RadioField';
  /** internal key for answer value */
  name: Scalars['String'];
  options: Array<FieldOption>;
  type: Scalars['String'];
};

export type ResendProjectMemberInvitationInput = {
  projectId: Scalars['ID'];
  tenant?: InputMaybe<TenantsDetailsInput>;
  userId: Scalars['ID'];
};

export type Section = {
  __typename?: 'Section';
  createUser: DisplayUserSchema;
  createdBy: Scalars['ID'];
  createdOn: Scalars['DateTime'];
  /** id of the section */
  id: Scalars['ID'];
  modifiedBy?: Maybe<Scalars['ID']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  modifyUser?: Maybe<DisplayUserSchema>;
  /** name of the section */
  name: Scalars['String'];
  tasklist: Tasklist;
  /** ID of the parent tasklist */
  tasklistId: Scalars['ID'];
  tasks: Array<Task>;
};

export enum SecurityRole {
  Admin = 'Admin',
  Member = 'Member',
  Participant = 'Participant',
  TheoremAdmin = 'TheoremAdmin'
}

export enum SecurityRoleEnum {
  Admin = 'Admin',
  Member = 'Member',
  Participant = 'Participant',
  TheoremAdmin = 'TheoremAdmin'
}

export type Service = {
  __typename?: 'Service';
  createdOn: Scalars['DateTime'];
  highEstimate: Scalars['Float'];
  id: Scalars['ID'];
  lowEstimate: Scalars['Float'];
  midEstimate: Scalars['Float'];
  modifiedOn: Scalars['DateTime'];
  percentage: Scalars['Float'];
  servicesTemplates: ServiceTemplate;
};

export type ServiceTemplate = {
  __typename?: 'ServiceTemplate';
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  serviceId: Scalars['String'];
};

export type Space = {
  __typename?: 'Space';
  createdOn: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  industry?: Maybe<Industry>;
  items?: Maybe<Array<SpaceItem>>;
  list?: Maybe<SpaceList>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  quantity: Scalars['Int'];
  templateId?: Maybe<Scalars['String']>;
};

export type SpaceComment = {
  __typename?: 'SpaceComment';
  comment: Scalars['String'];
  createdOn: Scalars['DateTime'];
  /** id of the comment */
  id: Scalars['ID'];
  /** id of the parent space */
  spaceId: Scalars['ID'];
  userFirstName: Scalars['String'];
  userLastName: Scalars['String'];
};

export type SpaceCommentInput = {
  /** Comment */
  comment: Scalars['String'];
  /** ID of the space */
  spaceId: Scalars['ID'];
};

export type SpaceItem = {
  __typename?: 'SpaceItem';
  category: ItemCategory;
  createdOn: Scalars['DateTime'];
  dragDropIndex?: Maybe<Scalars['Float']>;
  highPrice: Scalars['Float'];
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  itemTemplatesId?: Maybe<Scalars['ID']>;
  lowPrice: Scalars['Float'];
  midPrice: Scalars['Float'];
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  quantity: Scalars['Int'];
};

export type SpaceItemInput = {
  discountPercentage?: InputMaybe<Scalars['Float']>;
  highPrice?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
  increasePercentage?: InputMaybe<Scalars['Float']>;
  itemTemplatesId?: InputMaybe<Scalars['ID']>;
  lowPrice?: InputMaybe<Scalars['Float']>;
  midPrice?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  quantity: Scalars['Int'];
};

export type SpaceList = {
  __typename?: 'SpaceList';
  /** Index inside DnD column */
  index: Scalars['Float'];
  /** List value equal to either one or two */
  listNumber: Scalars['Float'];
};

export type SpaceListInput = {
  /** Index inside DnD column */
  index: Scalars['Float'];
  /** List value equal to either one or two */
  listNumber: Scalars['Float'];
};

export type SpaceTemplate = {
  __typename?: 'SpaceTemplate';
  createdOn: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  industry?: Maybe<Industry>;
  items: Array<ItemTemplate>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  spaceId: Scalars['String'];
};

export type SpaceTemplateItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  quantity: Scalars['Int'];
};

export type SpacesItemTemplate = {
  __typename?: 'SpacesItemTemplate';
  itemTemplate: ItemTemplate;
  itemsQuantity: Scalars['Int'];
  spacesTemplate: SpaceTemplate;
};

export enum Status {
  Active = 'Active',
  Inactive = 'Inactive',
  Pending = 'Pending'
}

export enum StatusEnum {
  Active = 'Active',
  Inactive = 'Inactive',
  Pending = 'Pending'
}

export type Task = {
  __typename?: 'Task';
  assignedUser?: Maybe<DisplayUserSchema>;
  /** ID of associated user */
  assignedUserId?: Maybe<Scalars['ID']>;
  comments?: Maybe<Array<TaskComment>>;
  completedByUser?: Maybe<DisplayUserSchema>;
  /** ID of user that completed task */
  completedByUserId?: Maybe<Scalars['ID']>;
  /** date the task was completed */
  completedDate?: Maybe<Scalars['DateTime']>;
  createUser: DisplayUserSchema;
  createdBy: Scalars['ID'];
  createdOn: Scalars['DateTime'];
  /** date the task is due */
  dueDate?: Maybe<Scalars['DateTime']>;
  /** task field data */
  fields?: Maybe<Array<TaskField>>;
  /** id of the task */
  id: Scalars['ID'];
  modifiedBy?: Maybe<Scalars['ID']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  modifyUser?: Maybe<DisplayUserSchema>;
  /** name of the task */
  name: Scalars['String'];
  numComments: Scalars['Int'];
  section: Section;
  /** ID of the parent section */
  sectionId: Scalars['ID'];
  taskAnswer?: Maybe<TaskAnswer>;
  /** ID of the template task, if applicable */
  taskTemplateId?: Maybe<Scalars['ID']>;
};

export type TaskAnswer = {
  __typename?: 'TaskAnswer';
  createUser: DisplayUserSchema;
  createdBy: Scalars['ID'];
  createdOn: Scalars['DateTime'];
  /** id of the taskAnswer */
  id: Scalars['ID'];
  modifiedBy?: Maybe<Scalars['ID']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  modifyUser?: Maybe<DisplayUserSchema>;
  task: Task;
  /** ID of the parent task */
  taskId: Scalars['ID'];
  /** key and value (value contains answer) */
  values: Scalars['JSONObject'];
};

export type TaskComment = {
  __typename?: 'TaskComment';
  comment: Scalars['String'];
  createUser: DisplayUserSchema;
  createdBy: Scalars['ID'];
  createdOn: Scalars['DateTime'];
  /** id of the task */
  id: Scalars['ID'];
  modifiedBy?: Maybe<Scalars['ID']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  modifyUser?: Maybe<DisplayUserSchema>;
  /** List of tagged people */
  tags?: Maybe<Array<TaskTag>>;
  task: Task;
  /** ID of the parent task */
  taskId: Scalars['ID'];
};

export type TaskField = AreaField | CheckboxField | DateField | RadioField | TextField;

export type TaskFieldInput = {
  /** input label displayed to usrs */
  label?: InputMaybe<Scalars['String']>;
  /** internal key for answer value */
  name: Scalars['String'];
  options?: InputMaybe<Array<FieldOptionInput>>;
  type: TaskFieldInputDiscriminator;
};

export enum TaskFieldInputDiscriminator {
  Area = 'area',
  Checkbox = 'checkbox',
  Date = 'date',
  Radio = 'radio',
  Text = 'text'
}

export type TaskTag = {
  __typename?: 'TaskTag';
  /** Tagged display user */
  display: Scalars['String'];
  /** ID of the user who were tagged */
  userId: Scalars['String'];
};

export type TaskTagInput = {
  /** Tagged display user */
  display: Scalars['String'];
  /** ID of the user who were tagged */
  userId: Scalars['String'];
};

export type Tasklist = {
  __typename?: 'Tasklist';
  /** ID of associated object (like project) */
  associatedObjectId?: Maybe<Scalars['ID']>;
  createUser: DisplayUserSchema;
  createdBy: Scalars['ID'];
  createdOn: Scalars['DateTime'];
  /** description of the tasklist */
  description?: Maybe<Scalars['String']>;
  /** date the task is due */
  dueDate?: Maybe<Scalars['DateTime']>;
  /** id of the tasklist */
  id: Scalars['ID'];
  /** whether the tasklist has been archived by user */
  isArchived: Scalars['Boolean'];
  /** whether the tasklist is visible */
  isVisible: Scalars['Boolean'];
  isVisibleChangedOn?: Maybe<Scalars['DateTime']>;
  modifiedBy?: Maybe<Scalars['ID']>;
  modifiedOn: Scalars['DateTime'];
  modifyUser?: Maybe<DisplayUserSchema>;
  /** name of the tasklist */
  name: Scalars['String'];
  sections: Array<Section>;
  /** ID of the template tasklist, if applicable */
  tasklistTemplateId?: Maybe<Scalars['ID']>;
  /** users assigned to the tasklist */
  tasklistUsers?: Maybe<Array<TasklistUser>>;
};

export type TasklistTemplateListItem = {
  __typename?: 'TasklistTemplateListItem';
  createdOn: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  modifiedOn: Scalars['DateTime'];
  name: Scalars['String'];
  tasklistTemplateId: Scalars['ID'];
};

export type TasklistUser = {
  __typename?: 'TasklistUser';
  avatarUrl?: Maybe<Scalars['String']>;
  businessRole?: Maybe<Scalars['String']>;
  createUser: DisplayUserSchema;
  createdBy: Scalars['ID'];
  createdOn: Scalars['DateTime'];
  firstName?: Maybe<Scalars['String']>;
  /** id of the user */
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['ID']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  modifyUser?: Maybe<DisplayUserSchema>;
  /** tasklist the user is assigned to */
  tasklists: Array<Tasklist>;
  /** ID of assigned user */
  userId: Scalars['ID'];
};

export type TenantDetailsInput = {
  /** Tenant Code */
  code: Scalars['String'];
  /** Tenant Email */
  email?: InputMaybe<Scalars['String']>;
  /** Tenant ID */
  id: Scalars['ID'];
  /** Licenses */
  licenses: Scalars['Int'];
  /** Name */
  tenantName?: InputMaybe<Scalars['String']>;
  /** Used Licenses */
  used?: InputMaybe<Scalars['Int']>;
};

export type TenantsDetails = {
  __typename?: 'TenantsDetails';
  code: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  licenses: Scalars['Int'];
  tenantName?: Maybe<Scalars['String']>;
  used?: Maybe<Scalars['Int']>;
};

export type TenantsDetailsInput = {
  code: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  licenses: Scalars['Int'];
  tenantName?: InputMaybe<Scalars['String']>;
  used?: InputMaybe<Scalars['Int']>;
};

export type TextField = {
  __typename?: 'TextField';
  /** input label displayed to users */
  label: Scalars['String'];
  /** internal key for answer value */
  name: Scalars['String'];
  type: Scalars['String'];
};

export type UpdateItemIndexInput = {
  id: Scalars['String'];
  index: Scalars['Float'];
};

export type UpdateProjectMemberRoleInput = {
  memberId: Scalars['ID'];
  projectId: Scalars['ID'];
  roleId: Scalars['ID'];
};

export type UpdateServicesInput = {
  highEstimate: Scalars['Int'];
  lowEstimate: Scalars['Int'];
  midEstimate: Scalars['Int'];
  percentage: Scalars['Float'];
  serviceId: Scalars['ID'];
};

export type UpdateSpaceInput = {
  description: Scalars['String'];
  discountPercentage?: InputMaybe<Scalars['Float']>;
  image: Scalars['String'];
  increasePercentage?: InputMaybe<Scalars['Float']>;
  items?: InputMaybe<Array<SpaceItemInput>>;
  name: Scalars['String'];
  quantity: Scalars['Int'];
};

export type UpdateSpaceListInput = {
  id: Scalars['String'];
  list?: InputMaybe<SpaceListInput>;
};

export type UpdateSpaceTemplateInput = {
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  industryId?: InputMaybe<Scalars['ID']>;
  items?: InputMaybe<Array<SpaceTemplateItemInput>>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateTaskInput = {
  /** ID of assigned user */
  assignedUserId?: InputMaybe<Scalars['ID']>;
  /** ID of user that completed task */
  completedByUserId?: InputMaybe<Scalars['ID']>;
  /** date the task was completed */
  completedDate?: InputMaybe<Scalars['DateTime']>;
  /** date the task is due */
  dueDate?: InputMaybe<Scalars['DateTime']>;
  /** task field data */
  fields?: InputMaybe<Array<TaskFieldInput>>;
  /** id of the task */
  id: Scalars['ID'];
  /** name of the task */
  name?: InputMaybe<Scalars['String']>;
  /** id of the parent section */
  sectionId?: InputMaybe<Scalars['ID']>;
  /** ID of the template task, if applicable */
  taskTemplateId?: InputMaybe<Scalars['ID']>;
};

export type UpdateTasklistInput = {
  /** IDs (generated in account DB) of assigned users */
  assignedUserIds?: InputMaybe<Array<Scalars['ID']>>;
  /** ID of associated object - like project */
  associatedObjectId?: InputMaybe<Scalars['ID']>;
  /** description of the tasklist */
  description?: InputMaybe<Scalars['String']>;
  /** date the tasklist is due */
  dueDate?: InputMaybe<Scalars['DateTime']>;
  /** id of the tasklist */
  id: Scalars['ID'];
  /** whether the tasklist is visible */
  isVisible?: InputMaybe<Scalars['Boolean']>;
  /** name of the tasklist */
  name?: InputMaybe<Scalars['String']>;
  /** IDs ((generated in account DB) of removed users */
  removedUserIds?: InputMaybe<Array<Scalars['ID']>>;
  /** ID of the template tasklist, if applicable */
  tasklistTemplateId?: InputMaybe<Scalars['ID']>;
};

export type UpdateTenantInfoInput = {
  email: Scalars['String'];
  id: Scalars['ID'];
  licenses: Scalars['Int'];
  name: Scalars['String'];
};

export type UpdateUserInput = {
  avatarUrl?: InputMaybe<Scalars['String']>;
  businessRole: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
};

export type UpsertTaskAnswerInput = {
  /** id of the parent task */
  taskId: Scalars['ID'];
  /** answer to task field data */
  values: Scalars['JSONObject'];
};

/** users */
export type User = {
  __typename?: 'User';
  avatarUrl?: Maybe<Scalars['String']>;
  businessRole?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isTheoremAdmin?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  securityRoles: Array<SecurityRole>;
  status: Status;
};

export type UserSchema = {
  __typename?: 'UserSchema';
  avatarUrl?: Maybe<Scalars['String']>;
  businessRole?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isTheoremAdmin?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  securityRoles: Array<SecurityRoleEnum>;
  status: StatusEnum;
};

/** Visual Preferences information */
export type VisualPreferences = {
  __typename?: 'VisualPreferences';
  dislike: Scalars['Boolean'];
  id: Scalars['String'];
  like: Scalars['Boolean'];
  url: Scalars['String'];
};

/** Visual Preferences information */
export type VisualPreferencesInput = {
  dislike: Scalars['Boolean'];
  id: Scalars['String'];
  like: Scalars['Boolean'];
  url: Scalars['String'];
};

export type ListIndustriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListIndustriesQuery = { __typename?: 'Query', listIndustries: Array<{ __typename?: 'Industry', id: string, name: string, covers?: Array<{ __typename?: 'IndustryCover', id: string, url: string }> | null | undefined }> };

export type CreateNotificationMutationVariables = Exact<{
  input: NotificationInput;
}>;


export type CreateNotificationMutation = { __typename?: 'Mutation', createNotification: { __typename?: 'Notification', id: string, type: NotificationsTypeEnum, fromUserId: string, toUserId: string, taskId?: string | null | undefined, taskCommentId?: string | null | undefined, sectionId?: string | null | undefined, tasklistId?: string | null | undefined, projectId: string } };

export type DeleteNotificationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteNotificationMutation = { __typename?: 'Mutation', deleteNotification: boolean };

export type GetNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationsQuery = { __typename?: 'Query', getNotifications: Array<{ __typename?: 'NotificationDetail', id: string, type: NotificationsTypeEnum, toUserId: string, date: any, fromUser: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined }, project: { __typename?: 'NotificationProject', id: string, name: string, client: { __typename?: 'NotificationClient', id: string, name: string } }, tasklist?: { __typename?: 'NotificationTasklist', id?: string | null | undefined, name?: string | null | undefined, description?: string | null | undefined, dueDate?: any | null | undefined, section?: { __typename?: 'NotificationSection', id?: string | null | undefined, task?: { __typename?: 'NotificationTask', id?: string | null | undefined, name?: string | null | undefined, completedDate?: any | null | undefined, dueDate?: any | null | undefined, comment?: { __typename?: 'NotificationTaskComment', id?: string | null | undefined, comment?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined } | null | undefined }> };

export type AcceptProjectInvitationMutationVariables = Exact<{
  projectId: Scalars['ID'];
  tenant?: InputMaybe<TenantsDetailsInput>;
}>;


export type AcceptProjectInvitationMutation = { __typename?: 'Mutation', acceptInvitation: boolean };

export type AddClientMutationVariables = Exact<{
  clientInfo: ClientInput;
}>;


export type AddClientMutation = { __typename?: 'Mutation', createClient: { __typename?: 'Client', id: string, name: string } };

export type AddProjectMutationVariables = Exact<{
  input: ProjectInput;
}>;


export type AddProjectMutation = { __typename?: 'Mutation', createProject: { __typename?: 'Project', id: string, name: string, coverImageUrl: string, members: Array<{ __typename?: 'Member', firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined, id: string }>, industry: { __typename?: 'Industry', name: string }, industryDetails?: { __typename?: 'ProjectIndustryDetails', id: string, visualPreferences?: Array<{ __typename?: 'VisualPreferences', url: string, id: string, like: boolean, dislike: boolean }> | null | undefined, otherBusinessGoals?: { __typename?: 'OtherBusinessGoals', other: string, values: Array<OtherBusinessGoalsEnum> } | null | undefined, otherSpaces?: { __typename?: 'OtherSpaces', other: string, quantities: Array<number>, values: Array<OtherSpacesEnum>, quantValues: Array<{ __typename?: 'QuantValuesSchema', amount: number, values: OtherSpacesEnum }> } | null | undefined, otherFacilityTypes?: { __typename?: 'OtherFacilityTypes', other: string, values: Array<OtherFacilityTypesEnum> } | null | undefined, otherAdministrativeGoals?: { __typename?: 'OtherAdministrativeGoals', other: string, values: Array<OtherAdministrativeGoalsEnum> } | null | undefined, otherClinicalGoals?: { __typename?: 'OtherClinicalGoals', other: string, values: Array<OtherClinicalGoalsEnum> } | null | undefined, otherHomeType?: { __typename?: 'OtherHomeType', other: string, values: Array<OtherHomeTypeEnum> } | null | undefined, otherWorkspaceType?: { __typename?: 'OtherWorkspaceType', other: string, values: Array<OtherWorkspaceTypeEnum> } | null | undefined, otherElements?: { __typename?: 'OtherElements', other: string, values: Array<OtherElementsEnum> } | null | undefined, projectSize?: { __typename?: 'ProjectSize', other: string, values: Array<ProjectSizeEnum> } | null | undefined, experienceLevel?: { __typename?: 'ExperienceLevel', other: string, values: Array<ExperienceLevelEnum> } | null | undefined } | null | undefined, client: { __typename?: 'Client', id: string } } };

export type DeleteClientMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteClientMutation = { __typename?: 'Mutation', deleteClient: boolean };

export type DeleteMemberMutationVariables = Exact<{
  input: DeleteProjectMemberInput;
}>;


export type DeleteMemberMutation = { __typename?: 'Mutation', deleteMember: boolean };

export type DeleteProjectMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteProject: boolean };

export type DenyProjectInvitationMutationVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type DenyProjectInvitationMutation = { __typename?: 'Mutation', denyInvitation: boolean };

export type ListFolioClientsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListFolioClientsQuery = { __typename?: 'Query', listFolioClients: Array<{ __typename?: 'Client', id: string, name: string, logoUrl: string, createdOn: any, createdBy?: { __typename?: 'DisplayUserSchema', firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined }> };

export type GetClientQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetClientQuery = { __typename?: 'Query', getClient: { __typename?: 'Client', id: string, name: string, logoUrl: string, industries: Array<{ __typename?: 'Industry', name: string, id: string }>, projects?: Array<{ __typename?: 'Project', id: string, name: string, coverImageUrl: string, isPinned: boolean, members: Array<{ __typename?: 'Member', avatarUrl?: string | null | undefined, id: string, firstName?: string | null | undefined, lastName?: string | null | undefined }>, industry: { __typename?: 'Industry', id: string, name: string } }> | null | undefined } };

export type GetProjectQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetProjectQuery = { __typename?: 'Query', getProject: { __typename?: 'Project', id: string, name: string, coverImageUrl: string, stage: string, budget: number, headCount: number, squareFootage: number, moveInDate?: any | null | undefined, buildingsQty: number, discountPercentage?: number | null | undefined, increasePercentage?: number | null | undefined, assignedTasklistsCount?: number | null | undefined, companyName?: string | null | undefined, projectEstimate?: { __typename?: 'ProjectEstimate', lowPrice: number, highPrice: number } | null | undefined, client: { __typename?: 'Client', id: string, name: string }, industry: { __typename?: 'Industry', id: string, name: string, covers?: Array<{ __typename?: 'IndustryCover', id: string, url: string }> | null | undefined }, industryDetails?: { __typename?: 'ProjectIndustryDetails', id: string, visualPreferences?: Array<{ __typename?: 'VisualPreferences', url: string, id: string, like: boolean, dislike: boolean }> | null | undefined, otherBusinessGoals?: { __typename?: 'OtherBusinessGoals', other: string, values: Array<OtherBusinessGoalsEnum> } | null | undefined, otherSpaces?: { __typename?: 'OtherSpaces', other: string, values: Array<OtherSpacesEnum>, quantValues: Array<{ __typename?: 'QuantValuesSchema', amount: number, values: OtherSpacesEnum, other: string }> } | null | undefined, otherFacilityTypes?: { __typename?: 'OtherFacilityTypes', other: string, values: Array<OtherFacilityTypesEnum> } | null | undefined, otherAdministrativeGoals?: { __typename?: 'OtherAdministrativeGoals', other: string, values: Array<OtherAdministrativeGoalsEnum> } | null | undefined, otherClinicalGoals?: { __typename?: 'OtherClinicalGoals', other: string, values: Array<OtherClinicalGoalsEnum> } | null | undefined, otherHomeType?: { __typename?: 'OtherHomeType', other: string, values: Array<OtherHomeTypeEnum> } | null | undefined, otherWorkspaceType?: { __typename?: 'OtherWorkspaceType', other: string, values: Array<OtherWorkspaceTypeEnum> } | null | undefined, otherElements?: { __typename?: 'OtherElements', other: string, values: Array<OtherElementsEnum> } | null | undefined, projectSize?: { __typename?: 'ProjectSize', other: string, values: Array<ProjectSizeEnum> } | null | undefined, experienceLevel?: { __typename?: 'ExperienceLevel', other: string, values: Array<ExperienceLevelEnum> } | null | undefined } | null | undefined, members: Array<{ __typename?: 'Member', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, avatarUrl?: string | null | undefined, status: ProjectMemberStatusEnum, phoneNumber?: string | null | undefined, businessRole?: string | null | undefined, role: { __typename?: 'ProjectRole', id: string, name: string } }> } };

export type GetProjectEstimatesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetProjectEstimatesQuery = { __typename?: 'Query', getProjectEstimates: { __typename?: 'ProjectEstimate', antiPricePercentHigh: number, antiPricePercentLow: number, antiPricePercentMid: number, lowPrice: number, midPrice: number, highPrice: number, lowServiceEstimate: number, midServiceEstimate: number, highServiceEstimate: number, installPercentLow: number, installPercentMid: number, installPercentHigh: number, freightPercentLow: number, freightPercentMid: number, freightPercentHigh: number, productTaxPercentHigh: number, productTaxPercentLow: number, productTaxPercentMid: number, serviceTaxPercentHigh: number, serviceTaxPercentLow: number, serviceTaxPercentMid: number, totalTaxPercentHigh: number, totalTaxPercentLow: number, totalTaxPercentMid: number } };

export type ListProjectsRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListProjectsRolesQuery = { __typename?: 'Query', listProjectsRoles: Array<{ __typename?: 'ProjectRole', id: string, name: string }> };

export type ListProjectSpacesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ListProjectSpacesQuery = { __typename?: 'Query', listProjectSpaces: Array<{ __typename?: 'Space', id: string, name: string, description?: string | null | undefined, templateId?: string | null | undefined, image?: string | null | undefined, quantity: number, list?: { __typename?: 'SpaceList', index: number, listNumber: number } | null | undefined, industry?: { __typename?: 'Industry', id: string, name: string } | null | undefined, items?: Array<{ __typename?: 'SpaceItem', id: string, name: string, quantity: number, lowPrice: number, midPrice: number, highPrice: number, image?: string | null | undefined, itemTemplatesId?: string | null | undefined, dragDropIndex?: number | null | undefined, category: { __typename?: 'ItemCategory', id: string, name: string } }> | null | undefined }> };

export type GetUsersForProjectInviteQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersForProjectInviteQuery = { __typename?: 'Query', getUsersForProjectInvite: Array<{ __typename?: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, phone?: string | null | undefined, email: string, status: Status, businessRole?: string | null | undefined, securityRoles: Array<SecurityRole> }> };

export type InviteCollaboratorsToFolioMutationVariables = Exact<{
  collaborators: Array<CollaboratorInformation> | CollaboratorInformation;
  tenant: TenantDetailsInput;
}>;


export type InviteCollaboratorsToFolioMutation = { __typename?: 'Mutation', inviteCollaboratorsToFolio: boolean };

export type InviteCollaboratorsMutationVariables = Exact<{
  input: InviteProjectCollaboratorsListInput;
}>;


export type InviteCollaboratorsMutation = { __typename?: 'Mutation', inviteCollaborators: boolean };

export type InviteMembersMutationVariables = Exact<{
  input: InviteProjectMembersListInput;
}>;


export type InviteMembersMutation = { __typename?: 'Mutation', inviteMembers: boolean };

export type LoadClientsAndProjectsQueryVariables = Exact<{
  industriesIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  memberIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type LoadClientsAndProjectsQuery = { __typename?: 'Query', listMemberClients: Array<{ __typename?: 'Client', id: string, name: string, logoUrl: string, createdOn: any, createdBy?: { __typename?: 'DisplayUserSchema', firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined, industries: Array<{ __typename?: 'Industry', name: string }>, projects?: Array<{ __typename?: 'Project', id: string, name: string, isPinned: boolean, datePinned?: any | null | undefined, coverImageUrl: string, companyName?: string | null | undefined, members: Array<{ __typename?: 'Member', firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined, id: string, role: { __typename?: 'ProjectRole', id: string, name: string } }>, industry: { __typename?: 'Industry', name: string }, industryDetails?: { __typename?: 'ProjectIndustryDetails', id: string, visualPreferences?: Array<{ __typename?: 'VisualPreferences', url: string, id: string, like: boolean, dislike: boolean }> | null | undefined, otherBusinessGoals?: { __typename?: 'OtherBusinessGoals', other: string, values: Array<OtherBusinessGoalsEnum> } | null | undefined, otherSpaces?: { __typename?: 'OtherSpaces', other: string, values: Array<OtherSpacesEnum>, quantValues: Array<{ __typename?: 'QuantValuesSchema', other: string, amount: number, values: OtherSpacesEnum }> } | null | undefined, otherFacilityTypes?: { __typename?: 'OtherFacilityTypes', other: string, values: Array<OtherFacilityTypesEnum> } | null | undefined, otherAdministrativeGoals?: { __typename?: 'OtherAdministrativeGoals', other: string, values: Array<OtherAdministrativeGoalsEnum> } | null | undefined, otherClinicalGoals?: { __typename?: 'OtherClinicalGoals', other: string, values: Array<OtherClinicalGoalsEnum> } | null | undefined, otherHomeType?: { __typename?: 'OtherHomeType', other: string, values: Array<OtherHomeTypeEnum> } | null | undefined, otherWorkspaceType?: { __typename?: 'OtherWorkspaceType', other: string, values: Array<OtherWorkspaceTypeEnum> } | null | undefined, otherElements?: { __typename?: 'OtherElements', other: string, values: Array<OtherElementsEnum> } | null | undefined, projectSize?: { __typename?: 'ProjectSize', other: string, values: Array<ProjectSizeEnum> } | null | undefined, experienceLevel?: { __typename?: 'ExperienceLevel', other: string, values: Array<ExperienceLevelEnum> } | null | undefined } | null | undefined }> | null | undefined }> };

export type ResendInvitationMutationVariables = Exact<{
  input: ResendProjectMemberInvitationInput;
}>;


export type ResendInvitationMutation = { __typename?: 'Mutation', resendInvitation: boolean };

export type SearchClientsAndProjectsQueryVariables = Exact<{
  fragment: Scalars['String'];
}>;


export type SearchClientsAndProjectsQuery = { __typename?: 'Query', searchProjectsClients: { __typename?: 'ProjectsClientsSearchResults', clients?: Array<{ __typename?: 'Item', id: string, name: string }> | null | undefined, projects?: Array<{ __typename?: 'Item', id: string, name: string }> | null | undefined } };

export type SendWelcomeToFolioQueryVariables = Exact<{
  userId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type SendWelcomeToFolioQuery = { __typename?: 'Query', sendWelcomeToFolioEmail: boolean };

export type SetProjectPinMutationVariables = Exact<{
  pinProjectInfo: PinProjectInput;
}>;


export type SetProjectPinMutation = { __typename?: 'Mutation', pinProject: { __typename?: 'PinnedProject', userId: string } };

export type UpdateOtherSpacesMutationVariables = Exact<{
  input: OtherSpacesInput;
  id: Scalars['ID'];
}>;


export type UpdateOtherSpacesMutation = { __typename?: 'Mutation', updateOtherSpaces: { __typename?: 'Project', industryDetails?: { __typename?: 'ProjectIndustryDetails', otherSpaces?: { __typename?: 'OtherSpaces', other: string, values: Array<OtherSpacesEnum>, quantValues: Array<{ __typename?: 'QuantValuesSchema', other: string, amount: number, values: OtherSpacesEnum }> } | null | undefined } | null | undefined } };

export type UpdateClientMutationVariables = Exact<{
  id: Scalars['ID'];
  clientInfo: ClientInput;
}>;


export type UpdateClientMutation = { __typename?: 'Mutation', updateClient: { __typename?: 'Client', id: string } };

export type UpdateDiscIncValuesMutationVariables = Exact<{
  input: DiscIncInput;
}>;


export type UpdateDiscIncValuesMutation = { __typename?: 'Mutation', updateDiscIncValues: { __typename?: 'Project', id: string, spaces?: Array<{ __typename?: 'Space', items?: Array<{ __typename?: 'SpaceItem', id: string, name: string, lowPrice: number, midPrice: number, highPrice: number }> | null | undefined }> | null | undefined } };

export type UpdateProjectMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ProjectInput;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'Project', id: string, name: string, coverImageUrl: string, stage: string, budget: number, headCount: number, squareFootage: number, moveInDate?: any | null | undefined, buildingsQty: number, assignedTasklistsCount?: number | null | undefined, companyName?: string | null | undefined, projectEstimate?: { __typename?: 'ProjectEstimate', lowPrice: number, highPrice: number } | null | undefined, client: { __typename?: 'Client', id: string, name: string }, industry: { __typename?: 'Industry', id: string, name: string, covers?: Array<{ __typename?: 'IndustryCover', id: string, url: string }> | null | undefined }, industryDetails?: { __typename?: 'ProjectIndustryDetails', id: string, visualPreferences?: Array<{ __typename?: 'VisualPreferences', url: string, id: string, like: boolean, dislike: boolean }> | null | undefined, otherBusinessGoals?: { __typename?: 'OtherBusinessGoals', other: string, values: Array<OtherBusinessGoalsEnum> } | null | undefined, otherSpaces?: { __typename?: 'OtherSpaces', other: string, values: Array<OtherSpacesEnum>, quantValues: Array<{ __typename?: 'QuantValuesSchema', amount: number, values: OtherSpacesEnum, other: string }> } | null | undefined, otherFacilityTypes?: { __typename?: 'OtherFacilityTypes', other: string, values: Array<OtherFacilityTypesEnum> } | null | undefined, otherAdministrativeGoals?: { __typename?: 'OtherAdministrativeGoals', other: string, values: Array<OtherAdministrativeGoalsEnum> } | null | undefined, otherClinicalGoals?: { __typename?: 'OtherClinicalGoals', other: string, values: Array<OtherClinicalGoalsEnum> } | null | undefined, otherHomeType?: { __typename?: 'OtherHomeType', other: string, values: Array<OtherHomeTypeEnum> } | null | undefined, otherWorkspaceType?: { __typename?: 'OtherWorkspaceType', other: string, values: Array<OtherWorkspaceTypeEnum> } | null | undefined, otherElements?: { __typename?: 'OtherElements', other: string, values: Array<OtherElementsEnum> } | null | undefined, projectSize?: { __typename?: 'ProjectSize', other: string, values: Array<ProjectSizeEnum> } | null | undefined, experienceLevel?: { __typename?: 'ExperienceLevel', other: string, values: Array<ExperienceLevelEnum> } | null | undefined } | null | undefined } };

export type UpdateProjectMemberRoleMutationVariables = Exact<{
  input: UpdateProjectMemberRoleInput;
}>;


export type UpdateProjectMemberRoleMutation = { __typename?: 'Mutation', updateMemberRole: boolean };

export type UpdateProjectsStageMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ProjectStageInput;
}>;


export type UpdateProjectsStageMutation = { __typename?: 'Mutation', updateProjectsStage: { __typename?: 'Project', id: string } };

export type ViewProjectCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewProjectCountQuery = { __typename?: 'Query', viewProjectCount: number };

export type ViewUserInvitationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewUserInvitationsQuery = { __typename?: 'Query', viewUserInvitations: Array<{ __typename?: 'Project', id: string, name: string }> };

export type CreateServicesMutationVariables = Exact<{
  input: CreateServicesInput;
}>;


export type CreateServicesMutation = { __typename?: 'Mutation', createServices: Array<{ __typename?: 'Service', id: string, lowEstimate: number, midEstimate: number, highEstimate: number, percentage: number, servicesTemplates: { __typename?: 'ServiceTemplate', name: string } }> };

export type DeleteServiceMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteServiceMutation = { __typename?: 'Mutation', deleteService: boolean };

export type ListServicesTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListServicesTemplatesQuery = { __typename?: 'Query', listServicesTemplates: Array<{ __typename?: 'ServiceTemplate', id: string, name: string }> };

export type GetProjectServicesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetProjectServicesQuery = { __typename?: 'Query', listProjectServices: Array<{ __typename?: 'Service', id: string, lowEstimate: number, midEstimate: number, highEstimate: number, percentage: number, servicesTemplates: { __typename?: 'ServiceTemplate', id: string, name: string, description: string } }> };

export type UpdateServicesMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateServicesInput;
}>;


export type UpdateServicesMutation = { __typename?: 'Mutation', updateService: boolean };

export type CopySpaceMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CopySpaceMutation = { __typename?: 'Mutation', copySpace: boolean };

export type CreateSpaceCommentMutationVariables = Exact<{
  input: SpaceCommentInput;
}>;


export type CreateSpaceCommentMutation = { __typename?: 'Mutation', createSpaceComment: { __typename?: 'SpaceComment', id: string, comment: string, spaceId: string } };

export type CreateSpacesMutationVariables = Exact<{
  input: CreateSpacesInput;
}>;


export type CreateSpacesMutation = { __typename?: 'Mutation', createSpaces: Array<{ __typename?: 'Space', id: string, name: string }> };

export type DeleteSpaceMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteSpaceMutation = { __typename?: 'Mutation', deleteSpace: boolean };

export type GetCommentsBySpaceIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCommentsBySpaceIdQuery = { __typename?: 'Query', getCommentsBySpaceId: Array<{ __typename?: 'SpaceComment', id: string, comment: string, spaceId: string, userFirstName: string, userLastName: string, createdOn: any }> };

export type GetAllItemTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllItemTemplatesQuery = { __typename?: 'Query', getAllItemTemplates: Array<{ __typename?: 'ItemTemplate', id: string, name: string, lowPrice: number, midPrice: number, highPrice: number, image?: string | null | undefined, quantity: number, createdOn: any, modifiedOn?: any | null | undefined, category?: { __typename?: 'ItemCategory', id: string, name: string, createdOn: any, modifiedOn?: any | null | undefined } | null | undefined }> };

export type ListSpacesItemTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListSpacesItemTemplatesQuery = { __typename?: 'Query', listSpacesItemTemplates: Array<{ __typename?: 'SpacesItemTemplate', itemsQuantity: number, itemTemplate: { __typename?: 'ItemTemplate', id: string, lowPrice: number, midPrice: number, highPrice: number }, spacesTemplate: { __typename?: 'SpaceTemplate', id: string } }> };

export type ListSpacesTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListSpacesTemplatesQuery = { __typename?: 'Query', listSpacesTemplates: Array<{ __typename?: 'SpaceTemplate', id: string, name: string, description: string, image?: string | null | undefined, industry?: { __typename?: 'Industry', id: string, name: string } | null | undefined, items: Array<{ __typename?: 'ItemTemplate', id: string, name: string, lowPrice: number, midPrice: number, highPrice: number, image?: string | null | undefined, category?: { __typename?: 'ItemCategory', id: string, name: string } | null | undefined }> }> };

export type UpdateItemIndexMutationVariables = Exact<{
  input: Array<UpdateItemIndexInput> | UpdateItemIndexInput;
}>;


export type UpdateItemIndexMutation = { __typename?: 'Mutation', updateItemIndex: boolean };

export type UpdateSpaceMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateSpaceInput;
}>;


export type UpdateSpaceMutation = { __typename?: 'Mutation', updateSpace: boolean };

export type UpdateSpaceListsMutationVariables = Exact<{
  input: Array<UpdateSpaceListInput> | UpdateSpaceListInput;
}>;


export type UpdateSpaceListsMutation = { __typename?: 'Mutation', updateSpaceList: boolean };

export type AddTaskCommentMutationVariables = Exact<{
  input: CreateCommentInput;
}>;


export type AddTaskCommentMutation = { __typename?: 'Mutation', addTaskComment: { __typename?: 'TaskComment', id: string, taskId: string, comment: string, createdOn: any, modifiedOn?: any | null | undefined, createUser: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined }, modifyUser?: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined } };

export type AddTasklistToProjectMutationVariables = Exact<{
  projectId: Scalars['ID'];
  templateId: Scalars['ID'];
}>;


export type AddTasklistToProjectMutation = { __typename?: 'Mutation', addTasklistToProject: { __typename?: 'Tasklist', id: string, name: string, isVisible: boolean, createdOn: any, modifiedOn: any, dueDate?: any | null | undefined, tasklistTemplateId?: string | null | undefined, createUser: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined }, modifyUser?: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined, sections: Array<{ __typename?: 'Section', id: string, name: string, tasklistId: string, createdOn: any, modifiedOn?: any | null | undefined, createUser: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined }, modifyUser?: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined, tasks: Array<{ __typename?: 'Task', id: string, name: string, sectionId: string, completedDate?: any | null | undefined, createdOn: any, modifiedOn?: any | null | undefined, dueDate?: any | null | undefined, createUser: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined }, modifyUser?: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined, fields?: Array<{ __typename?: 'AreaField', name: string, type: string, label: string } | { __typename?: 'CheckboxField', name: string, type: string, label: string } | { __typename?: 'DateField', name: string, type: string, label: string } | { __typename?: 'RadioField', name: string, type: string, options: Array<{ __typename?: 'FieldOption', label: string, value: string }> } | { __typename?: 'TextField', name: string, type: string, label: string }> | null | undefined, taskAnswer?: { __typename?: 'TaskAnswer', id: string, values: any, taskId: string, createdOn: any, modifiedOn?: any | null | undefined, createUser: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined }, modifyUser?: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined } | null | undefined }> }> } };

export type ArchiveTasklistMutationVariables = Exact<{
  projectId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type ArchiveTasklistMutation = { __typename?: 'Mutation', archiveTasklist: boolean };

export type CompleteTasksInSectionMutationVariables = Exact<{
  projectId: Scalars['ID'];
  sectionId: Scalars['ID'];
}>;


export type CompleteTasksInSectionMutation = { __typename?: 'Mutation', completeTasksInSection: boolean };

export type CreateSectionMutationVariables = Exact<{
  projectId: Scalars['ID'];
  input: CreateSectionInput;
}>;


export type CreateSectionMutation = { __typename?: 'Mutation', createSection: { __typename?: 'Section', id: string, name: string, tasklistId: string, createdOn: any, modifiedOn?: any | null | undefined, createdBy: string, modifiedBy?: string | null | undefined, tasklist: { __typename?: 'Tasklist', id: string } } };

export type CreateTaskMutationVariables = Exact<{
  projectId: Scalars['ID'];
  input: CreateTaskInput;
}>;


export type CreateTaskMutation = { __typename?: 'Mutation', createTask: { __typename?: 'Task', id: string, name: string, completedDate?: any | null | undefined, dueDate?: any | null | undefined, sectionId: string, createdOn: any, modifiedOn?: any | null | undefined, createdBy: string, modifiedBy?: string | null | undefined, assignedUser?: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined, completedByUser?: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined, createUser: { __typename?: 'DisplayUserSchema', avatarUrl?: string | null | undefined, businessRole?: string | null | undefined, firstName?: string | null | undefined, id: string, lastName?: string | null | undefined }, modifyUser?: { __typename?: 'DisplayUserSchema', avatarUrl?: string | null | undefined, businessRole?: string | null | undefined, firstName?: string | null | undefined, id: string, lastName?: string | null | undefined } | null | undefined, fields?: Array<{ __typename?: 'AreaField', name: string, type: string, label: string } | { __typename?: 'CheckboxField', name: string, type: string, label: string } | { __typename?: 'DateField', name: string, type: string, label: string } | { __typename?: 'RadioField', name: string, type: string, options: Array<{ __typename?: 'FieldOption', label: string, value: string }> } | { __typename?: 'TextField', name: string, type: string, label: string }> | null | undefined, taskAnswer?: { __typename?: 'TaskAnswer', id: string, values: any, createdOn: any, modifiedOn?: any | null | undefined, createdBy: string, modifiedBy?: string | null | undefined } | null | undefined } };

export type CreateTaskListMutationVariables = Exact<{
  input: CreateTasklistInput;
}>;


export type CreateTaskListMutation = { __typename?: 'Mutation', createTasklist: { __typename?: 'Tasklist', id: string, name: string, description?: string | null | undefined, dueDate?: any | null | undefined, associatedObjectId?: string | null | undefined, createdOn: any, modifiedOn: any, createUser: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined }, modifyUser?: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined, tasklistUsers?: Array<{ __typename?: 'TasklistUser', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined, createdOn: any, modifiedOn?: any | null | undefined, tasklists: Array<{ __typename?: 'Tasklist', id: string, name: string }>, createUser: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined }, modifyUser?: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined }> | null | undefined } };

export type DeleteTaskMutationVariables = Exact<{
  projectId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type DeleteTaskMutation = { __typename?: 'Mutation', deleteTask: boolean };

export type DeleteTasklistMutationVariables = Exact<{
  projectId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type DeleteTasklistMutation = { __typename?: 'Mutation', deleteTasklist: boolean };

export type GetTaskCommentsQueryVariables = Exact<{
  projectId: Scalars['ID'];
  taskId: Scalars['ID'];
}>;


export type GetTaskCommentsQuery = { __typename?: 'Query', getTaskComments: Array<{ __typename?: 'TaskComment', id: string, taskId: string, comment: string, createdOn: any, modifiedOn?: any | null | undefined, createUser: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined }, modifyUser?: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined }> };

export type PredefinedTasklistsQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type PredefinedTasklistsQuery = { __typename?: 'Query', predefinedTasklists: Array<{ __typename?: 'TasklistTemplateListItem', tasklistTemplateId: string, name: string, description?: string | null | undefined, createdOn: any, modifiedOn: any }> };

export type TasklistsForProjectQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type TasklistsForProjectQuery = { __typename?: 'Query', tasklistsForProject: Array<{ __typename?: 'Tasklist', id: string, name: string, description?: string | null | undefined, isArchived: boolean, isVisible: boolean, isVisibleChangedOn?: any | null | undefined, associatedObjectId?: string | null | undefined, tasklistTemplateId?: string | null | undefined, createdOn: any, modifiedOn: any, dueDate?: any | null | undefined, createUser: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined }, modifyUser?: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined, tasklistUsers?: Array<{ __typename?: 'TasklistUser', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined, createdOn: any, modifiedOn?: any | null | undefined, tasklists: Array<{ __typename?: 'Tasklist', id: string, name: string }>, createUser: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined }, modifyUser?: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined }> | null | undefined, sections: Array<{ __typename?: 'Section', id: string, name: string, tasklistId: string, createdOn: any, modifiedOn?: any | null | undefined, createUser: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined }, modifyUser?: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined, tasks: Array<{ __typename?: 'Task', id: string, name: string, completedDate?: any | null | undefined, sectionId: string, createdOn: any, modifiedOn?: any | null | undefined, dueDate?: any | null | undefined, numComments: number, createUser: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined }, modifyUser?: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined, assignedUser?: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined, completedByUser?: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined, comments?: Array<{ __typename?: 'TaskComment', createdBy: string, modifiedBy?: string | null | undefined, createdOn: any, modifiedOn?: any | null | undefined, id: string, taskId: string, comment: string, tags?: Array<{ __typename?: 'TaskTag', display: string, userId: string }> | null | undefined }> | null | undefined, fields?: Array<{ __typename?: 'AreaField', name: string, type: string, label: string } | { __typename?: 'CheckboxField', name: string, type: string, label: string } | { __typename?: 'DateField', name: string, type: string, label: string } | { __typename?: 'RadioField', name: string, type: string, options: Array<{ __typename?: 'FieldOption', label: string, value: string }> } | { __typename?: 'TextField', name: string, type: string, label: string }> | null | undefined, taskAnswer?: { __typename?: 'TaskAnswer', id: string, values: any, taskId: string, createdOn: any, modifiedOn?: any | null | undefined } | null | undefined }> }> }> };

export type UpdateTaskMutationVariables = Exact<{
  projectId: Scalars['ID'];
  input: UpdateTaskInput;
}>;


export type UpdateTaskMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'Task', id: string, name: string, completedDate?: any | null | undefined, sectionId: string, createdOn: any, modifiedOn?: any | null | undefined, dueDate?: any | null | undefined, numComments: number, createUser: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined }, modifyUser?: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined, assignedUser?: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined, completedByUser?: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined, fields?: Array<{ __typename?: 'AreaField', name: string, type: string, label: string } | { __typename?: 'CheckboxField', name: string, type: string, label: string } | { __typename?: 'DateField', name: string, type: string, label: string } | { __typename?: 'RadioField', name: string, type: string, options: Array<{ __typename?: 'FieldOption', label: string, value: string }> } | { __typename?: 'TextField', name: string, type: string, label: string }> | null | undefined, taskAnswer?: { __typename?: 'TaskAnswer', id: string, values: any, taskId: string, createdOn: any, modifiedOn?: any | null | undefined } | null | undefined } };

export type UpdateTaskListMutationVariables = Exact<{
  projectId: Scalars['ID'];
  input: UpdateTasklistInput;
}>;


export type UpdateTaskListMutation = { __typename?: 'Mutation', updateTasklist: boolean };

export type UpsertTaskAnswerMutationVariables = Exact<{
  projectId: Scalars['ID'];
  input: UpsertTaskAnswerInput;
}>;


export type UpsertTaskAnswerMutation = { __typename?: 'Mutation', upsertTaskAnswer: { __typename?: 'TaskAnswer', id: string, taskId: string, values: any, createdOn: any, modifiedOn?: any | null | undefined, createUser: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined }, modifyUser?: { __typename?: 'DisplayUserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined, task: { __typename?: 'Task', id: string } } };

export type GetTenantInfoByCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantInfoByCodeQuery = { __typename?: 'Query', getTenantInfoByCode: { __typename?: 'TenantsDetails', id: string, code: string, tenantName?: string | null | undefined, email?: string | null | undefined, licenses: number, used?: number | null | undefined } };

export type ListUsersForProjectInviteQueryVariables = Exact<{
  projectId: Scalars['ID'];
}>;


export type ListUsersForProjectInviteQuery = { __typename?: 'Query', listUsersForProjectInvite: Array<{ __typename?: 'UserSchema', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, phone?: string | null | undefined, email: string, status: StatusEnum, businessRole?: string | null | undefined, securityRoles: Array<SecurityRoleEnum> }> };

export type AddRoleMutationVariables = Exact<{
  id: Scalars['ID'];
  role: SecurityRole;
}>;


export type AddRoleMutation = { __typename?: 'Mutation', addRole: boolean };

export type AdminUpdateUserMutationVariables = Exact<{
  id: Scalars['ID'];
  userInfo: AdminUpdateUserInput;
}>;


export type AdminUpdateUserMutation = { __typename?: 'Mutation', adminUpdateUser: boolean };

export type GetDisplayUserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetDisplayUserQuery = { __typename?: 'Query', getDisplayUser: { __typename?: 'DisplayUser', firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined, businessRole?: string | null | undefined } };

export type GetDisplayUsersByUserIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetDisplayUsersByUserIdsQuery = { __typename?: 'Query', getDisplayUsersByUserIds: Array<{ __typename?: 'DisplayUser', firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined, businessRole?: string | null | undefined }> };

export type GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { __typename?: 'Query', getUsers: Array<{ __typename?: 'User', avatarUrl?: string | null | undefined, id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, phone?: string | null | undefined, email: string, status: Status, businessRole?: string | null | undefined, securityRoles: Array<SecurityRole> }> };

export type GetUsersByUserIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetUsersByUserIdsQuery = { __typename?: 'Query', getUsersByUserIds: Array<{ __typename?: 'User', id: string, email: string, status: Status, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarUrl?: string | null | undefined, phone?: string | null | undefined, businessRole?: string | null | undefined, securityRoles: Array<SecurityRole> }> };

export type InviteUserMutationVariables = Exact<{
  email: Scalars['String'];
  firstName: Scalars['String'];
  securityRoles: Array<SecurityRole> | SecurityRole;
}>;


export type InviteUserMutation = { __typename?: 'Mutation', inviteUser: string };

export type LoadCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadCurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, avatarUrl?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, phone?: string | null | undefined, email: string, status: Status, businessRole?: string | null | undefined, securityRoles: Array<SecurityRole>, isTheoremAdmin?: boolean | null | undefined } };

export type RemoveRoleMutationVariables = Exact<{
  id: Scalars['ID'];
  role: SecurityRole;
}>;


export type RemoveRoleMutation = { __typename?: 'Mutation', removeRole: boolean };

export type ResendInviteLinkMutationVariables = Exact<{
  email: Scalars['String'];
  id: Scalars['ID'];
}>;


export type ResendInviteLinkMutation = { __typename?: 'Mutation', resendInviteLink: boolean };

export type ResendTheoremAdminInviteLinkMutationVariables = Exact<{
  email: Scalars['String'];
  id: Scalars['ID'];
}>;


export type ResendTheoremAdminInviteLinkMutation = { __typename?: 'Mutation', resendTheoremAdminInviteLink: boolean };

export type UpdateUserMutationVariables = Exact<{
  userInfo: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: boolean };

export type AreaFieldKeySpecifier = ('label' | 'name' | 'type' | AreaFieldKeySpecifier)[];
export type AreaFieldFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckboxFieldKeySpecifier = ('label' | 'name' | 'type' | CheckboxFieldKeySpecifier)[];
export type CheckboxFieldFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ClientKeySpecifier = ('createdBy' | 'createdOn' | 'id' | 'industries' | 'logoUrl' | 'modifiedOn' | 'name' | 'projects' | ClientKeySpecifier)[];
export type ClientFieldPolicy = {
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdOn?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	industries?: FieldPolicy<any> | FieldReadFunction<any>,
	logoUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	projects?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DateFieldKeySpecifier = ('label' | 'name' | 'type' | DateFieldKeySpecifier)[];
export type DateFieldFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisplayUserKeySpecifier = ('avatarUrl' | 'businessRole' | 'firstName' | 'id' | 'lastName' | DisplayUserKeySpecifier)[];
export type DisplayUserFieldPolicy = {
	avatarUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	businessRole?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisplayUserSchemaKeySpecifier = ('avatarUrl' | 'businessRole' | 'firstName' | 'id' | 'lastName' | DisplayUserSchemaKeySpecifier)[];
export type DisplayUserSchemaFieldPolicy = {
	avatarUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	businessRole?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExperienceLevelKeySpecifier = ('other' | 'values' | ExperienceLevelKeySpecifier)[];
export type ExperienceLevelFieldPolicy = {
	other?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FieldOptionKeySpecifier = ('label' | 'value' | FieldOptionKeySpecifier)[];
export type FieldOptionFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IndustryKeySpecifier = ('covers' | 'id' | 'name' | IndustryKeySpecifier)[];
export type IndustryFieldPolicy = {
	covers?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IndustryCoverKeySpecifier = ('id' | 'url' | IndustryCoverKeySpecifier)[];
export type IndustryCoverFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ItemKeySpecifier = ('id' | 'name' | ItemKeySpecifier)[];
export type ItemFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ItemCategoryKeySpecifier = ('createdOn' | 'id' | 'modifiedOn' | 'name' | ItemCategoryKeySpecifier)[];
export type ItemCategoryFieldPolicy = {
	createdOn?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ItemTemplateKeySpecifier = ('category' | 'createdOn' | 'highPrice' | 'id' | 'image' | 'lowPrice' | 'midPrice' | 'modifiedOn' | 'name' | 'quantity' | ItemTemplateKeySpecifier)[];
export type ItemTemplateFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	createdOn?: FieldPolicy<any> | FieldReadFunction<any>,
	highPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	lowPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	midPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MemberKeySpecifier = ('avatarUrl' | 'businessRole' | 'email' | 'firstName' | 'id' | 'lastName' | 'phoneNumber' | 'role' | 'status' | MemberKeySpecifier)[];
export type MemberFieldPolicy = {
	avatarUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	businessRole?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationKeySpecifier = ('acceptInvitation' | 'addRole' | 'addTaskComment' | 'addTasklistToProject' | 'adminUpdateUser' | 'archiveTasklist' | 'completeTasksInSection' | 'copySpace' | 'createClient' | 'createIndustry' | 'createItemTemplate' | 'createNotification' | 'createProject' | 'createSection' | 'createServices' | 'createSpaceComment' | 'createSpaceTemplate' | 'createSpaces' | 'createTask' | 'createTasklist' | 'createUser' | 'deleteClient' | 'deleteIndustry' | 'deleteItemTemplate' | 'deleteMember' | 'deleteNotification' | 'deleteProject' | 'deleteService' | 'deleteSpace' | 'deleteSpaceTemplate' | 'deleteTask' | 'deleteTasklist' | 'deleteUser' | 'denyInvitation' | 'inviteCollaborators' | 'inviteCollaboratorsToFolio' | 'inviteMembers' | 'inviteParticipantUser' | 'inviteTheoremAdmin' | 'inviteUser' | 'pinProject' | 'removeRole' | 'resendInvitation' | 'resendInviteLink' | 'resendTheoremAdminInviteLink' | 'updateClient' | 'updateDiscIncValues' | 'updateIndustry' | 'updateItemIndex' | 'updateItemTemplate' | 'updateMemberRole' | 'updateOtherSpaces' | 'updateProject' | 'updateProjectsStage' | 'updateService' | 'updateSpace' | 'updateSpaceList' | 'updateSpaceTemplate' | 'updateTask' | 'updateTasklist' | 'updateTenantInfo' | 'updateUser' | 'upsertTaskAnswer' | MutationKeySpecifier)[];
export type MutationFieldPolicy = {
	acceptInvitation?: FieldPolicy<any> | FieldReadFunction<any>,
	addRole?: FieldPolicy<any> | FieldReadFunction<any>,
	addTaskComment?: FieldPolicy<any> | FieldReadFunction<any>,
	addTasklistToProject?: FieldPolicy<any> | FieldReadFunction<any>,
	adminUpdateUser?: FieldPolicy<any> | FieldReadFunction<any>,
	archiveTasklist?: FieldPolicy<any> | FieldReadFunction<any>,
	completeTasksInSection?: FieldPolicy<any> | FieldReadFunction<any>,
	copySpace?: FieldPolicy<any> | FieldReadFunction<any>,
	createClient?: FieldPolicy<any> | FieldReadFunction<any>,
	createIndustry?: FieldPolicy<any> | FieldReadFunction<any>,
	createItemTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	createNotification?: FieldPolicy<any> | FieldReadFunction<any>,
	createProject?: FieldPolicy<any> | FieldReadFunction<any>,
	createSection?: FieldPolicy<any> | FieldReadFunction<any>,
	createServices?: FieldPolicy<any> | FieldReadFunction<any>,
	createSpaceComment?: FieldPolicy<any> | FieldReadFunction<any>,
	createSpaceTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	createSpaces?: FieldPolicy<any> | FieldReadFunction<any>,
	createTask?: FieldPolicy<any> | FieldReadFunction<any>,
	createTasklist?: FieldPolicy<any> | FieldReadFunction<any>,
	createUser?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteClient?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteIndustry?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteItemTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteMember?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteNotification?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteProject?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteService?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteSpace?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteSpaceTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteTask?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteTasklist?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteUser?: FieldPolicy<any> | FieldReadFunction<any>,
	denyInvitation?: FieldPolicy<any> | FieldReadFunction<any>,
	inviteCollaborators?: FieldPolicy<any> | FieldReadFunction<any>,
	inviteCollaboratorsToFolio?: FieldPolicy<any> | FieldReadFunction<any>,
	inviteMembers?: FieldPolicy<any> | FieldReadFunction<any>,
	inviteParticipantUser?: FieldPolicy<any> | FieldReadFunction<any>,
	inviteTheoremAdmin?: FieldPolicy<any> | FieldReadFunction<any>,
	inviteUser?: FieldPolicy<any> | FieldReadFunction<any>,
	pinProject?: FieldPolicy<any> | FieldReadFunction<any>,
	removeRole?: FieldPolicy<any> | FieldReadFunction<any>,
	resendInvitation?: FieldPolicy<any> | FieldReadFunction<any>,
	resendInviteLink?: FieldPolicy<any> | FieldReadFunction<any>,
	resendTheoremAdminInviteLink?: FieldPolicy<any> | FieldReadFunction<any>,
	updateClient?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDiscIncValues?: FieldPolicy<any> | FieldReadFunction<any>,
	updateIndustry?: FieldPolicy<any> | FieldReadFunction<any>,
	updateItemIndex?: FieldPolicy<any> | FieldReadFunction<any>,
	updateItemTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	updateMemberRole?: FieldPolicy<any> | FieldReadFunction<any>,
	updateOtherSpaces?: FieldPolicy<any> | FieldReadFunction<any>,
	updateProject?: FieldPolicy<any> | FieldReadFunction<any>,
	updateProjectsStage?: FieldPolicy<any> | FieldReadFunction<any>,
	updateService?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSpace?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSpaceList?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSpaceTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTask?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTasklist?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTenantInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUser?: FieldPolicy<any> | FieldReadFunction<any>,
	upsertTaskAnswer?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationKeySpecifier = ('fromUserId' | 'id' | 'projectId' | 'sectionId' | 'taskCommentId' | 'taskId' | 'tasklistId' | 'toUserId' | 'type' | NotificationKeySpecifier)[];
export type NotificationFieldPolicy = {
	fromUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	projectId?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionId?: FieldPolicy<any> | FieldReadFunction<any>,
	taskCommentId?: FieldPolicy<any> | FieldReadFunction<any>,
	taskId?: FieldPolicy<any> | FieldReadFunction<any>,
	tasklistId?: FieldPolicy<any> | FieldReadFunction<any>,
	toUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationClientKeySpecifier = ('id' | 'name' | NotificationClientKeySpecifier)[];
export type NotificationClientFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationDetailKeySpecifier = ('date' | 'fromUser' | 'id' | 'project' | 'tasklist' | 'toUserId' | 'type' | NotificationDetailKeySpecifier)[];
export type NotificationDetailFieldPolicy = {
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	fromUser?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	project?: FieldPolicy<any> | FieldReadFunction<any>,
	tasklist?: FieldPolicy<any> | FieldReadFunction<any>,
	toUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationProjectKeySpecifier = ('client' | 'id' | 'name' | NotificationProjectKeySpecifier)[];
export type NotificationProjectFieldPolicy = {
	client?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationSectionKeySpecifier = ('id' | 'task' | NotificationSectionKeySpecifier)[];
export type NotificationSectionFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	task?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationTaskKeySpecifier = ('comment' | 'completedDate' | 'dueDate' | 'id' | 'name' | NotificationTaskKeySpecifier)[];
export type NotificationTaskFieldPolicy = {
	comment?: FieldPolicy<any> | FieldReadFunction<any>,
	completedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	dueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationTaskCommentKeySpecifier = ('comment' | 'id' | NotificationTaskCommentKeySpecifier)[];
export type NotificationTaskCommentFieldPolicy = {
	comment?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationTasklistKeySpecifier = ('description' | 'dueDate' | 'id' | 'name' | 'section' | NotificationTasklistKeySpecifier)[];
export type NotificationTasklistFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	dueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	section?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OtherAdministrativeGoalsKeySpecifier = ('other' | 'values' | OtherAdministrativeGoalsKeySpecifier)[];
export type OtherAdministrativeGoalsFieldPolicy = {
	other?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OtherBusinessGoalsKeySpecifier = ('other' | 'values' | OtherBusinessGoalsKeySpecifier)[];
export type OtherBusinessGoalsFieldPolicy = {
	other?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OtherClinicalGoalsKeySpecifier = ('other' | 'values' | OtherClinicalGoalsKeySpecifier)[];
export type OtherClinicalGoalsFieldPolicy = {
	other?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OtherElementsKeySpecifier = ('other' | 'values' | OtherElementsKeySpecifier)[];
export type OtherElementsFieldPolicy = {
	other?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OtherFacilityTypesKeySpecifier = ('other' | 'values' | OtherFacilityTypesKeySpecifier)[];
export type OtherFacilityTypesFieldPolicy = {
	other?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OtherHomeTypeKeySpecifier = ('other' | 'values' | OtherHomeTypeKeySpecifier)[];
export type OtherHomeTypeFieldPolicy = {
	other?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OtherSpacesKeySpecifier = ('other' | 'quantValues' | 'quantities' | 'values' | OtherSpacesKeySpecifier)[];
export type OtherSpacesFieldPolicy = {
	other?: FieldPolicy<any> | FieldReadFunction<any>,
	quantValues?: FieldPolicy<any> | FieldReadFunction<any>,
	quantities?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OtherWorkspaceTypeKeySpecifier = ('other' | 'values' | OtherWorkspaceTypeKeySpecifier)[];
export type OtherWorkspaceTypeFieldPolicy = {
	other?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PinnedProjectKeySpecifier = ('isPinned' | 'project' | 'userId' | PinnedProjectKeySpecifier)[];
export type PinnedProjectFieldPolicy = {
	isPinned?: FieldPolicy<any> | FieldReadFunction<any>,
	project?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProjectKeySpecifier = ('assignedTasklistsCount' | 'budget' | 'buildingsQty' | 'client' | 'companyName' | 'coverImageUrl' | 'createdOn' | 'datePinned' | 'discountPercentage' | 'headCount' | 'id' | 'increasePercentage' | 'industry' | 'industryDetails' | 'isPinned' | 'members' | 'modifiedOn' | 'moveInDate' | 'name' | 'notifications' | 'projectEstimate' | 'spaces' | 'squareFootage' | 'stage' | ProjectKeySpecifier)[];
export type ProjectFieldPolicy = {
	assignedTasklistsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	budget?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingsQty?: FieldPolicy<any> | FieldReadFunction<any>,
	client?: FieldPolicy<any> | FieldReadFunction<any>,
	companyName?: FieldPolicy<any> | FieldReadFunction<any>,
	coverImageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	createdOn?: FieldPolicy<any> | FieldReadFunction<any>,
	datePinned?: FieldPolicy<any> | FieldReadFunction<any>,
	discountPercentage?: FieldPolicy<any> | FieldReadFunction<any>,
	headCount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	increasePercentage?: FieldPolicy<any> | FieldReadFunction<any>,
	industry?: FieldPolicy<any> | FieldReadFunction<any>,
	industryDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	isPinned?: FieldPolicy<any> | FieldReadFunction<any>,
	members?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	moveInDate?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	notifications?: FieldPolicy<any> | FieldReadFunction<any>,
	projectEstimate?: FieldPolicy<any> | FieldReadFunction<any>,
	spaces?: FieldPolicy<any> | FieldReadFunction<any>,
	squareFootage?: FieldPolicy<any> | FieldReadFunction<any>,
	stage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProjectEstimateKeySpecifier = ('antiPricePercentHigh' | 'antiPricePercentLow' | 'antiPricePercentMid' | 'freightPercentHigh' | 'freightPercentLow' | 'freightPercentMid' | 'highPrice' | 'highServiceEstimate' | 'installPercentHigh' | 'installPercentLow' | 'installPercentMid' | 'lowPrice' | 'lowServiceEstimate' | 'midPrice' | 'midServiceEstimate' | 'productTaxPercentHigh' | 'productTaxPercentLow' | 'productTaxPercentMid' | 'serviceTaxPercentHigh' | 'serviceTaxPercentLow' | 'serviceTaxPercentMid' | 'totalTaxPercentHigh' | 'totalTaxPercentLow' | 'totalTaxPercentMid' | ProjectEstimateKeySpecifier)[];
export type ProjectEstimateFieldPolicy = {
	antiPricePercentHigh?: FieldPolicy<any> | FieldReadFunction<any>,
	antiPricePercentLow?: FieldPolicy<any> | FieldReadFunction<any>,
	antiPricePercentMid?: FieldPolicy<any> | FieldReadFunction<any>,
	freightPercentHigh?: FieldPolicy<any> | FieldReadFunction<any>,
	freightPercentLow?: FieldPolicy<any> | FieldReadFunction<any>,
	freightPercentMid?: FieldPolicy<any> | FieldReadFunction<any>,
	highPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	highServiceEstimate?: FieldPolicy<any> | FieldReadFunction<any>,
	installPercentHigh?: FieldPolicy<any> | FieldReadFunction<any>,
	installPercentLow?: FieldPolicy<any> | FieldReadFunction<any>,
	installPercentMid?: FieldPolicy<any> | FieldReadFunction<any>,
	lowPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	lowServiceEstimate?: FieldPolicy<any> | FieldReadFunction<any>,
	midPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	midServiceEstimate?: FieldPolicy<any> | FieldReadFunction<any>,
	productTaxPercentHigh?: FieldPolicy<any> | FieldReadFunction<any>,
	productTaxPercentLow?: FieldPolicy<any> | FieldReadFunction<any>,
	productTaxPercentMid?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceTaxPercentHigh?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceTaxPercentLow?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceTaxPercentMid?: FieldPolicy<any> | FieldReadFunction<any>,
	totalTaxPercentHigh?: FieldPolicy<any> | FieldReadFunction<any>,
	totalTaxPercentLow?: FieldPolicy<any> | FieldReadFunction<any>,
	totalTaxPercentMid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProjectIndustryDetailsKeySpecifier = ('experienceLevel' | 'id' | 'otherAdministrativeGoals' | 'otherBusinessGoals' | 'otherClinicalGoals' | 'otherElements' | 'otherFacilityTypes' | 'otherHomeType' | 'otherSpaces' | 'otherWorkspaceType' | 'projectSize' | 'visualPreferences' | ProjectIndustryDetailsKeySpecifier)[];
export type ProjectIndustryDetailsFieldPolicy = {
	experienceLevel?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	otherAdministrativeGoals?: FieldPolicy<any> | FieldReadFunction<any>,
	otherBusinessGoals?: FieldPolicy<any> | FieldReadFunction<any>,
	otherClinicalGoals?: FieldPolicy<any> | FieldReadFunction<any>,
	otherElements?: FieldPolicy<any> | FieldReadFunction<any>,
	otherFacilityTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	otherHomeType?: FieldPolicy<any> | FieldReadFunction<any>,
	otherSpaces?: FieldPolicy<any> | FieldReadFunction<any>,
	otherWorkspaceType?: FieldPolicy<any> | FieldReadFunction<any>,
	projectSize?: FieldPolicy<any> | FieldReadFunction<any>,
	visualPreferences?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProjectRoleKeySpecifier = ('id' | 'name' | ProjectRoleKeySpecifier)[];
export type ProjectRoleFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProjectSizeKeySpecifier = ('other' | 'values' | ProjectSizeKeySpecifier)[];
export type ProjectSizeFieldPolicy = {
	other?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProjectsClientsSearchResultsKeySpecifier = ('clients' | 'projects' | ProjectsClientsSearchResultsKeySpecifier)[];
export type ProjectsClientsSearchResultsFieldPolicy = {
	clients?: FieldPolicy<any> | FieldReadFunction<any>,
	projects?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuantValuesSchemaKeySpecifier = ('amount' | 'other' | 'values' | QuantValuesSchemaKeySpecifier)[];
export type QuantValuesSchemaFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	other?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('currentUser' | 'getAllItemTemplates' | 'getAllSpaceTemplates' | 'getClient' | 'getCommentsBySpaceId' | 'getDisplayUser' | 'getDisplayUsersByUserIds' | 'getIndustry' | 'getItemTemplateById' | 'getItemTemplateCategories' | 'getNotifications' | 'getProject' | 'getProjectEstimates' | 'getSpaceById' | 'getTaskComments' | 'getTenantInfoByCode' | 'getTenantsInfo' | 'getTheoremUsers' | 'getUser' | 'getUsers' | 'getUsersByUserIds' | 'getUsersForProjectInvite' | 'listClients' | 'listFolioClients' | 'listIndustries' | 'listMemberClients' | 'listMembers' | 'listProjectServices' | 'listProjectSpaces' | 'listProjects' | 'listProjectsRoles' | 'listServicesTemplates' | 'listSpacesItemTemplates' | 'listSpacesTemplates' | 'listTemplateIndustries' | 'listUsersForProjectInvite' | 'predefinedTasklists' | 'searchProjectsClients' | 'sendParticipantProjectInvite' | 'sendWelcomeToFolioEmail' | 'tasklistsForProject' | 'viewProjectCount' | 'viewProjectInvitations' | 'viewUserInvitations' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	currentUser?: FieldPolicy<any> | FieldReadFunction<any>,
	getAllItemTemplates?: FieldPolicy<any> | FieldReadFunction<any>,
	getAllSpaceTemplates?: FieldPolicy<any> | FieldReadFunction<any>,
	getClient?: FieldPolicy<any> | FieldReadFunction<any>,
	getCommentsBySpaceId?: FieldPolicy<any> | FieldReadFunction<any>,
	getDisplayUser?: FieldPolicy<any> | FieldReadFunction<any>,
	getDisplayUsersByUserIds?: FieldPolicy<any> | FieldReadFunction<any>,
	getIndustry?: FieldPolicy<any> | FieldReadFunction<any>,
	getItemTemplateById?: FieldPolicy<any> | FieldReadFunction<any>,
	getItemTemplateCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	getNotifications?: FieldPolicy<any> | FieldReadFunction<any>,
	getProject?: FieldPolicy<any> | FieldReadFunction<any>,
	getProjectEstimates?: FieldPolicy<any> | FieldReadFunction<any>,
	getSpaceById?: FieldPolicy<any> | FieldReadFunction<any>,
	getTaskComments?: FieldPolicy<any> | FieldReadFunction<any>,
	getTenantInfoByCode?: FieldPolicy<any> | FieldReadFunction<any>,
	getTenantsInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	getTheoremUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	getUser?: FieldPolicy<any> | FieldReadFunction<any>,
	getUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	getUsersByUserIds?: FieldPolicy<any> | FieldReadFunction<any>,
	getUsersForProjectInvite?: FieldPolicy<any> | FieldReadFunction<any>,
	listClients?: FieldPolicy<any> | FieldReadFunction<any>,
	listFolioClients?: FieldPolicy<any> | FieldReadFunction<any>,
	listIndustries?: FieldPolicy<any> | FieldReadFunction<any>,
	listMemberClients?: FieldPolicy<any> | FieldReadFunction<any>,
	listMembers?: FieldPolicy<any> | FieldReadFunction<any>,
	listProjectServices?: FieldPolicy<any> | FieldReadFunction<any>,
	listProjectSpaces?: FieldPolicy<any> | FieldReadFunction<any>,
	listProjects?: FieldPolicy<any> | FieldReadFunction<any>,
	listProjectsRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	listServicesTemplates?: FieldPolicy<any> | FieldReadFunction<any>,
	listSpacesItemTemplates?: FieldPolicy<any> | FieldReadFunction<any>,
	listSpacesTemplates?: FieldPolicy<any> | FieldReadFunction<any>,
	listTemplateIndustries?: FieldPolicy<any> | FieldReadFunction<any>,
	listUsersForProjectInvite?: FieldPolicy<any> | FieldReadFunction<any>,
	predefinedTasklists?: FieldPolicy<any> | FieldReadFunction<any>,
	searchProjectsClients?: FieldPolicy<any> | FieldReadFunction<any>,
	sendParticipantProjectInvite?: FieldPolicy<any> | FieldReadFunction<any>,
	sendWelcomeToFolioEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	tasklistsForProject?: FieldPolicy<any> | FieldReadFunction<any>,
	viewProjectCount?: FieldPolicy<any> | FieldReadFunction<any>,
	viewProjectInvitations?: FieldPolicy<any> | FieldReadFunction<any>,
	viewUserInvitations?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RadioFieldKeySpecifier = ('name' | 'options' | 'type' | RadioFieldKeySpecifier)[];
export type RadioFieldFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SectionKeySpecifier = ('createUser' | 'createdBy' | 'createdOn' | 'id' | 'modifiedBy' | 'modifiedOn' | 'modifyUser' | 'name' | 'tasklist' | 'tasklistId' | 'tasks' | SectionKeySpecifier)[];
export type SectionFieldPolicy = {
	createUser?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdOn?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	modifyUser?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	tasklist?: FieldPolicy<any> | FieldReadFunction<any>,
	tasklistId?: FieldPolicy<any> | FieldReadFunction<any>,
	tasks?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServiceKeySpecifier = ('createdOn' | 'highEstimate' | 'id' | 'lowEstimate' | 'midEstimate' | 'modifiedOn' | 'percentage' | 'servicesTemplates' | ServiceKeySpecifier)[];
export type ServiceFieldPolicy = {
	createdOn?: FieldPolicy<any> | FieldReadFunction<any>,
	highEstimate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lowEstimate?: FieldPolicy<any> | FieldReadFunction<any>,
	midEstimate?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	percentage?: FieldPolicy<any> | FieldReadFunction<any>,
	servicesTemplates?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServiceTemplateKeySpecifier = ('description' | 'id' | 'name' | 'serviceId' | ServiceTemplateKeySpecifier)[];
export type ServiceTemplateFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SpaceKeySpecifier = ('createdOn' | 'description' | 'id' | 'image' | 'industry' | 'items' | 'list' | 'modifiedOn' | 'name' | 'quantity' | 'templateId' | SpaceKeySpecifier)[];
export type SpaceFieldPolicy = {
	createdOn?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	industry?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	list?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	templateId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SpaceCommentKeySpecifier = ('comment' | 'createdOn' | 'id' | 'spaceId' | 'userFirstName' | 'userLastName' | SpaceCommentKeySpecifier)[];
export type SpaceCommentFieldPolicy = {
	comment?: FieldPolicy<any> | FieldReadFunction<any>,
	createdOn?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	spaceId?: FieldPolicy<any> | FieldReadFunction<any>,
	userFirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	userLastName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SpaceItemKeySpecifier = ('category' | 'createdOn' | 'dragDropIndex' | 'highPrice' | 'id' | 'image' | 'itemTemplatesId' | 'lowPrice' | 'midPrice' | 'modifiedOn' | 'name' | 'quantity' | SpaceItemKeySpecifier)[];
export type SpaceItemFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	createdOn?: FieldPolicy<any> | FieldReadFunction<any>,
	dragDropIndex?: FieldPolicy<any> | FieldReadFunction<any>,
	highPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	itemTemplatesId?: FieldPolicy<any> | FieldReadFunction<any>,
	lowPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	midPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SpaceListKeySpecifier = ('index' | 'listNumber' | SpaceListKeySpecifier)[];
export type SpaceListFieldPolicy = {
	index?: FieldPolicy<any> | FieldReadFunction<any>,
	listNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SpaceTemplateKeySpecifier = ('createdOn' | 'description' | 'id' | 'image' | 'industry' | 'items' | 'modifiedOn' | 'name' | 'spaceId' | SpaceTemplateKeySpecifier)[];
export type SpaceTemplateFieldPolicy = {
	createdOn?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	industry?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	spaceId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SpacesItemTemplateKeySpecifier = ('itemTemplate' | 'itemsQuantity' | 'spacesTemplate' | SpacesItemTemplateKeySpecifier)[];
export type SpacesItemTemplateFieldPolicy = {
	itemTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	itemsQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	spacesTemplate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskKeySpecifier = ('assignedUser' | 'assignedUserId' | 'comments' | 'completedByUser' | 'completedByUserId' | 'completedDate' | 'createUser' | 'createdBy' | 'createdOn' | 'dueDate' | 'fields' | 'id' | 'modifiedBy' | 'modifiedOn' | 'modifyUser' | 'name' | 'numComments' | 'section' | 'sectionId' | 'taskAnswer' | 'taskTemplateId' | TaskKeySpecifier)[];
export type TaskFieldPolicy = {
	assignedUser?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	comments?: FieldPolicy<any> | FieldReadFunction<any>,
	completedByUser?: FieldPolicy<any> | FieldReadFunction<any>,
	completedByUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	completedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	createUser?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdOn?: FieldPolicy<any> | FieldReadFunction<any>,
	dueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	modifyUser?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	numComments?: FieldPolicy<any> | FieldReadFunction<any>,
	section?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionId?: FieldPolicy<any> | FieldReadFunction<any>,
	taskAnswer?: FieldPolicy<any> | FieldReadFunction<any>,
	taskTemplateId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskAnswerKeySpecifier = ('createUser' | 'createdBy' | 'createdOn' | 'id' | 'modifiedBy' | 'modifiedOn' | 'modifyUser' | 'task' | 'taskId' | 'values' | TaskAnswerKeySpecifier)[];
export type TaskAnswerFieldPolicy = {
	createUser?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdOn?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	modifyUser?: FieldPolicy<any> | FieldReadFunction<any>,
	task?: FieldPolicy<any> | FieldReadFunction<any>,
	taskId?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskCommentKeySpecifier = ('comment' | 'createUser' | 'createdBy' | 'createdOn' | 'id' | 'modifiedBy' | 'modifiedOn' | 'modifyUser' | 'tags' | 'task' | 'taskId' | TaskCommentKeySpecifier)[];
export type TaskCommentFieldPolicy = {
	comment?: FieldPolicy<any> | FieldReadFunction<any>,
	createUser?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdOn?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	modifyUser?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	task?: FieldPolicy<any> | FieldReadFunction<any>,
	taskId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskTagKeySpecifier = ('display' | 'userId' | TaskTagKeySpecifier)[];
export type TaskTagFieldPolicy = {
	display?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TasklistKeySpecifier = ('associatedObjectId' | 'createUser' | 'createdBy' | 'createdOn' | 'description' | 'dueDate' | 'id' | 'isArchived' | 'isVisible' | 'isVisibleChangedOn' | 'modifiedBy' | 'modifiedOn' | 'modifyUser' | 'name' | 'sections' | 'tasklistTemplateId' | 'tasklistUsers' | TasklistKeySpecifier)[];
export type TasklistFieldPolicy = {
	associatedObjectId?: FieldPolicy<any> | FieldReadFunction<any>,
	createUser?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdOn?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	dueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isArchived?: FieldPolicy<any> | FieldReadFunction<any>,
	isVisible?: FieldPolicy<any> | FieldReadFunction<any>,
	isVisibleChangedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	modifyUser?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	sections?: FieldPolicy<any> | FieldReadFunction<any>,
	tasklistTemplateId?: FieldPolicy<any> | FieldReadFunction<any>,
	tasklistUsers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TasklistTemplateListItemKeySpecifier = ('createdOn' | 'description' | 'modifiedOn' | 'name' | 'tasklistTemplateId' | TasklistTemplateListItemKeySpecifier)[];
export type TasklistTemplateListItemFieldPolicy = {
	createdOn?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	tasklistTemplateId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TasklistUserKeySpecifier = ('avatarUrl' | 'businessRole' | 'createUser' | 'createdBy' | 'createdOn' | 'firstName' | 'id' | 'lastName' | 'modifiedBy' | 'modifiedOn' | 'modifyUser' | 'tasklists' | 'userId' | TasklistUserKeySpecifier)[];
export type TasklistUserFieldPolicy = {
	avatarUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	businessRole?: FieldPolicy<any> | FieldReadFunction<any>,
	createUser?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdOn?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	modifyUser?: FieldPolicy<any> | FieldReadFunction<any>,
	tasklists?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantsDetailsKeySpecifier = ('code' | 'email' | 'id' | 'licenses' | 'tenantName' | 'used' | TenantsDetailsKeySpecifier)[];
export type TenantsDetailsFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	licenses?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantName?: FieldPolicy<any> | FieldReadFunction<any>,
	used?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TextFieldKeySpecifier = ('label' | 'name' | 'type' | TextFieldKeySpecifier)[];
export type TextFieldFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserKeySpecifier = ('avatarUrl' | 'businessRole' | 'email' | 'firstName' | 'id' | 'isTheoremAdmin' | 'lastName' | 'phone' | 'securityRoles' | 'status' | UserKeySpecifier)[];
export type UserFieldPolicy = {
	avatarUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	businessRole?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isTheoremAdmin?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	securityRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserSchemaKeySpecifier = ('avatarUrl' | 'businessRole' | 'email' | 'firstName' | 'id' | 'isTheoremAdmin' | 'lastName' | 'phone' | 'securityRoles' | 'status' | UserSchemaKeySpecifier)[];
export type UserSchemaFieldPolicy = {
	avatarUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	businessRole?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isTheoremAdmin?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	securityRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VisualPreferencesKeySpecifier = ('dislike' | 'id' | 'like' | 'url' | VisualPreferencesKeySpecifier)[];
export type VisualPreferencesFieldPolicy = {
	dislike?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	like?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	AreaField?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AreaFieldKeySpecifier | (() => undefined | AreaFieldKeySpecifier),
		fields?: AreaFieldFieldPolicy,
	},
	CheckboxField?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckboxFieldKeySpecifier | (() => undefined | CheckboxFieldKeySpecifier),
		fields?: CheckboxFieldFieldPolicy,
	},
	Client?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ClientKeySpecifier | (() => undefined | ClientKeySpecifier),
		fields?: ClientFieldPolicy,
	},
	DateField?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DateFieldKeySpecifier | (() => undefined | DateFieldKeySpecifier),
		fields?: DateFieldFieldPolicy,
	},
	DisplayUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisplayUserKeySpecifier | (() => undefined | DisplayUserKeySpecifier),
		fields?: DisplayUserFieldPolicy,
	},
	DisplayUserSchema?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisplayUserSchemaKeySpecifier | (() => undefined | DisplayUserSchemaKeySpecifier),
		fields?: DisplayUserSchemaFieldPolicy,
	},
	ExperienceLevel?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExperienceLevelKeySpecifier | (() => undefined | ExperienceLevelKeySpecifier),
		fields?: ExperienceLevelFieldPolicy,
	},
	FieldOption?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FieldOptionKeySpecifier | (() => undefined | FieldOptionKeySpecifier),
		fields?: FieldOptionFieldPolicy,
	},
	Industry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IndustryKeySpecifier | (() => undefined | IndustryKeySpecifier),
		fields?: IndustryFieldPolicy,
	},
	IndustryCover?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IndustryCoverKeySpecifier | (() => undefined | IndustryCoverKeySpecifier),
		fields?: IndustryCoverFieldPolicy,
	},
	Item?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ItemKeySpecifier | (() => undefined | ItemKeySpecifier),
		fields?: ItemFieldPolicy,
	},
	ItemCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ItemCategoryKeySpecifier | (() => undefined | ItemCategoryKeySpecifier),
		fields?: ItemCategoryFieldPolicy,
	},
	ItemTemplate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ItemTemplateKeySpecifier | (() => undefined | ItemTemplateKeySpecifier),
		fields?: ItemTemplateFieldPolicy,
	},
	Member?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MemberKeySpecifier | (() => undefined | MemberKeySpecifier),
		fields?: MemberFieldPolicy,
	},
	Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier),
		fields?: MutationFieldPolicy,
	},
	Notification?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationKeySpecifier | (() => undefined | NotificationKeySpecifier),
		fields?: NotificationFieldPolicy,
	},
	NotificationClient?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationClientKeySpecifier | (() => undefined | NotificationClientKeySpecifier),
		fields?: NotificationClientFieldPolicy,
	},
	NotificationDetail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationDetailKeySpecifier | (() => undefined | NotificationDetailKeySpecifier),
		fields?: NotificationDetailFieldPolicy,
	},
	NotificationProject?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationProjectKeySpecifier | (() => undefined | NotificationProjectKeySpecifier),
		fields?: NotificationProjectFieldPolicy,
	},
	NotificationSection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationSectionKeySpecifier | (() => undefined | NotificationSectionKeySpecifier),
		fields?: NotificationSectionFieldPolicy,
	},
	NotificationTask?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationTaskKeySpecifier | (() => undefined | NotificationTaskKeySpecifier),
		fields?: NotificationTaskFieldPolicy,
	},
	NotificationTaskComment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationTaskCommentKeySpecifier | (() => undefined | NotificationTaskCommentKeySpecifier),
		fields?: NotificationTaskCommentFieldPolicy,
	},
	NotificationTasklist?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationTasklistKeySpecifier | (() => undefined | NotificationTasklistKeySpecifier),
		fields?: NotificationTasklistFieldPolicy,
	},
	OtherAdministrativeGoals?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OtherAdministrativeGoalsKeySpecifier | (() => undefined | OtherAdministrativeGoalsKeySpecifier),
		fields?: OtherAdministrativeGoalsFieldPolicy,
	},
	OtherBusinessGoals?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OtherBusinessGoalsKeySpecifier | (() => undefined | OtherBusinessGoalsKeySpecifier),
		fields?: OtherBusinessGoalsFieldPolicy,
	},
	OtherClinicalGoals?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OtherClinicalGoalsKeySpecifier | (() => undefined | OtherClinicalGoalsKeySpecifier),
		fields?: OtherClinicalGoalsFieldPolicy,
	},
	OtherElements?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OtherElementsKeySpecifier | (() => undefined | OtherElementsKeySpecifier),
		fields?: OtherElementsFieldPolicy,
	},
	OtherFacilityTypes?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OtherFacilityTypesKeySpecifier | (() => undefined | OtherFacilityTypesKeySpecifier),
		fields?: OtherFacilityTypesFieldPolicy,
	},
	OtherHomeType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OtherHomeTypeKeySpecifier | (() => undefined | OtherHomeTypeKeySpecifier),
		fields?: OtherHomeTypeFieldPolicy,
	},
	OtherSpaces?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OtherSpacesKeySpecifier | (() => undefined | OtherSpacesKeySpecifier),
		fields?: OtherSpacesFieldPolicy,
	},
	OtherWorkspaceType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OtherWorkspaceTypeKeySpecifier | (() => undefined | OtherWorkspaceTypeKeySpecifier),
		fields?: OtherWorkspaceTypeFieldPolicy,
	},
	PinnedProject?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PinnedProjectKeySpecifier | (() => undefined | PinnedProjectKeySpecifier),
		fields?: PinnedProjectFieldPolicy,
	},
	Project?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProjectKeySpecifier | (() => undefined | ProjectKeySpecifier),
		fields?: ProjectFieldPolicy,
	},
	ProjectEstimate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProjectEstimateKeySpecifier | (() => undefined | ProjectEstimateKeySpecifier),
		fields?: ProjectEstimateFieldPolicy,
	},
	ProjectIndustryDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProjectIndustryDetailsKeySpecifier | (() => undefined | ProjectIndustryDetailsKeySpecifier),
		fields?: ProjectIndustryDetailsFieldPolicy,
	},
	ProjectRole?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProjectRoleKeySpecifier | (() => undefined | ProjectRoleKeySpecifier),
		fields?: ProjectRoleFieldPolicy,
	},
	ProjectSize?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProjectSizeKeySpecifier | (() => undefined | ProjectSizeKeySpecifier),
		fields?: ProjectSizeFieldPolicy,
	},
	ProjectsClientsSearchResults?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProjectsClientsSearchResultsKeySpecifier | (() => undefined | ProjectsClientsSearchResultsKeySpecifier),
		fields?: ProjectsClientsSearchResultsFieldPolicy,
	},
	QuantValuesSchema?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuantValuesSchemaKeySpecifier | (() => undefined | QuantValuesSchemaKeySpecifier),
		fields?: QuantValuesSchemaFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	RadioField?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RadioFieldKeySpecifier | (() => undefined | RadioFieldKeySpecifier),
		fields?: RadioFieldFieldPolicy,
	},
	Section?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SectionKeySpecifier | (() => undefined | SectionKeySpecifier),
		fields?: SectionFieldPolicy,
	},
	Service?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServiceKeySpecifier | (() => undefined | ServiceKeySpecifier),
		fields?: ServiceFieldPolicy,
	},
	ServiceTemplate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServiceTemplateKeySpecifier | (() => undefined | ServiceTemplateKeySpecifier),
		fields?: ServiceTemplateFieldPolicy,
	},
	Space?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SpaceKeySpecifier | (() => undefined | SpaceKeySpecifier),
		fields?: SpaceFieldPolicy,
	},
	SpaceComment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SpaceCommentKeySpecifier | (() => undefined | SpaceCommentKeySpecifier),
		fields?: SpaceCommentFieldPolicy,
	},
	SpaceItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SpaceItemKeySpecifier | (() => undefined | SpaceItemKeySpecifier),
		fields?: SpaceItemFieldPolicy,
	},
	SpaceList?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SpaceListKeySpecifier | (() => undefined | SpaceListKeySpecifier),
		fields?: SpaceListFieldPolicy,
	},
	SpaceTemplate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SpaceTemplateKeySpecifier | (() => undefined | SpaceTemplateKeySpecifier),
		fields?: SpaceTemplateFieldPolicy,
	},
	SpacesItemTemplate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SpacesItemTemplateKeySpecifier | (() => undefined | SpacesItemTemplateKeySpecifier),
		fields?: SpacesItemTemplateFieldPolicy,
	},
	Task?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskKeySpecifier | (() => undefined | TaskKeySpecifier),
		fields?: TaskFieldPolicy,
	},
	TaskAnswer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskAnswerKeySpecifier | (() => undefined | TaskAnswerKeySpecifier),
		fields?: TaskAnswerFieldPolicy,
	},
	TaskComment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskCommentKeySpecifier | (() => undefined | TaskCommentKeySpecifier),
		fields?: TaskCommentFieldPolicy,
	},
	TaskTag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskTagKeySpecifier | (() => undefined | TaskTagKeySpecifier),
		fields?: TaskTagFieldPolicy,
	},
	Tasklist?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TasklistKeySpecifier | (() => undefined | TasklistKeySpecifier),
		fields?: TasklistFieldPolicy,
	},
	TasklistTemplateListItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TasklistTemplateListItemKeySpecifier | (() => undefined | TasklistTemplateListItemKeySpecifier),
		fields?: TasklistTemplateListItemFieldPolicy,
	},
	TasklistUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TasklistUserKeySpecifier | (() => undefined | TasklistUserKeySpecifier),
		fields?: TasklistUserFieldPolicy,
	},
	TenantsDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantsDetailsKeySpecifier | (() => undefined | TenantsDetailsKeySpecifier),
		fields?: TenantsDetailsFieldPolicy,
	},
	TextField?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TextFieldKeySpecifier | (() => undefined | TextFieldKeySpecifier),
		fields?: TextFieldFieldPolicy,
	},
	User?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserKeySpecifier | (() => undefined | UserKeySpecifier),
		fields?: UserFieldPolicy,
	},
	UserSchema?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserSchemaKeySpecifier | (() => undefined | UserSchemaKeySpecifier),
		fields?: UserSchemaFieldPolicy,
	},
	VisualPreferences?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VisualPreferencesKeySpecifier | (() => undefined | VisualPreferencesKeySpecifier),
		fields?: VisualPreferencesFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;

export const ListIndustriesDocument = gql`
    query ListIndustries {
  listIndustries {
    id
    name
    covers {
      id
      url
    }
  }
}
    `;

/**
 * __useListIndustriesQuery__
 *
 * To run a query within a React component, call `useListIndustriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListIndustriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListIndustriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListIndustriesQuery(baseOptions?: Apollo.QueryHookOptions<ListIndustriesQuery, ListIndustriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListIndustriesQuery, ListIndustriesQueryVariables>(ListIndustriesDocument, options);
      }
export function useListIndustriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListIndustriesQuery, ListIndustriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListIndustriesQuery, ListIndustriesQueryVariables>(ListIndustriesDocument, options);
        }
export type ListIndustriesQueryHookResult = ReturnType<typeof useListIndustriesQuery>;
export type ListIndustriesLazyQueryHookResult = ReturnType<typeof useListIndustriesLazyQuery>;
export type ListIndustriesQueryResult = Apollo.QueryResult<ListIndustriesQuery, ListIndustriesQueryVariables>;
export const CreateNotificationDocument = gql`
    mutation createNotification($input: NotificationInput!) {
  createNotification(input: $input) {
    id
    type
    fromUserId
    toUserId
    taskId
    taskCommentId
    sectionId
    tasklistId
    projectId
  }
}
    `;
export type CreateNotificationMutationFn = Apollo.MutationFunction<CreateNotificationMutation, CreateNotificationMutationVariables>;

/**
 * __useCreateNotificationMutation__
 *
 * To run a mutation, you first call `useCreateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationMutation, { data, loading, error }] = useCreateNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNotificationMutation(baseOptions?: Apollo.MutationHookOptions<CreateNotificationMutation, CreateNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNotificationMutation, CreateNotificationMutationVariables>(CreateNotificationDocument, options);
      }
export type CreateNotificationMutationHookResult = ReturnType<typeof useCreateNotificationMutation>;
export type CreateNotificationMutationResult = Apollo.MutationResult<CreateNotificationMutation>;
export type CreateNotificationMutationOptions = Apollo.BaseMutationOptions<CreateNotificationMutation, CreateNotificationMutationVariables>;
export const DeleteNotificationDocument = gql`
    mutation DeleteNotification($id: ID!) {
  deleteNotification(id: $id)
}
    `;
export type DeleteNotificationMutationFn = Apollo.MutationFunction<DeleteNotificationMutation, DeleteNotificationMutationVariables>;

/**
 * __useDeleteNotificationMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationMutation, { data, loading, error }] = useDeleteNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNotificationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNotificationMutation, DeleteNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNotificationMutation, DeleteNotificationMutationVariables>(DeleteNotificationDocument, options);
      }
export type DeleteNotificationMutationHookResult = ReturnType<typeof useDeleteNotificationMutation>;
export type DeleteNotificationMutationResult = Apollo.MutationResult<DeleteNotificationMutation>;
export type DeleteNotificationMutationOptions = Apollo.BaseMutationOptions<DeleteNotificationMutation, DeleteNotificationMutationVariables>;
export const GetNotificationsDocument = gql`
    query GetNotifications {
  getNotifications {
    id
    type
    fromUser {
      id
      firstName
      lastName
    }
    toUserId
    date
    project {
      id
      name
      client {
        id
        name
      }
    }
    tasklist {
      id
      name
      description
      dueDate
      section {
        id
        task {
          id
          name
          completedDate
          dueDate
          comment {
            id
            comment
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const AcceptProjectInvitationDocument = gql`
    mutation AcceptProjectInvitation($projectId: ID!, $tenant: TenantsDetailsInput) {
  acceptInvitation(input: {projectId: $projectId, tenant: $tenant})
}
    `;
export type AcceptProjectInvitationMutationFn = Apollo.MutationFunction<AcceptProjectInvitationMutation, AcceptProjectInvitationMutationVariables>;

/**
 * __useAcceptProjectInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptProjectInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptProjectInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptProjectInvitationMutation, { data, loading, error }] = useAcceptProjectInvitationMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useAcceptProjectInvitationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptProjectInvitationMutation, AcceptProjectInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptProjectInvitationMutation, AcceptProjectInvitationMutationVariables>(AcceptProjectInvitationDocument, options);
      }
export type AcceptProjectInvitationMutationHookResult = ReturnType<typeof useAcceptProjectInvitationMutation>;
export type AcceptProjectInvitationMutationResult = Apollo.MutationResult<AcceptProjectInvitationMutation>;
export type AcceptProjectInvitationMutationOptions = Apollo.BaseMutationOptions<AcceptProjectInvitationMutation, AcceptProjectInvitationMutationVariables>;
export const AddClientDocument = gql`
    mutation AddClient($clientInfo: ClientInput!) {
  createClient(clientInfo: $clientInfo) {
    id
    name
  }
}
    `;
export type AddClientMutationFn = Apollo.MutationFunction<AddClientMutation, AddClientMutationVariables>;

/**
 * __useAddClientMutation__
 *
 * To run a mutation, you first call `useAddClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addClientMutation, { data, loading, error }] = useAddClientMutation({
 *   variables: {
 *      clientInfo: // value for 'clientInfo'
 *   },
 * });
 */
export function useAddClientMutation(baseOptions?: Apollo.MutationHookOptions<AddClientMutation, AddClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddClientMutation, AddClientMutationVariables>(AddClientDocument, options);
      }
export type AddClientMutationHookResult = ReturnType<typeof useAddClientMutation>;
export type AddClientMutationResult = Apollo.MutationResult<AddClientMutation>;
export type AddClientMutationOptions = Apollo.BaseMutationOptions<AddClientMutation, AddClientMutationVariables>;
export const AddProjectDocument = gql`
    mutation AddProject($input: ProjectInput!) {
  createProject(input: $input) {
    id
    name
    coverImageUrl
    members {
      firstName
      lastName
      avatarUrl
      id
    }
    industry {
      name
    }
    industryDetails {
      id
      visualPreferences {
        url
        id
        like
        dislike
      }
      otherBusinessGoals {
        other
        values
      }
      otherSpaces {
        other
        quantValues {
          amount
          values
        }
        quantities
        values
      }
      otherFacilityTypes {
        other
        values
      }
      otherAdministrativeGoals {
        other
        values
      }
      otherClinicalGoals {
        other
        values
      }
      otherHomeType {
        other
        values
      }
      otherWorkspaceType {
        other
        values
      }
      otherElements {
        other
        values
      }
      projectSize {
        other
        values
      }
      experienceLevel {
        other
        values
      }
    }
    client {
      id
    }
  }
}
    `;
export type AddProjectMutationFn = Apollo.MutationFunction<AddProjectMutation, AddProjectMutationVariables>;

/**
 * __useAddProjectMutation__
 *
 * To run a mutation, you first call `useAddProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectMutation, { data, loading, error }] = useAddProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProjectMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectMutation, AddProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectMutation, AddProjectMutationVariables>(AddProjectDocument, options);
      }
export type AddProjectMutationHookResult = ReturnType<typeof useAddProjectMutation>;
export type AddProjectMutationResult = Apollo.MutationResult<AddProjectMutation>;
export type AddProjectMutationOptions = Apollo.BaseMutationOptions<AddProjectMutation, AddProjectMutationVariables>;
export const DeleteClientDocument = gql`
    mutation DeleteClient($id: ID!) {
  deleteClient(id: $id)
}
    `;
export type DeleteClientMutationFn = Apollo.MutationFunction<DeleteClientMutation, DeleteClientMutationVariables>;

/**
 * __useDeleteClientMutation__
 *
 * To run a mutation, you first call `useDeleteClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientMutation, { data, loading, error }] = useDeleteClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClientMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientMutation, DeleteClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientMutation, DeleteClientMutationVariables>(DeleteClientDocument, options);
      }
export type DeleteClientMutationHookResult = ReturnType<typeof useDeleteClientMutation>;
export type DeleteClientMutationResult = Apollo.MutationResult<DeleteClientMutation>;
export type DeleteClientMutationOptions = Apollo.BaseMutationOptions<DeleteClientMutation, DeleteClientMutationVariables>;
export const DeleteMemberDocument = gql`
    mutation DeleteMember($input: DeleteProjectMemberInput!) {
  deleteMember(input: $input)
}
    `;
export type DeleteMemberMutationFn = Apollo.MutationFunction<DeleteMemberMutation, DeleteMemberMutationVariables>;

/**
 * __useDeleteMemberMutation__
 *
 * To run a mutation, you first call `useDeleteMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMemberMutation, { data, loading, error }] = useDeleteMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMemberMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMemberMutation, DeleteMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMemberMutation, DeleteMemberMutationVariables>(DeleteMemberDocument, options);
      }
export type DeleteMemberMutationHookResult = ReturnType<typeof useDeleteMemberMutation>;
export type DeleteMemberMutationResult = Apollo.MutationResult<DeleteMemberMutation>;
export type DeleteMemberMutationOptions = Apollo.BaseMutationOptions<DeleteMemberMutation, DeleteMemberMutationVariables>;
export const DeleteProjectDocument = gql`
    mutation DeleteProject($id: ID!) {
  deleteProject(id: $id)
}
    `;
export type DeleteProjectMutationFn = Apollo.MutationFunction<DeleteProjectMutation, DeleteProjectMutationVariables>;

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectMutation, DeleteProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectMutation, DeleteProjectMutationVariables>(DeleteProjectDocument, options);
      }
export type DeleteProjectMutationHookResult = ReturnType<typeof useDeleteProjectMutation>;
export type DeleteProjectMutationResult = Apollo.MutationResult<DeleteProjectMutation>;
export type DeleteProjectMutationOptions = Apollo.BaseMutationOptions<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const DenyProjectInvitationDocument = gql`
    mutation DenyProjectInvitation($projectId: ID!) {
  denyInvitation(input: {projectId: $projectId})
}
    `;
export type DenyProjectInvitationMutationFn = Apollo.MutationFunction<DenyProjectInvitationMutation, DenyProjectInvitationMutationVariables>;

/**
 * __useDenyProjectInvitationMutation__
 *
 * To run a mutation, you first call `useDenyProjectInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDenyProjectInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [denyProjectInvitationMutation, { data, loading, error }] = useDenyProjectInvitationMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDenyProjectInvitationMutation(baseOptions?: Apollo.MutationHookOptions<DenyProjectInvitationMutation, DenyProjectInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DenyProjectInvitationMutation, DenyProjectInvitationMutationVariables>(DenyProjectInvitationDocument, options);
      }
export type DenyProjectInvitationMutationHookResult = ReturnType<typeof useDenyProjectInvitationMutation>;
export type DenyProjectInvitationMutationResult = Apollo.MutationResult<DenyProjectInvitationMutation>;
export type DenyProjectInvitationMutationOptions = Apollo.BaseMutationOptions<DenyProjectInvitationMutation, DenyProjectInvitationMutationVariables>;
export const ListFolioClientsDocument = gql`
    query ListFolioClients {
  listFolioClients {
    id
    name
    logoUrl
    createdOn
    createdBy {
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useListFolioClientsQuery__
 *
 * To run a query within a React component, call `useListFolioClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFolioClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFolioClientsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListFolioClientsQuery(baseOptions?: Apollo.QueryHookOptions<ListFolioClientsQuery, ListFolioClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListFolioClientsQuery, ListFolioClientsQueryVariables>(ListFolioClientsDocument, options);
      }
export function useListFolioClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListFolioClientsQuery, ListFolioClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListFolioClientsQuery, ListFolioClientsQueryVariables>(ListFolioClientsDocument, options);
        }
export type ListFolioClientsQueryHookResult = ReturnType<typeof useListFolioClientsQuery>;
export type ListFolioClientsLazyQueryHookResult = ReturnType<typeof useListFolioClientsLazyQuery>;
export type ListFolioClientsQueryResult = Apollo.QueryResult<ListFolioClientsQuery, ListFolioClientsQueryVariables>;
export const GetClientDocument = gql`
    query GetClient($id: ID!) {
  getClient(id: $id) {
    id
    name
    logoUrl
    industries {
      name
      id
    }
    projects {
      id
      name
      coverImageUrl
      isPinned
      members {
        avatarUrl
        id
        firstName
        lastName
      }
      industry {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetClientQuery__
 *
 * To run a query within a React component, call `useGetClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientQuery(baseOptions: Apollo.QueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
      }
export function useGetClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
        }
export type GetClientQueryHookResult = ReturnType<typeof useGetClientQuery>;
export type GetClientLazyQueryHookResult = ReturnType<typeof useGetClientLazyQuery>;
export type GetClientQueryResult = Apollo.QueryResult<GetClientQuery, GetClientQueryVariables>;
export const GetProjectDocument = gql`
    query GetProject($id: ID!) {
  getProject(id: $id) {
    id
    name
    coverImageUrl
    stage
    budget
    headCount
    squareFootage
    moveInDate
    buildingsQty
    discountPercentage
    increasePercentage
    assignedTasklistsCount
    projectEstimate {
      lowPrice
      highPrice
    }
    client {
      id
      name
    }
    industry {
      id
      name
      covers {
        id
        url
      }
    }
    industryDetails {
      id
      visualPreferences {
        url
        id
        like
        dislike
      }
      otherBusinessGoals {
        other
        values
      }
      otherSpaces {
        other
        quantValues {
          amount
          values
          other
        }
        values
      }
      otherFacilityTypes {
        other
        values
      }
      otherAdministrativeGoals {
        other
        values
      }
      otherClinicalGoals {
        other
        values
      }
      otherHomeType {
        other
        values
      }
      otherWorkspaceType {
        other
        values
      }
      otherElements {
        other
        values
      }
      projectSize {
        other
        values
      }
      experienceLevel {
        other
        values
      }
    }
    members {
      id
      firstName
      lastName
      email
      avatarUrl
      status
      role {
        id
        name
      }
      phoneNumber
      businessRole
    }
    companyName
  }
}
    `;

/**
 * __useGetProjectQuery__
 *
 * To run a query within a React component, call `useGetProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectQuery(baseOptions: Apollo.QueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
      }
export function useGetProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
        }
export type GetProjectQueryHookResult = ReturnType<typeof useGetProjectQuery>;
export type GetProjectLazyQueryHookResult = ReturnType<typeof useGetProjectLazyQuery>;
export type GetProjectQueryResult = Apollo.QueryResult<GetProjectQuery, GetProjectQueryVariables>;
export const GetProjectEstimatesDocument = gql`
    query GetProjectEstimates($id: ID!) {
  getProjectEstimates(id: $id) {
    antiPricePercentHigh
    antiPricePercentLow
    antiPricePercentMid
    lowPrice
    midPrice
    highPrice
    lowServiceEstimate
    midServiceEstimate
    highServiceEstimate
    installPercentLow
    installPercentMid
    installPercentHigh
    freightPercentLow
    freightPercentMid
    freightPercentHigh
    productTaxPercentHigh
    productTaxPercentLow
    productTaxPercentMid
    serviceTaxPercentHigh
    serviceTaxPercentLow
    serviceTaxPercentMid
    totalTaxPercentHigh
    totalTaxPercentLow
    totalTaxPercentMid
  }
}
    `;

/**
 * __useGetProjectEstimatesQuery__
 *
 * To run a query within a React component, call `useGetProjectEstimatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectEstimatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectEstimatesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectEstimatesQuery(baseOptions: Apollo.QueryHookOptions<GetProjectEstimatesQuery, GetProjectEstimatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectEstimatesQuery, GetProjectEstimatesQueryVariables>(GetProjectEstimatesDocument, options);
      }
export function useGetProjectEstimatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectEstimatesQuery, GetProjectEstimatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectEstimatesQuery, GetProjectEstimatesQueryVariables>(GetProjectEstimatesDocument, options);
        }
export type GetProjectEstimatesQueryHookResult = ReturnType<typeof useGetProjectEstimatesQuery>;
export type GetProjectEstimatesLazyQueryHookResult = ReturnType<typeof useGetProjectEstimatesLazyQuery>;
export type GetProjectEstimatesQueryResult = Apollo.QueryResult<GetProjectEstimatesQuery, GetProjectEstimatesQueryVariables>;
export const ListProjectsRolesDocument = gql`
    query ListProjectsRoles {
  listProjectsRoles {
    id
    name
  }
}
    `;

/**
 * __useListProjectsRolesQuery__
 *
 * To run a query within a React component, call `useListProjectsRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProjectsRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProjectsRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListProjectsRolesQuery(baseOptions?: Apollo.QueryHookOptions<ListProjectsRolesQuery, ListProjectsRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProjectsRolesQuery, ListProjectsRolesQueryVariables>(ListProjectsRolesDocument, options);
      }
export function useListProjectsRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProjectsRolesQuery, ListProjectsRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProjectsRolesQuery, ListProjectsRolesQueryVariables>(ListProjectsRolesDocument, options);
        }
export type ListProjectsRolesQueryHookResult = ReturnType<typeof useListProjectsRolesQuery>;
export type ListProjectsRolesLazyQueryHookResult = ReturnType<typeof useListProjectsRolesLazyQuery>;
export type ListProjectsRolesQueryResult = Apollo.QueryResult<ListProjectsRolesQuery, ListProjectsRolesQueryVariables>;
export const ListProjectSpacesDocument = gql`
    query ListProjectSpaces($id: ID!) {
  listProjectSpaces(id: $id) {
    id
    name
    list {
      index
      listNumber
    }
    description
    templateId
    industry {
      id
      name
    }
    image
    quantity
    items {
      id
      name
      category {
        id
        name
      }
      quantity
      lowPrice
      midPrice
      highPrice
      image
      itemTemplatesId
      dragDropIndex
    }
  }
}
    `;

/**
 * __useListProjectSpacesQuery__
 *
 * To run a query within a React component, call `useListProjectSpacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProjectSpacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProjectSpacesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListProjectSpacesQuery(baseOptions: Apollo.QueryHookOptions<ListProjectSpacesQuery, ListProjectSpacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProjectSpacesQuery, ListProjectSpacesQueryVariables>(ListProjectSpacesDocument, options);
      }
export function useListProjectSpacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProjectSpacesQuery, ListProjectSpacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProjectSpacesQuery, ListProjectSpacesQueryVariables>(ListProjectSpacesDocument, options);
        }
export type ListProjectSpacesQueryHookResult = ReturnType<typeof useListProjectSpacesQuery>;
export type ListProjectSpacesLazyQueryHookResult = ReturnType<typeof useListProjectSpacesLazyQuery>;
export type ListProjectSpacesQueryResult = Apollo.QueryResult<ListProjectSpacesQuery, ListProjectSpacesQueryVariables>;
export const GetUsersForProjectInviteDocument = gql`
    query GetUsersForProjectInvite {
  getUsersForProjectInvite {
    id
    firstName
    lastName
    phone
    email
    status
    businessRole
    securityRoles
  }
}
    `;

/**
 * __useGetUsersForProjectInviteQuery__
 *
 * To run a query within a React component, call `useGetUsersForProjectInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersForProjectInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersForProjectInviteQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersForProjectInviteQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersForProjectInviteQuery, GetUsersForProjectInviteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersForProjectInviteQuery, GetUsersForProjectInviteQueryVariables>(GetUsersForProjectInviteDocument, options);
      }
export function useGetUsersForProjectInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersForProjectInviteQuery, GetUsersForProjectInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersForProjectInviteQuery, GetUsersForProjectInviteQueryVariables>(GetUsersForProjectInviteDocument, options);
        }
export type GetUsersForProjectInviteQueryHookResult = ReturnType<typeof useGetUsersForProjectInviteQuery>;
export type GetUsersForProjectInviteLazyQueryHookResult = ReturnType<typeof useGetUsersForProjectInviteLazyQuery>;
export type GetUsersForProjectInviteQueryResult = Apollo.QueryResult<GetUsersForProjectInviteQuery, GetUsersForProjectInviteQueryVariables>;
export const InviteCollaboratorsToFolioDocument = gql`
    mutation inviteCollaboratorsToFolio($collaborators: [CollaboratorInformation!]!, $tenant: TenantDetailsInput!) {
  inviteCollaboratorsToFolio(collaborators: $collaborators, tenant: $tenant)
}
    `;
export type InviteCollaboratorsToFolioMutationFn = Apollo.MutationFunction<InviteCollaboratorsToFolioMutation, InviteCollaboratorsToFolioMutationVariables>;

/**
 * __useInviteCollaboratorsToFolioMutation__
 *
 * To run a mutation, you first call `useInviteCollaboratorsToFolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteCollaboratorsToFolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteCollaboratorsToFolioMutation, { data, loading, error }] = useInviteCollaboratorsToFolioMutation({
 *   variables: {
 *      collaborators: // value for 'collaborators'
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useInviteCollaboratorsToFolioMutation(baseOptions?: Apollo.MutationHookOptions<InviteCollaboratorsToFolioMutation, InviteCollaboratorsToFolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteCollaboratorsToFolioMutation, InviteCollaboratorsToFolioMutationVariables>(InviteCollaboratorsToFolioDocument, options);
      }
export type InviteCollaboratorsToFolioMutationHookResult = ReturnType<typeof useInviteCollaboratorsToFolioMutation>;
export type InviteCollaboratorsToFolioMutationResult = Apollo.MutationResult<InviteCollaboratorsToFolioMutation>;
export type InviteCollaboratorsToFolioMutationOptions = Apollo.BaseMutationOptions<InviteCollaboratorsToFolioMutation, InviteCollaboratorsToFolioMutationVariables>;
export const InviteCollaboratorsDocument = gql`
    mutation inviteCollaborators($input: InviteProjectCollaboratorsListInput!) {
  inviteCollaborators(input: $input)
}
    `;
export type InviteCollaboratorsMutationFn = Apollo.MutationFunction<InviteCollaboratorsMutation, InviteCollaboratorsMutationVariables>;

/**
 * __useInviteCollaboratorsMutation__
 *
 * To run a mutation, you first call `useInviteCollaboratorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteCollaboratorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteCollaboratorsMutation, { data, loading, error }] = useInviteCollaboratorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteCollaboratorsMutation(baseOptions?: Apollo.MutationHookOptions<InviteCollaboratorsMutation, InviteCollaboratorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteCollaboratorsMutation, InviteCollaboratorsMutationVariables>(InviteCollaboratorsDocument, options);
      }
export type InviteCollaboratorsMutationHookResult = ReturnType<typeof useInviteCollaboratorsMutation>;
export type InviteCollaboratorsMutationResult = Apollo.MutationResult<InviteCollaboratorsMutation>;
export type InviteCollaboratorsMutationOptions = Apollo.BaseMutationOptions<InviteCollaboratorsMutation, InviteCollaboratorsMutationVariables>;
export const InviteMembersDocument = gql`
    mutation inviteMembers($input: InviteProjectMembersListInput!) {
  inviteMembers(input: $input)
}
    `;
export type InviteMembersMutationFn = Apollo.MutationFunction<InviteMembersMutation, InviteMembersMutationVariables>;

/**
 * __useInviteMembersMutation__
 *
 * To run a mutation, you first call `useInviteMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteMembersMutation, { data, loading, error }] = useInviteMembersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteMembersMutation(baseOptions?: Apollo.MutationHookOptions<InviteMembersMutation, InviteMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteMembersMutation, InviteMembersMutationVariables>(InviteMembersDocument, options);
      }
export type InviteMembersMutationHookResult = ReturnType<typeof useInviteMembersMutation>;
export type InviteMembersMutationResult = Apollo.MutationResult<InviteMembersMutation>;
export type InviteMembersMutationOptions = Apollo.BaseMutationOptions<InviteMembersMutation, InviteMembersMutationVariables>;
export const LoadClientsAndProjectsDocument = gql`
    query LoadClientsAndProjects($industriesIds: [ID!], $memberIds: [ID!], $startDate: DateTime, $endDate: DateTime) {
  listMemberClients(
    filters: {industriesIds: $industriesIds, memberIds: $memberIds, moveInDateRange: {start: $startDate, end: $endDate}}
  ) {
    id
    name
    logoUrl
    createdOn
    createdBy {
      firstName
      lastName
    }
    industries {
      name
    }
    projects {
      id
      name
      isPinned
      datePinned
      coverImageUrl
      members {
        firstName
        lastName
        avatarUrl
        id
        role {
          id
          name
        }
      }
      industry {
        name
      }
      industryDetails {
        id
        visualPreferences {
          url
          id
          like
          dislike
        }
        otherBusinessGoals {
          other
          values
        }
        otherSpaces {
          other
          quantValues {
            other
            amount
            values
          }
          values
        }
        otherFacilityTypes {
          other
          values
        }
        otherAdministrativeGoals {
          other
          values
        }
        otherClinicalGoals {
          other
          values
        }
        otherHomeType {
          other
          values
        }
        otherWorkspaceType {
          other
          values
        }
        otherElements {
          other
          values
        }
        projectSize {
          other
          values
        }
        experienceLevel {
          other
          values
        }
      }
      companyName
    }
  }
}
    `;

/**
 * __useLoadClientsAndProjectsQuery__
 *
 * To run a query within a React component, call `useLoadClientsAndProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadClientsAndProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadClientsAndProjectsQuery({
 *   variables: {
 *      industriesIds: // value for 'industriesIds'
 *      memberIds: // value for 'memberIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useLoadClientsAndProjectsQuery(baseOptions?: Apollo.QueryHookOptions<LoadClientsAndProjectsQuery, LoadClientsAndProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadClientsAndProjectsQuery, LoadClientsAndProjectsQueryVariables>(LoadClientsAndProjectsDocument, options);
      }
export function useLoadClientsAndProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadClientsAndProjectsQuery, LoadClientsAndProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadClientsAndProjectsQuery, LoadClientsAndProjectsQueryVariables>(LoadClientsAndProjectsDocument, options);
        }
export type LoadClientsAndProjectsQueryHookResult = ReturnType<typeof useLoadClientsAndProjectsQuery>;
export type LoadClientsAndProjectsLazyQueryHookResult = ReturnType<typeof useLoadClientsAndProjectsLazyQuery>;
export type LoadClientsAndProjectsQueryResult = Apollo.QueryResult<LoadClientsAndProjectsQuery, LoadClientsAndProjectsQueryVariables>;
export const ResendInvitationDocument = gql`
    mutation ResendInvitation($input: ResendProjectMemberInvitationInput!) {
  resendInvitation(input: $input)
}
    `;
export type ResendInvitationMutationFn = Apollo.MutationFunction<ResendInvitationMutation, ResendInvitationMutationVariables>;

/**
 * __useResendInvitationMutation__
 *
 * To run a mutation, you first call `useResendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInvitationMutation, { data, loading, error }] = useResendInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendInvitationMutation(baseOptions?: Apollo.MutationHookOptions<ResendInvitationMutation, ResendInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendInvitationMutation, ResendInvitationMutationVariables>(ResendInvitationDocument, options);
      }
export type ResendInvitationMutationHookResult = ReturnType<typeof useResendInvitationMutation>;
export type ResendInvitationMutationResult = Apollo.MutationResult<ResendInvitationMutation>;
export type ResendInvitationMutationOptions = Apollo.BaseMutationOptions<ResendInvitationMutation, ResendInvitationMutationVariables>;
export const SearchClientsAndProjectsDocument = gql`
    query SearchClientsAndProjects($fragment: String!) {
  searchProjectsClients(fragment: $fragment) {
    clients {
      id
      name
    }
    projects {
      id
      name
    }
  }
}
    `;

/**
 * __useSearchClientsAndProjectsQuery__
 *
 * To run a query within a React component, call `useSearchClientsAndProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchClientsAndProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchClientsAndProjectsQuery({
 *   variables: {
 *      fragment: // value for 'fragment'
 *   },
 * });
 */
export function useSearchClientsAndProjectsQuery(baseOptions: Apollo.QueryHookOptions<SearchClientsAndProjectsQuery, SearchClientsAndProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchClientsAndProjectsQuery, SearchClientsAndProjectsQueryVariables>(SearchClientsAndProjectsDocument, options);
      }
export function useSearchClientsAndProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchClientsAndProjectsQuery, SearchClientsAndProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchClientsAndProjectsQuery, SearchClientsAndProjectsQueryVariables>(SearchClientsAndProjectsDocument, options);
        }
export type SearchClientsAndProjectsQueryHookResult = ReturnType<typeof useSearchClientsAndProjectsQuery>;
export type SearchClientsAndProjectsLazyQueryHookResult = ReturnType<typeof useSearchClientsAndProjectsLazyQuery>;
export type SearchClientsAndProjectsQueryResult = Apollo.QueryResult<SearchClientsAndProjectsQuery, SearchClientsAndProjectsQueryVariables>;
export const SendWelcomeToFolioDocument = gql`
    query sendWelcomeToFolio($userId: String!, $projectId: String!) {
  sendWelcomeToFolioEmail(userId: $userId, projectId: $projectId)
}
    `;

/**
 * __useSendWelcomeToFolioQuery__
 *
 * To run a query within a React component, call `useSendWelcomeToFolioQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendWelcomeToFolioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendWelcomeToFolioQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSendWelcomeToFolioQuery(baseOptions: Apollo.QueryHookOptions<SendWelcomeToFolioQuery, SendWelcomeToFolioQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SendWelcomeToFolioQuery, SendWelcomeToFolioQueryVariables>(SendWelcomeToFolioDocument, options);
      }
export function useSendWelcomeToFolioLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SendWelcomeToFolioQuery, SendWelcomeToFolioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SendWelcomeToFolioQuery, SendWelcomeToFolioQueryVariables>(SendWelcomeToFolioDocument, options);
        }
export type SendWelcomeToFolioQueryHookResult = ReturnType<typeof useSendWelcomeToFolioQuery>;
export type SendWelcomeToFolioLazyQueryHookResult = ReturnType<typeof useSendWelcomeToFolioLazyQuery>;
export type SendWelcomeToFolioQueryResult = Apollo.QueryResult<SendWelcomeToFolioQuery, SendWelcomeToFolioQueryVariables>;
export const SetProjectPinDocument = gql`
    mutation SetProjectPin($pinProjectInfo: PinProjectInput!) {
  pinProject(pinProjectInfo: $pinProjectInfo) {
    userId
  }
}
    `;
export type SetProjectPinMutationFn = Apollo.MutationFunction<SetProjectPinMutation, SetProjectPinMutationVariables>;

/**
 * __useSetProjectPinMutation__
 *
 * To run a mutation, you first call `useSetProjectPinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProjectPinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProjectPinMutation, { data, loading, error }] = useSetProjectPinMutation({
 *   variables: {
 *      pinProjectInfo: // value for 'pinProjectInfo'
 *   },
 * });
 */
export function useSetProjectPinMutation(baseOptions?: Apollo.MutationHookOptions<SetProjectPinMutation, SetProjectPinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProjectPinMutation, SetProjectPinMutationVariables>(SetProjectPinDocument, options);
      }
export type SetProjectPinMutationHookResult = ReturnType<typeof useSetProjectPinMutation>;
export type SetProjectPinMutationResult = Apollo.MutationResult<SetProjectPinMutation>;
export type SetProjectPinMutationOptions = Apollo.BaseMutationOptions<SetProjectPinMutation, SetProjectPinMutationVariables>;
export const UpdateOtherSpacesDocument = gql`
    mutation UpdateOtherSpaces($input: OtherSpacesInput!, $id: ID!) {
  updateOtherSpaces(input: $input, projectId: $id) {
    industryDetails {
      otherSpaces {
        other
        quantValues {
          other
          amount
          values
        }
        values
      }
    }
  }
}
    `;
export type UpdateOtherSpacesMutationFn = Apollo.MutationFunction<UpdateOtherSpacesMutation, UpdateOtherSpacesMutationVariables>;

/**
 * __useUpdateOtherSpacesMutation__
 *
 * To run a mutation, you first call `useUpdateOtherSpacesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOtherSpacesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOtherSpacesMutation, { data, loading, error }] = useUpdateOtherSpacesMutation({
 *   variables: {
 *      input: // value for 'input'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateOtherSpacesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOtherSpacesMutation, UpdateOtherSpacesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOtherSpacesMutation, UpdateOtherSpacesMutationVariables>(UpdateOtherSpacesDocument, options);
      }
export type UpdateOtherSpacesMutationHookResult = ReturnType<typeof useUpdateOtherSpacesMutation>;
export type UpdateOtherSpacesMutationResult = Apollo.MutationResult<UpdateOtherSpacesMutation>;
export type UpdateOtherSpacesMutationOptions = Apollo.BaseMutationOptions<UpdateOtherSpacesMutation, UpdateOtherSpacesMutationVariables>;
export const UpdateClientDocument = gql`
    mutation UpdateClient($id: ID!, $clientInfo: ClientInput!) {
  updateClient(id: $id, clientInfo: $clientInfo) {
    id
  }
}
    `;
export type UpdateClientMutationFn = Apollo.MutationFunction<UpdateClientMutation, UpdateClientMutationVariables>;

/**
 * __useUpdateClientMutation__
 *
 * To run a mutation, you first call `useUpdateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientMutation, { data, loading, error }] = useUpdateClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *      clientInfo: // value for 'clientInfo'
 *   },
 * });
 */
export function useUpdateClientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientMutation, UpdateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientMutation, UpdateClientMutationVariables>(UpdateClientDocument, options);
      }
export type UpdateClientMutationHookResult = ReturnType<typeof useUpdateClientMutation>;
export type UpdateClientMutationResult = Apollo.MutationResult<UpdateClientMutation>;
export type UpdateClientMutationOptions = Apollo.BaseMutationOptions<UpdateClientMutation, UpdateClientMutationVariables>;
export const UpdateDiscIncValuesDocument = gql`
    mutation UpdateDiscIncValues($input: DiscIncInput!) {
  updateDiscIncValues(input: $input) {
    id
    spaces {
      items {
        id
        name
        lowPrice
        midPrice
        highPrice
      }
    }
  }
}
    `;
export type UpdateDiscIncValuesMutationFn = Apollo.MutationFunction<UpdateDiscIncValuesMutation, UpdateDiscIncValuesMutationVariables>;

/**
 * __useUpdateDiscIncValuesMutation__
 *
 * To run a mutation, you first call `useUpdateDiscIncValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscIncValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiscIncValuesMutation, { data, loading, error }] = useUpdateDiscIncValuesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDiscIncValuesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDiscIncValuesMutation, UpdateDiscIncValuesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDiscIncValuesMutation, UpdateDiscIncValuesMutationVariables>(UpdateDiscIncValuesDocument, options);
      }
export type UpdateDiscIncValuesMutationHookResult = ReturnType<typeof useUpdateDiscIncValuesMutation>;
export type UpdateDiscIncValuesMutationResult = Apollo.MutationResult<UpdateDiscIncValuesMutation>;
export type UpdateDiscIncValuesMutationOptions = Apollo.BaseMutationOptions<UpdateDiscIncValuesMutation, UpdateDiscIncValuesMutationVariables>;
export const UpdateProjectDocument = gql`
    mutation UpdateProject($id: ID!, $input: ProjectInput!) {
  updateProject(id: $id, input: $input) {
    id
    name
    coverImageUrl
    stage
    budget
    headCount
    squareFootage
    moveInDate
    buildingsQty
    assignedTasklistsCount
    projectEstimate {
      lowPrice
      highPrice
    }
    client {
      id
      name
    }
    industry {
      id
      name
      covers {
        id
        url
      }
    }
    industryDetails {
      id
      visualPreferences {
        url
        id
        like
        dislike
      }
      otherBusinessGoals {
        other
        values
      }
      otherSpaces {
        other
        quantValues {
          amount
          values
          other
        }
        values
      }
      otherFacilityTypes {
        other
        values
      }
      otherAdministrativeGoals {
        other
        values
      }
      otherClinicalGoals {
        other
        values
      }
      otherHomeType {
        other
        values
      }
      otherWorkspaceType {
        other
        values
      }
      otherElements {
        other
        values
      }
      projectSize {
        other
        values
      }
      experienceLevel {
        other
        values
      }
    }
    companyName
  }
}
    `;
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, options);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const UpdateProjectMemberRoleDocument = gql`
    mutation UpdateProjectMemberRole($input: UpdateProjectMemberRoleInput!) {
  updateMemberRole(input: $input)
}
    `;
export type UpdateProjectMemberRoleMutationFn = Apollo.MutationFunction<UpdateProjectMemberRoleMutation, UpdateProjectMemberRoleMutationVariables>;

/**
 * __useUpdateProjectMemberRoleMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMemberRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMemberRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMemberRoleMutation, { data, loading, error }] = useUpdateProjectMemberRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectMemberRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectMemberRoleMutation, UpdateProjectMemberRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectMemberRoleMutation, UpdateProjectMemberRoleMutationVariables>(UpdateProjectMemberRoleDocument, options);
      }
export type UpdateProjectMemberRoleMutationHookResult = ReturnType<typeof useUpdateProjectMemberRoleMutation>;
export type UpdateProjectMemberRoleMutationResult = Apollo.MutationResult<UpdateProjectMemberRoleMutation>;
export type UpdateProjectMemberRoleMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMemberRoleMutation, UpdateProjectMemberRoleMutationVariables>;
export const UpdateProjectsStageDocument = gql`
    mutation UpdateProjectsStage($id: ID!, $input: ProjectStageInput!) {
  updateProjectsStage(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateProjectsStageMutationFn = Apollo.MutationFunction<UpdateProjectsStageMutation, UpdateProjectsStageMutationVariables>;

/**
 * __useUpdateProjectsStageMutation__
 *
 * To run a mutation, you first call `useUpdateProjectsStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectsStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectsStageMutation, { data, loading, error }] = useUpdateProjectsStageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectsStageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectsStageMutation, UpdateProjectsStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectsStageMutation, UpdateProjectsStageMutationVariables>(UpdateProjectsStageDocument, options);
      }
export type UpdateProjectsStageMutationHookResult = ReturnType<typeof useUpdateProjectsStageMutation>;
export type UpdateProjectsStageMutationResult = Apollo.MutationResult<UpdateProjectsStageMutation>;
export type UpdateProjectsStageMutationOptions = Apollo.BaseMutationOptions<UpdateProjectsStageMutation, UpdateProjectsStageMutationVariables>;
export const ViewProjectCountDocument = gql`
    query ViewProjectCount {
  viewProjectCount
}
    `;

/**
 * __useViewProjectCountQuery__
 *
 * To run a query within a React component, call `useViewProjectCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewProjectCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewProjectCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewProjectCountQuery(baseOptions?: Apollo.QueryHookOptions<ViewProjectCountQuery, ViewProjectCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewProjectCountQuery, ViewProjectCountQueryVariables>(ViewProjectCountDocument, options);
      }
export function useViewProjectCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewProjectCountQuery, ViewProjectCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewProjectCountQuery, ViewProjectCountQueryVariables>(ViewProjectCountDocument, options);
        }
export type ViewProjectCountQueryHookResult = ReturnType<typeof useViewProjectCountQuery>;
export type ViewProjectCountLazyQueryHookResult = ReturnType<typeof useViewProjectCountLazyQuery>;
export type ViewProjectCountQueryResult = Apollo.QueryResult<ViewProjectCountQuery, ViewProjectCountQueryVariables>;
export const ViewUserInvitationsDocument = gql`
    query ViewUserInvitations {
  viewUserInvitations {
    id
    name
  }
}
    `;

/**
 * __useViewUserInvitationsQuery__
 *
 * To run a query within a React component, call `useViewUserInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewUserInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewUserInvitationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewUserInvitationsQuery(baseOptions?: Apollo.QueryHookOptions<ViewUserInvitationsQuery, ViewUserInvitationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewUserInvitationsQuery, ViewUserInvitationsQueryVariables>(ViewUserInvitationsDocument, options);
      }
export function useViewUserInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewUserInvitationsQuery, ViewUserInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewUserInvitationsQuery, ViewUserInvitationsQueryVariables>(ViewUserInvitationsDocument, options);
        }
export type ViewUserInvitationsQueryHookResult = ReturnType<typeof useViewUserInvitationsQuery>;
export type ViewUserInvitationsLazyQueryHookResult = ReturnType<typeof useViewUserInvitationsLazyQuery>;
export type ViewUserInvitationsQueryResult = Apollo.QueryResult<ViewUserInvitationsQuery, ViewUserInvitationsQueryVariables>;
export const CreateServicesDocument = gql`
    mutation createServices($input: CreateServicesInput!) {
  createServices(input: $input) {
    id
    lowEstimate
    midEstimate
    highEstimate
    percentage
    servicesTemplates {
      name
    }
  }
}
    `;
export type CreateServicesMutationFn = Apollo.MutationFunction<CreateServicesMutation, CreateServicesMutationVariables>;

/**
 * __useCreateServicesMutation__
 *
 * To run a mutation, you first call `useCreateServicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServicesMutation, { data, loading, error }] = useCreateServicesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateServicesMutation(baseOptions?: Apollo.MutationHookOptions<CreateServicesMutation, CreateServicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServicesMutation, CreateServicesMutationVariables>(CreateServicesDocument, options);
      }
export type CreateServicesMutationHookResult = ReturnType<typeof useCreateServicesMutation>;
export type CreateServicesMutationResult = Apollo.MutationResult<CreateServicesMutation>;
export type CreateServicesMutationOptions = Apollo.BaseMutationOptions<CreateServicesMutation, CreateServicesMutationVariables>;
export const DeleteServiceDocument = gql`
    mutation DeleteService($id: ID!) {
  deleteService(id: $id)
}
    `;
export type DeleteServiceMutationFn = Apollo.MutationFunction<DeleteServiceMutation, DeleteServiceMutationVariables>;

/**
 * __useDeleteServiceMutation__
 *
 * To run a mutation, you first call `useDeleteServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceMutation, { data, loading, error }] = useDeleteServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteServiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteServiceMutation, DeleteServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteServiceMutation, DeleteServiceMutationVariables>(DeleteServiceDocument, options);
      }
export type DeleteServiceMutationHookResult = ReturnType<typeof useDeleteServiceMutation>;
export type DeleteServiceMutationResult = Apollo.MutationResult<DeleteServiceMutation>;
export type DeleteServiceMutationOptions = Apollo.BaseMutationOptions<DeleteServiceMutation, DeleteServiceMutationVariables>;
export const ListServicesTemplatesDocument = gql`
    query listServicesTemplates {
  listServicesTemplates {
    id
    name
  }
}
    `;

/**
 * __useListServicesTemplatesQuery__
 *
 * To run a query within a React component, call `useListServicesTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListServicesTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListServicesTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListServicesTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<ListServicesTemplatesQuery, ListServicesTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListServicesTemplatesQuery, ListServicesTemplatesQueryVariables>(ListServicesTemplatesDocument, options);
      }
export function useListServicesTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListServicesTemplatesQuery, ListServicesTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListServicesTemplatesQuery, ListServicesTemplatesQueryVariables>(ListServicesTemplatesDocument, options);
        }
export type ListServicesTemplatesQueryHookResult = ReturnType<typeof useListServicesTemplatesQuery>;
export type ListServicesTemplatesLazyQueryHookResult = ReturnType<typeof useListServicesTemplatesLazyQuery>;
export type ListServicesTemplatesQueryResult = Apollo.QueryResult<ListServicesTemplatesQuery, ListServicesTemplatesQueryVariables>;
export const GetProjectServicesDocument = gql`
    query getProjectServices($id: ID!) {
  listProjectServices(id: $id) {
    id
    servicesTemplates {
      id
      name
      description
    }
    lowEstimate
    midEstimate
    highEstimate
    percentage
  }
}
    `;

/**
 * __useGetProjectServicesQuery__
 *
 * To run a query within a React component, call `useGetProjectServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectServicesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectServicesQuery(baseOptions: Apollo.QueryHookOptions<GetProjectServicesQuery, GetProjectServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectServicesQuery, GetProjectServicesQueryVariables>(GetProjectServicesDocument, options);
      }
export function useGetProjectServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectServicesQuery, GetProjectServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectServicesQuery, GetProjectServicesQueryVariables>(GetProjectServicesDocument, options);
        }
export type GetProjectServicesQueryHookResult = ReturnType<typeof useGetProjectServicesQuery>;
export type GetProjectServicesLazyQueryHookResult = ReturnType<typeof useGetProjectServicesLazyQuery>;
export type GetProjectServicesQueryResult = Apollo.QueryResult<GetProjectServicesQuery, GetProjectServicesQueryVariables>;
export const UpdateServicesDocument = gql`
    mutation updateServices($id: ID!, $input: UpdateServicesInput!) {
  updateService(id: $id, input: $input)
}
    `;
export type UpdateServicesMutationFn = Apollo.MutationFunction<UpdateServicesMutation, UpdateServicesMutationVariables>;

/**
 * __useUpdateServicesMutation__
 *
 * To run a mutation, you first call `useUpdateServicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServicesMutation, { data, loading, error }] = useUpdateServicesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateServicesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServicesMutation, UpdateServicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServicesMutation, UpdateServicesMutationVariables>(UpdateServicesDocument, options);
      }
export type UpdateServicesMutationHookResult = ReturnType<typeof useUpdateServicesMutation>;
export type UpdateServicesMutationResult = Apollo.MutationResult<UpdateServicesMutation>;
export type UpdateServicesMutationOptions = Apollo.BaseMutationOptions<UpdateServicesMutation, UpdateServicesMutationVariables>;
export const CopySpaceDocument = gql`
    mutation copySpace($id: ID!) {
  copySpace(id: $id)
}
    `;
export type CopySpaceMutationFn = Apollo.MutationFunction<CopySpaceMutation, CopySpaceMutationVariables>;

/**
 * __useCopySpaceMutation__
 *
 * To run a mutation, you first call `useCopySpaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopySpaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copySpaceMutation, { data, loading, error }] = useCopySpaceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCopySpaceMutation(baseOptions?: Apollo.MutationHookOptions<CopySpaceMutation, CopySpaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopySpaceMutation, CopySpaceMutationVariables>(CopySpaceDocument, options);
      }
export type CopySpaceMutationHookResult = ReturnType<typeof useCopySpaceMutation>;
export type CopySpaceMutationResult = Apollo.MutationResult<CopySpaceMutation>;
export type CopySpaceMutationOptions = Apollo.BaseMutationOptions<CopySpaceMutation, CopySpaceMutationVariables>;
export const CreateSpaceCommentDocument = gql`
    mutation createSpaceComment($input: SpaceCommentInput!) {
  createSpaceComment(input: $input) {
    id
    comment
    spaceId
  }
}
    `;
export type CreateSpaceCommentMutationFn = Apollo.MutationFunction<CreateSpaceCommentMutation, CreateSpaceCommentMutationVariables>;

/**
 * __useCreateSpaceCommentMutation__
 *
 * To run a mutation, you first call `useCreateSpaceCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSpaceCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSpaceCommentMutation, { data, loading, error }] = useCreateSpaceCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSpaceCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSpaceCommentMutation, CreateSpaceCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSpaceCommentMutation, CreateSpaceCommentMutationVariables>(CreateSpaceCommentDocument, options);
      }
export type CreateSpaceCommentMutationHookResult = ReturnType<typeof useCreateSpaceCommentMutation>;
export type CreateSpaceCommentMutationResult = Apollo.MutationResult<CreateSpaceCommentMutation>;
export type CreateSpaceCommentMutationOptions = Apollo.BaseMutationOptions<CreateSpaceCommentMutation, CreateSpaceCommentMutationVariables>;
export const CreateSpacesDocument = gql`
    mutation createSpaces($input: CreateSpacesInput!) {
  createSpaces(input: $input) {
    id
    name
  }
}
    `;
export type CreateSpacesMutationFn = Apollo.MutationFunction<CreateSpacesMutation, CreateSpacesMutationVariables>;

/**
 * __useCreateSpacesMutation__
 *
 * To run a mutation, you first call `useCreateSpacesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSpacesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSpacesMutation, { data, loading, error }] = useCreateSpacesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSpacesMutation(baseOptions?: Apollo.MutationHookOptions<CreateSpacesMutation, CreateSpacesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSpacesMutation, CreateSpacesMutationVariables>(CreateSpacesDocument, options);
      }
export type CreateSpacesMutationHookResult = ReturnType<typeof useCreateSpacesMutation>;
export type CreateSpacesMutationResult = Apollo.MutationResult<CreateSpacesMutation>;
export type CreateSpacesMutationOptions = Apollo.BaseMutationOptions<CreateSpacesMutation, CreateSpacesMutationVariables>;
export const DeleteSpaceDocument = gql`
    mutation deleteSpace($id: ID!) {
  deleteSpace(id: $id)
}
    `;
export type DeleteSpaceMutationFn = Apollo.MutationFunction<DeleteSpaceMutation, DeleteSpaceMutationVariables>;

/**
 * __useDeleteSpaceMutation__
 *
 * To run a mutation, you first call `useDeleteSpaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSpaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSpaceMutation, { data, loading, error }] = useDeleteSpaceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSpaceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSpaceMutation, DeleteSpaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSpaceMutation, DeleteSpaceMutationVariables>(DeleteSpaceDocument, options);
      }
export type DeleteSpaceMutationHookResult = ReturnType<typeof useDeleteSpaceMutation>;
export type DeleteSpaceMutationResult = Apollo.MutationResult<DeleteSpaceMutation>;
export type DeleteSpaceMutationOptions = Apollo.BaseMutationOptions<DeleteSpaceMutation, DeleteSpaceMutationVariables>;
export const GetCommentsBySpaceIdDocument = gql`
    query getCommentsBySpaceId($id: String!) {
  getCommentsBySpaceId(id: $id) {
    id
    comment
    spaceId
    userFirstName
    userLastName
    createdOn
  }
}
    `;

/**
 * __useGetCommentsBySpaceIdQuery__
 *
 * To run a query within a React component, call `useGetCommentsBySpaceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsBySpaceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsBySpaceIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCommentsBySpaceIdQuery(baseOptions: Apollo.QueryHookOptions<GetCommentsBySpaceIdQuery, GetCommentsBySpaceIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommentsBySpaceIdQuery, GetCommentsBySpaceIdQueryVariables>(GetCommentsBySpaceIdDocument, options);
      }
export function useGetCommentsBySpaceIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommentsBySpaceIdQuery, GetCommentsBySpaceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommentsBySpaceIdQuery, GetCommentsBySpaceIdQueryVariables>(GetCommentsBySpaceIdDocument, options);
        }
export type GetCommentsBySpaceIdQueryHookResult = ReturnType<typeof useGetCommentsBySpaceIdQuery>;
export type GetCommentsBySpaceIdLazyQueryHookResult = ReturnType<typeof useGetCommentsBySpaceIdLazyQuery>;
export type GetCommentsBySpaceIdQueryResult = Apollo.QueryResult<GetCommentsBySpaceIdQuery, GetCommentsBySpaceIdQueryVariables>;
export const GetAllItemTemplatesDocument = gql`
    query GetAllItemTemplates {
  getAllItemTemplates {
    id
    name
    category {
      id
      name
      createdOn
      modifiedOn
    }
    lowPrice
    midPrice
    highPrice
    image
    quantity
    createdOn
    modifiedOn
  }
}
    `;

/**
 * __useGetAllItemTemplatesQuery__
 *
 * To run a query within a React component, call `useGetAllItemTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllItemTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllItemTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllItemTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllItemTemplatesQuery, GetAllItemTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllItemTemplatesQuery, GetAllItemTemplatesQueryVariables>(GetAllItemTemplatesDocument, options);
      }
export function useGetAllItemTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllItemTemplatesQuery, GetAllItemTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllItemTemplatesQuery, GetAllItemTemplatesQueryVariables>(GetAllItemTemplatesDocument, options);
        }
export type GetAllItemTemplatesQueryHookResult = ReturnType<typeof useGetAllItemTemplatesQuery>;
export type GetAllItemTemplatesLazyQueryHookResult = ReturnType<typeof useGetAllItemTemplatesLazyQuery>;
export type GetAllItemTemplatesQueryResult = Apollo.QueryResult<GetAllItemTemplatesQuery, GetAllItemTemplatesQueryVariables>;
export const ListSpacesItemTemplatesDocument = gql`
    query ListSpacesItemTemplates {
  listSpacesItemTemplates {
    itemsQuantity
    itemTemplate {
      id
      lowPrice
      midPrice
      highPrice
    }
    spacesTemplate {
      id
    }
  }
}
    `;

/**
 * __useListSpacesItemTemplatesQuery__
 *
 * To run a query within a React component, call `useListSpacesItemTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSpacesItemTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSpacesItemTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListSpacesItemTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<ListSpacesItemTemplatesQuery, ListSpacesItemTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSpacesItemTemplatesQuery, ListSpacesItemTemplatesQueryVariables>(ListSpacesItemTemplatesDocument, options);
      }
export function useListSpacesItemTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSpacesItemTemplatesQuery, ListSpacesItemTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSpacesItemTemplatesQuery, ListSpacesItemTemplatesQueryVariables>(ListSpacesItemTemplatesDocument, options);
        }
export type ListSpacesItemTemplatesQueryHookResult = ReturnType<typeof useListSpacesItemTemplatesQuery>;
export type ListSpacesItemTemplatesLazyQueryHookResult = ReturnType<typeof useListSpacesItemTemplatesLazyQuery>;
export type ListSpacesItemTemplatesQueryResult = Apollo.QueryResult<ListSpacesItemTemplatesQuery, ListSpacesItemTemplatesQueryVariables>;
export const ListSpacesTemplatesDocument = gql`
    query listSpacesTemplates {
  listSpacesTemplates {
    id
    name
    description
    image
    industry {
      id
      name
    }
    items {
      id
      name
      lowPrice
      midPrice
      highPrice
      image
      category {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useListSpacesTemplatesQuery__
 *
 * To run a query within a React component, call `useListSpacesTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSpacesTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSpacesTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListSpacesTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<ListSpacesTemplatesQuery, ListSpacesTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSpacesTemplatesQuery, ListSpacesTemplatesQueryVariables>(ListSpacesTemplatesDocument, options);
      }
export function useListSpacesTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSpacesTemplatesQuery, ListSpacesTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSpacesTemplatesQuery, ListSpacesTemplatesQueryVariables>(ListSpacesTemplatesDocument, options);
        }
export type ListSpacesTemplatesQueryHookResult = ReturnType<typeof useListSpacesTemplatesQuery>;
export type ListSpacesTemplatesLazyQueryHookResult = ReturnType<typeof useListSpacesTemplatesLazyQuery>;
export type ListSpacesTemplatesQueryResult = Apollo.QueryResult<ListSpacesTemplatesQuery, ListSpacesTemplatesQueryVariables>;
export const UpdateItemIndexDocument = gql`
    mutation updateItemIndex($input: [UpdateItemIndexInput!]!) {
  updateItemIndex(input: $input)
}
    `;
export type UpdateItemIndexMutationFn = Apollo.MutationFunction<UpdateItemIndexMutation, UpdateItemIndexMutationVariables>;

/**
 * __useUpdateItemIndexMutation__
 *
 * To run a mutation, you first call `useUpdateItemIndexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItemIndexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItemIndexMutation, { data, loading, error }] = useUpdateItemIndexMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateItemIndexMutation(baseOptions?: Apollo.MutationHookOptions<UpdateItemIndexMutation, UpdateItemIndexMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateItemIndexMutation, UpdateItemIndexMutationVariables>(UpdateItemIndexDocument, options);
      }
export type UpdateItemIndexMutationHookResult = ReturnType<typeof useUpdateItemIndexMutation>;
export type UpdateItemIndexMutationResult = Apollo.MutationResult<UpdateItemIndexMutation>;
export type UpdateItemIndexMutationOptions = Apollo.BaseMutationOptions<UpdateItemIndexMutation, UpdateItemIndexMutationVariables>;
export const UpdateSpaceDocument = gql`
    mutation updateSpace($id: ID!, $input: UpdateSpaceInput!) {
  updateSpace(id: $id, input: $input)
}
    `;
export type UpdateSpaceMutationFn = Apollo.MutationFunction<UpdateSpaceMutation, UpdateSpaceMutationVariables>;

/**
 * __useUpdateSpaceMutation__
 *
 * To run a mutation, you first call `useUpdateSpaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpaceMutation, { data, loading, error }] = useUpdateSpaceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpaceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpaceMutation, UpdateSpaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpaceMutation, UpdateSpaceMutationVariables>(UpdateSpaceDocument, options);
      }
export type UpdateSpaceMutationHookResult = ReturnType<typeof useUpdateSpaceMutation>;
export type UpdateSpaceMutationResult = Apollo.MutationResult<UpdateSpaceMutation>;
export type UpdateSpaceMutationOptions = Apollo.BaseMutationOptions<UpdateSpaceMutation, UpdateSpaceMutationVariables>;
export const UpdateSpaceListsDocument = gql`
    mutation updateSpaceLists($input: [UpdateSpaceListInput!]!) {
  updateSpaceList(input: $input)
}
    `;
export type UpdateSpaceListsMutationFn = Apollo.MutationFunction<UpdateSpaceListsMutation, UpdateSpaceListsMutationVariables>;

/**
 * __useUpdateSpaceListsMutation__
 *
 * To run a mutation, you first call `useUpdateSpaceListsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpaceListsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpaceListsMutation, { data, loading, error }] = useUpdateSpaceListsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpaceListsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpaceListsMutation, UpdateSpaceListsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpaceListsMutation, UpdateSpaceListsMutationVariables>(UpdateSpaceListsDocument, options);
      }
export type UpdateSpaceListsMutationHookResult = ReturnType<typeof useUpdateSpaceListsMutation>;
export type UpdateSpaceListsMutationResult = Apollo.MutationResult<UpdateSpaceListsMutation>;
export type UpdateSpaceListsMutationOptions = Apollo.BaseMutationOptions<UpdateSpaceListsMutation, UpdateSpaceListsMutationVariables>;
export const AddTaskCommentDocument = gql`
    mutation AddTaskComment($input: CreateCommentInput!) {
  addTaskComment(input: $input) {
    id
    taskId
    comment
    createdOn
    createUser {
      id
      firstName
      lastName
      avatarUrl
    }
    modifiedOn
    modifyUser {
      id
      firstName
      lastName
      avatarUrl
    }
  }
}
    `;
export type AddTaskCommentMutationFn = Apollo.MutationFunction<AddTaskCommentMutation, AddTaskCommentMutationVariables>;

/**
 * __useAddTaskCommentMutation__
 *
 * To run a mutation, you first call `useAddTaskCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTaskCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTaskCommentMutation, { data, loading, error }] = useAddTaskCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTaskCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddTaskCommentMutation, AddTaskCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTaskCommentMutation, AddTaskCommentMutationVariables>(AddTaskCommentDocument, options);
      }
export type AddTaskCommentMutationHookResult = ReturnType<typeof useAddTaskCommentMutation>;
export type AddTaskCommentMutationResult = Apollo.MutationResult<AddTaskCommentMutation>;
export type AddTaskCommentMutationOptions = Apollo.BaseMutationOptions<AddTaskCommentMutation, AddTaskCommentMutationVariables>;
export const AddTasklistToProjectDocument = gql`
    mutation AddTasklistToProject($projectId: ID!, $templateId: ID!) {
  addTasklistToProject(projectId: $projectId, templateId: $templateId) {
    id
    name
    isVisible
    createdOn
    modifiedOn
    createUser {
      id
      firstName
      lastName
      avatarUrl
    }
    modifyUser {
      id
      firstName
      lastName
      avatarUrl
    }
    dueDate
    tasklistTemplateId
    sections {
      id
      name
      tasklistId
      createdOn
      modifiedOn
      createUser {
        id
        firstName
        lastName
        avatarUrl
      }
      modifyUser {
        id
        firstName
        lastName
        avatarUrl
      }
      tasks {
        id
        name
        sectionId
        completedDate
        createdOn
        modifiedOn
        dueDate
        createUser {
          id
          firstName
          lastName
          avatarUrl
        }
        modifyUser {
          id
          firstName
          lastName
          avatarUrl
        }
        fields {
          ... on RadioField {
            name
            type
            options {
              label
              value
            }
          }
          ... on AreaField {
            name
            type
            label
          }
          ... on TextField {
            name
            type
            label
          }
          ... on CheckboxField {
            name
            type
            label
          }
          ... on DateField {
            name
            type
            label
          }
        }
        taskAnswer {
          id
          values
          taskId
          createdOn
          modifiedOn
          createUser {
            id
            firstName
            lastName
            avatarUrl
          }
          modifyUser {
            id
            firstName
            lastName
            avatarUrl
          }
        }
      }
    }
  }
}
    `;
export type AddTasklistToProjectMutationFn = Apollo.MutationFunction<AddTasklistToProjectMutation, AddTasklistToProjectMutationVariables>;

/**
 * __useAddTasklistToProjectMutation__
 *
 * To run a mutation, you first call `useAddTasklistToProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTasklistToProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTasklistToProjectMutation, { data, loading, error }] = useAddTasklistToProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useAddTasklistToProjectMutation(baseOptions?: Apollo.MutationHookOptions<AddTasklistToProjectMutation, AddTasklistToProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTasklistToProjectMutation, AddTasklistToProjectMutationVariables>(AddTasklistToProjectDocument, options);
      }
export type AddTasklistToProjectMutationHookResult = ReturnType<typeof useAddTasklistToProjectMutation>;
export type AddTasklistToProjectMutationResult = Apollo.MutationResult<AddTasklistToProjectMutation>;
export type AddTasklistToProjectMutationOptions = Apollo.BaseMutationOptions<AddTasklistToProjectMutation, AddTasklistToProjectMutationVariables>;
export const ArchiveTasklistDocument = gql`
    mutation ArchiveTasklist($projectId: ID!, $id: ID!) {
  archiveTasklist(projectId: $projectId, id: $id)
}
    `;
export type ArchiveTasklistMutationFn = Apollo.MutationFunction<ArchiveTasklistMutation, ArchiveTasklistMutationVariables>;

/**
 * __useArchiveTasklistMutation__
 *
 * To run a mutation, you first call `useArchiveTasklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveTasklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveTasklistMutation, { data, loading, error }] = useArchiveTasklistMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveTasklistMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveTasklistMutation, ArchiveTasklistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveTasklistMutation, ArchiveTasklistMutationVariables>(ArchiveTasklistDocument, options);
      }
export type ArchiveTasklistMutationHookResult = ReturnType<typeof useArchiveTasklistMutation>;
export type ArchiveTasklistMutationResult = Apollo.MutationResult<ArchiveTasklistMutation>;
export type ArchiveTasklistMutationOptions = Apollo.BaseMutationOptions<ArchiveTasklistMutation, ArchiveTasklistMutationVariables>;
export const CompleteTasksInSectionDocument = gql`
    mutation CompleteTasksInSection($projectId: ID!, $sectionId: ID!) {
  completeTasksInSection(projectId: $projectId, id: $sectionId)
}
    `;
export type CompleteTasksInSectionMutationFn = Apollo.MutationFunction<CompleteTasksInSectionMutation, CompleteTasksInSectionMutationVariables>;

/**
 * __useCompleteTasksInSectionMutation__
 *
 * To run a mutation, you first call `useCompleteTasksInSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteTasksInSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeTasksInSectionMutation, { data, loading, error }] = useCompleteTasksInSectionMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useCompleteTasksInSectionMutation(baseOptions?: Apollo.MutationHookOptions<CompleteTasksInSectionMutation, CompleteTasksInSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteTasksInSectionMutation, CompleteTasksInSectionMutationVariables>(CompleteTasksInSectionDocument, options);
      }
export type CompleteTasksInSectionMutationHookResult = ReturnType<typeof useCompleteTasksInSectionMutation>;
export type CompleteTasksInSectionMutationResult = Apollo.MutationResult<CompleteTasksInSectionMutation>;
export type CompleteTasksInSectionMutationOptions = Apollo.BaseMutationOptions<CompleteTasksInSectionMutation, CompleteTasksInSectionMutationVariables>;
export const CreateSectionDocument = gql`
    mutation CreateSection($projectId: ID!, $input: CreateSectionInput!) {
  createSection(projectId: $projectId, input: $input) {
    id
    name
    tasklistId
    tasklist {
      id
    }
    createdOn
    modifiedOn
    createdBy
    modifiedBy
  }
}
    `;
export type CreateSectionMutationFn = Apollo.MutationFunction<CreateSectionMutation, CreateSectionMutationVariables>;

/**
 * __useCreateSectionMutation__
 *
 * To run a mutation, you first call `useCreateSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSectionMutation, { data, loading, error }] = useCreateSectionMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSectionMutation, CreateSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSectionMutation, CreateSectionMutationVariables>(CreateSectionDocument, options);
      }
export type CreateSectionMutationHookResult = ReturnType<typeof useCreateSectionMutation>;
export type CreateSectionMutationResult = Apollo.MutationResult<CreateSectionMutation>;
export type CreateSectionMutationOptions = Apollo.BaseMutationOptions<CreateSectionMutation, CreateSectionMutationVariables>;
export const CreateTaskDocument = gql`
    mutation CreateTask($projectId: ID!, $input: CreateTaskInput!) {
  createTask(projectId: $projectId, input: $input) {
    id
    name
    completedDate
    assignedUser {
      id
      firstName
      lastName
      avatarUrl
    }
    completedByUser {
      id
      firstName
      lastName
      avatarUrl
    }
    dueDate
    sectionId
    createdOn
    modifiedOn
    createdBy
    modifiedBy
    createUser {
      avatarUrl
      businessRole
      firstName
      id
      lastName
    }
    modifyUser {
      avatarUrl
      businessRole
      firstName
      id
      lastName
    }
    fields {
      ... on RadioField {
        name
        type
        options {
          label
          value
        }
      }
      ... on AreaField {
        name
        type
        label
      }
      ... on TextField {
        name
        type
        label
      }
      ... on CheckboxField {
        name
        type
        label
      }
      ... on DateField {
        name
        type
        label
      }
    }
    taskAnswer {
      id
      values
      createdOn
      modifiedOn
      createdBy
      modifiedBy
    }
  }
}
    `;
export type CreateTaskMutationFn = Apollo.MutationFunction<CreateTaskMutation, CreateTaskMutationVariables>;

/**
 * __useCreateTaskMutation__
 *
 * To run a mutation, you first call `useCreateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskMutation, { data, loading, error }] = useCreateTaskMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskMutation, CreateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskMutation, CreateTaskMutationVariables>(CreateTaskDocument, options);
      }
export type CreateTaskMutationHookResult = ReturnType<typeof useCreateTaskMutation>;
export type CreateTaskMutationResult = Apollo.MutationResult<CreateTaskMutation>;
export type CreateTaskMutationOptions = Apollo.BaseMutationOptions<CreateTaskMutation, CreateTaskMutationVariables>;
export const CreateTaskListDocument = gql`
    mutation CreateTaskList($input: CreateTasklistInput!) {
  createTasklist(input: $input) {
    id
    name
    description
    dueDate
    associatedObjectId
    createdOn
    createUser {
      id
      firstName
      lastName
      avatarUrl
    }
    modifiedOn
    modifyUser {
      id
      firstName
      lastName
      avatarUrl
    }
    tasklistUsers {
      id
      firstName
      lastName
      avatarUrl
      createdOn
      modifiedOn
      tasklists {
        id
        name
      }
      createUser {
        id
        firstName
        lastName
        avatarUrl
      }
      modifyUser {
        id
        firstName
        lastName
        avatarUrl
      }
    }
  }
}
    `;
export type CreateTaskListMutationFn = Apollo.MutationFunction<CreateTaskListMutation, CreateTaskListMutationVariables>;

/**
 * __useCreateTaskListMutation__
 *
 * To run a mutation, you first call `useCreateTaskListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskListMutation, { data, loading, error }] = useCreateTaskListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskListMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskListMutation, CreateTaskListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskListMutation, CreateTaskListMutationVariables>(CreateTaskListDocument, options);
      }
export type CreateTaskListMutationHookResult = ReturnType<typeof useCreateTaskListMutation>;
export type CreateTaskListMutationResult = Apollo.MutationResult<CreateTaskListMutation>;
export type CreateTaskListMutationOptions = Apollo.BaseMutationOptions<CreateTaskListMutation, CreateTaskListMutationVariables>;
export const DeleteTaskDocument = gql`
    mutation DeleteTask($projectId: ID!, $id: ID!) {
  deleteTask(projectId: $projectId, id: $id)
}
    `;
export type DeleteTaskMutationFn = Apollo.MutationFunction<DeleteTaskMutation, DeleteTaskMutationVariables>;

/**
 * __useDeleteTaskMutation__
 *
 * To run a mutation, you first call `useDeleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskMutation, { data, loading, error }] = useDeleteTaskMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTaskMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaskMutation, DeleteTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaskMutation, DeleteTaskMutationVariables>(DeleteTaskDocument, options);
      }
export type DeleteTaskMutationHookResult = ReturnType<typeof useDeleteTaskMutation>;
export type DeleteTaskMutationResult = Apollo.MutationResult<DeleteTaskMutation>;
export type DeleteTaskMutationOptions = Apollo.BaseMutationOptions<DeleteTaskMutation, DeleteTaskMutationVariables>;
export const DeleteTasklistDocument = gql`
    mutation DeleteTasklist($projectId: ID!, $id: ID!) {
  deleteTasklist(projectId: $projectId, id: $id)
}
    `;
export type DeleteTasklistMutationFn = Apollo.MutationFunction<DeleteTasklistMutation, DeleteTasklistMutationVariables>;

/**
 * __useDeleteTasklistMutation__
 *
 * To run a mutation, you first call `useDeleteTasklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTasklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTasklistMutation, { data, loading, error }] = useDeleteTasklistMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTasklistMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTasklistMutation, DeleteTasklistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTasklistMutation, DeleteTasklistMutationVariables>(DeleteTasklistDocument, options);
      }
export type DeleteTasklistMutationHookResult = ReturnType<typeof useDeleteTasklistMutation>;
export type DeleteTasklistMutationResult = Apollo.MutationResult<DeleteTasklistMutation>;
export type DeleteTasklistMutationOptions = Apollo.BaseMutationOptions<DeleteTasklistMutation, DeleteTasklistMutationVariables>;
export const GetTaskCommentsDocument = gql`
    query GetTaskComments($projectId: ID!, $taskId: ID!) {
  getTaskComments(projectId: $projectId, taskId: $taskId) {
    id
    taskId
    comment
    createdOn
    createUser {
      id
      firstName
      lastName
      avatarUrl
    }
    modifiedOn
    modifyUser {
      id
      firstName
      lastName
      avatarUrl
    }
  }
}
    `;

/**
 * __useGetTaskCommentsQuery__
 *
 * To run a query within a React component, call `useGetTaskCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskCommentsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetTaskCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetTaskCommentsQuery, GetTaskCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskCommentsQuery, GetTaskCommentsQueryVariables>(GetTaskCommentsDocument, options);
      }
export function useGetTaskCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskCommentsQuery, GetTaskCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskCommentsQuery, GetTaskCommentsQueryVariables>(GetTaskCommentsDocument, options);
        }
export type GetTaskCommentsQueryHookResult = ReturnType<typeof useGetTaskCommentsQuery>;
export type GetTaskCommentsLazyQueryHookResult = ReturnType<typeof useGetTaskCommentsLazyQuery>;
export type GetTaskCommentsQueryResult = Apollo.QueryResult<GetTaskCommentsQuery, GetTaskCommentsQueryVariables>;
export const PredefinedTasklistsDocument = gql`
    query PredefinedTasklists($projectId: ID!) {
  predefinedTasklists(projectId: $projectId) {
    tasklistTemplateId
    name
    description
    createdOn
    modifiedOn
  }
}
    `;

/**
 * __usePredefinedTasklistsQuery__
 *
 * To run a query within a React component, call `usePredefinedTasklistsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePredefinedTasklistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePredefinedTasklistsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePredefinedTasklistsQuery(baseOptions: Apollo.QueryHookOptions<PredefinedTasklistsQuery, PredefinedTasklistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PredefinedTasklistsQuery, PredefinedTasklistsQueryVariables>(PredefinedTasklistsDocument, options);
      }
export function usePredefinedTasklistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PredefinedTasklistsQuery, PredefinedTasklistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PredefinedTasklistsQuery, PredefinedTasklistsQueryVariables>(PredefinedTasklistsDocument, options);
        }
export type PredefinedTasklistsQueryHookResult = ReturnType<typeof usePredefinedTasklistsQuery>;
export type PredefinedTasklistsLazyQueryHookResult = ReturnType<typeof usePredefinedTasklistsLazyQuery>;
export type PredefinedTasklistsQueryResult = Apollo.QueryResult<PredefinedTasklistsQuery, PredefinedTasklistsQueryVariables>;
export const TasklistsForProjectDocument = gql`
    query TasklistsForProject($projectId: ID!) {
  tasklistsForProject(projectId: $projectId) {
    id
    name
    description
    isArchived
    isVisible
    isVisibleChangedOn
    associatedObjectId
    tasklistTemplateId
    createdOn
    modifiedOn
    createUser {
      id
      firstName
      lastName
      avatarUrl
    }
    modifyUser {
      id
      firstName
      lastName
      avatarUrl
    }
    tasklistUsers {
      id
      firstName
      lastName
      avatarUrl
      createdOn
      modifiedOn
      tasklists {
        id
        name
      }
      createUser {
        id
        firstName
        lastName
        avatarUrl
      }
      modifyUser {
        id
        firstName
        lastName
        avatarUrl
      }
    }
    dueDate
    sections {
      id
      name
      tasklistId
      createdOn
      modifiedOn
      createUser {
        id
        firstName
        lastName
        avatarUrl
      }
      modifyUser {
        id
        firstName
        lastName
        avatarUrl
      }
      tasks {
        id
        name
        completedDate
        sectionId
        createdOn
        modifiedOn
        createUser {
          id
          firstName
          lastName
          avatarUrl
        }
        modifyUser {
          id
          firstName
          lastName
          avatarUrl
        }
        assignedUser {
          id
          firstName
          lastName
          avatarUrl
        }
        completedByUser {
          id
          firstName
          lastName
          avatarUrl
        }
        dueDate
        comments {
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          id
          taskId
          comment
          tags {
            display
            userId
          }
        }
        numComments
        fields {
          ... on RadioField {
            name
            type
            options {
              label
              value
            }
          }
          ... on AreaField {
            name
            type
            label
          }
          ... on TextField {
            name
            type
            label
          }
          ... on CheckboxField {
            name
            type
            label
          }
          ... on DateField {
            name
            type
            label
          }
        }
        taskAnswer {
          id
          values
          taskId
          createdOn
          modifiedOn
        }
      }
    }
  }
}
    `;

/**
 * __useTasklistsForProjectQuery__
 *
 * To run a query within a React component, call `useTasklistsForProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useTasklistsForProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasklistsForProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useTasklistsForProjectQuery(baseOptions: Apollo.QueryHookOptions<TasklistsForProjectQuery, TasklistsForProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TasklistsForProjectQuery, TasklistsForProjectQueryVariables>(TasklistsForProjectDocument, options);
      }
export function useTasklistsForProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TasklistsForProjectQuery, TasklistsForProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TasklistsForProjectQuery, TasklistsForProjectQueryVariables>(TasklistsForProjectDocument, options);
        }
export type TasklistsForProjectQueryHookResult = ReturnType<typeof useTasklistsForProjectQuery>;
export type TasklistsForProjectLazyQueryHookResult = ReturnType<typeof useTasklistsForProjectLazyQuery>;
export type TasklistsForProjectQueryResult = Apollo.QueryResult<TasklistsForProjectQuery, TasklistsForProjectQueryVariables>;
export const UpdateTaskDocument = gql`
    mutation UpdateTask($projectId: ID!, $input: UpdateTaskInput!) {
  updateTask(projectId: $projectId, input: $input) {
    id
    name
    completedDate
    sectionId
    createdOn
    modifiedOn
    createUser {
      id
      firstName
      lastName
      avatarUrl
    }
    modifyUser {
      id
      firstName
      lastName
      avatarUrl
    }
    assignedUser {
      id
      firstName
      lastName
      avatarUrl
    }
    completedByUser {
      id
      firstName
      lastName
      avatarUrl
    }
    dueDate
    numComments
    fields {
      ... on RadioField {
        name
        type
        options {
          label
          value
        }
      }
      ... on AreaField {
        name
        type
        label
      }
      ... on TextField {
        name
        type
        label
      }
      ... on CheckboxField {
        name
        type
        label
      }
      ... on DateField {
        name
        type
        label
      }
    }
    taskAnswer {
      id
      values
      taskId
      createdOn
      modifiedOn
    }
  }
}
    `;
export type UpdateTaskMutationFn = Apollo.MutationFunction<UpdateTaskMutation, UpdateTaskMutationVariables>;

/**
 * __useUpdateTaskMutation__
 *
 * To run a mutation, you first call `useUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskMutation, { data, loading, error }] = useUpdateTaskMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskMutation, UpdateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskMutation, UpdateTaskMutationVariables>(UpdateTaskDocument, options);
      }
export type UpdateTaskMutationHookResult = ReturnType<typeof useUpdateTaskMutation>;
export type UpdateTaskMutationResult = Apollo.MutationResult<UpdateTaskMutation>;
export type UpdateTaskMutationOptions = Apollo.BaseMutationOptions<UpdateTaskMutation, UpdateTaskMutationVariables>;
export const UpdateTaskListDocument = gql`
    mutation UpdateTaskList($projectId: ID!, $input: UpdateTasklistInput!) {
  updateTasklist(projectId: $projectId, input: $input)
}
    `;
export type UpdateTaskListMutationFn = Apollo.MutationFunction<UpdateTaskListMutation, UpdateTaskListMutationVariables>;

/**
 * __useUpdateTaskListMutation__
 *
 * To run a mutation, you first call `useUpdateTaskListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskListMutation, { data, loading, error }] = useUpdateTaskListMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskListMutation, UpdateTaskListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskListMutation, UpdateTaskListMutationVariables>(UpdateTaskListDocument, options);
      }
export type UpdateTaskListMutationHookResult = ReturnType<typeof useUpdateTaskListMutation>;
export type UpdateTaskListMutationResult = Apollo.MutationResult<UpdateTaskListMutation>;
export type UpdateTaskListMutationOptions = Apollo.BaseMutationOptions<UpdateTaskListMutation, UpdateTaskListMutationVariables>;
export const UpsertTaskAnswerDocument = gql`
    mutation UpsertTaskAnswer($projectId: ID!, $input: UpsertTaskAnswerInput!) {
  upsertTaskAnswer(projectId: $projectId, input: $input) {
    id
    taskId
    values
    createdOn
    modifiedOn
    createUser {
      id
      firstName
      lastName
      avatarUrl
    }
    modifyUser {
      id
      firstName
      lastName
      avatarUrl
    }
    task {
      id
    }
  }
}
    `;
export type UpsertTaskAnswerMutationFn = Apollo.MutationFunction<UpsertTaskAnswerMutation, UpsertTaskAnswerMutationVariables>;

/**
 * __useUpsertTaskAnswerMutation__
 *
 * To run a mutation, you first call `useUpsertTaskAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTaskAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTaskAnswerMutation, { data, loading, error }] = useUpsertTaskAnswerMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertTaskAnswerMutation(baseOptions?: Apollo.MutationHookOptions<UpsertTaskAnswerMutation, UpsertTaskAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertTaskAnswerMutation, UpsertTaskAnswerMutationVariables>(UpsertTaskAnswerDocument, options);
      }
export type UpsertTaskAnswerMutationHookResult = ReturnType<typeof useUpsertTaskAnswerMutation>;
export type UpsertTaskAnswerMutationResult = Apollo.MutationResult<UpsertTaskAnswerMutation>;
export type UpsertTaskAnswerMutationOptions = Apollo.BaseMutationOptions<UpsertTaskAnswerMutation, UpsertTaskAnswerMutationVariables>;
export const GetTenantInfoByCodeDocument = gql`
    query getTenantInfoByCode {
  getTenantInfoByCode {
    id
    code
    tenantName
    email
    licenses
    used
  }
}
    `;

/**
 * __useGetTenantInfoByCodeQuery__
 *
 * To run a query within a React component, call `useGetTenantInfoByCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantInfoByCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantInfoByCodeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTenantInfoByCodeQuery(baseOptions?: Apollo.QueryHookOptions<GetTenantInfoByCodeQuery, GetTenantInfoByCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantInfoByCodeQuery, GetTenantInfoByCodeQueryVariables>(GetTenantInfoByCodeDocument, options);
      }
export function useGetTenantInfoByCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantInfoByCodeQuery, GetTenantInfoByCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantInfoByCodeQuery, GetTenantInfoByCodeQueryVariables>(GetTenantInfoByCodeDocument, options);
        }
export type GetTenantInfoByCodeQueryHookResult = ReturnType<typeof useGetTenantInfoByCodeQuery>;
export type GetTenantInfoByCodeLazyQueryHookResult = ReturnType<typeof useGetTenantInfoByCodeLazyQuery>;
export type GetTenantInfoByCodeQueryResult = Apollo.QueryResult<GetTenantInfoByCodeQuery, GetTenantInfoByCodeQueryVariables>;
export const ListUsersForProjectInviteDocument = gql`
    query listUsersForProjectInvite($projectId: ID!) {
  listUsersForProjectInvite(projectId: $projectId) {
    id
    firstName
    lastName
    phone
    email
    status
    businessRole
    securityRoles
  }
}
    `;

/**
 * __useListUsersForProjectInviteQuery__
 *
 * To run a query within a React component, call `useListUsersForProjectInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersForProjectInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersForProjectInviteQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useListUsersForProjectInviteQuery(baseOptions: Apollo.QueryHookOptions<ListUsersForProjectInviteQuery, ListUsersForProjectInviteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUsersForProjectInviteQuery, ListUsersForProjectInviteQueryVariables>(ListUsersForProjectInviteDocument, options);
      }
export function useListUsersForProjectInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUsersForProjectInviteQuery, ListUsersForProjectInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUsersForProjectInviteQuery, ListUsersForProjectInviteQueryVariables>(ListUsersForProjectInviteDocument, options);
        }
export type ListUsersForProjectInviteQueryHookResult = ReturnType<typeof useListUsersForProjectInviteQuery>;
export type ListUsersForProjectInviteLazyQueryHookResult = ReturnType<typeof useListUsersForProjectInviteLazyQuery>;
export type ListUsersForProjectInviteQueryResult = Apollo.QueryResult<ListUsersForProjectInviteQuery, ListUsersForProjectInviteQueryVariables>;
export const AddRoleDocument = gql`
    mutation AddRole($id: ID!, $role: SecurityRole!) {
  addRole(id: $id, role: $role)
}
    `;
export type AddRoleMutationFn = Apollo.MutationFunction<AddRoleMutation, AddRoleMutationVariables>;

/**
 * __useAddRoleMutation__
 *
 * To run a mutation, you first call `useAddRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRoleMutation, { data, loading, error }] = useAddRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useAddRoleMutation(baseOptions?: Apollo.MutationHookOptions<AddRoleMutation, AddRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRoleMutation, AddRoleMutationVariables>(AddRoleDocument, options);
      }
export type AddRoleMutationHookResult = ReturnType<typeof useAddRoleMutation>;
export type AddRoleMutationResult = Apollo.MutationResult<AddRoleMutation>;
export type AddRoleMutationOptions = Apollo.BaseMutationOptions<AddRoleMutation, AddRoleMutationVariables>;
export const AdminUpdateUserDocument = gql`
    mutation AdminUpdateUser($id: ID!, $userInfo: AdminUpdateUserInput!) {
  adminUpdateUser(id: $id, userInfo: $userInfo)
}
    `;
export type AdminUpdateUserMutationFn = Apollo.MutationFunction<AdminUpdateUserMutation, AdminUpdateUserMutationVariables>;

/**
 * __useAdminUpdateUserMutation__
 *
 * To run a mutation, you first call `useAdminUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateUserMutation, { data, loading, error }] = useAdminUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userInfo: // value for 'userInfo'
 *   },
 * });
 */
export function useAdminUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateUserMutation, AdminUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateUserMutation, AdminUpdateUserMutationVariables>(AdminUpdateUserDocument, options);
      }
export type AdminUpdateUserMutationHookResult = ReturnType<typeof useAdminUpdateUserMutation>;
export type AdminUpdateUserMutationResult = Apollo.MutationResult<AdminUpdateUserMutation>;
export type AdminUpdateUserMutationOptions = Apollo.BaseMutationOptions<AdminUpdateUserMutation, AdminUpdateUserMutationVariables>;
export const GetDisplayUserDocument = gql`
    query GetDisplayUser($id: ID!) {
  getDisplayUser(id: $id) {
    firstName
    lastName
    avatarUrl
    businessRole
  }
}
    `;

/**
 * __useGetDisplayUserQuery__
 *
 * To run a query within a React component, call `useGetDisplayUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisplayUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisplayUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDisplayUserQuery(baseOptions: Apollo.QueryHookOptions<GetDisplayUserQuery, GetDisplayUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDisplayUserQuery, GetDisplayUserQueryVariables>(GetDisplayUserDocument, options);
      }
export function useGetDisplayUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDisplayUserQuery, GetDisplayUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDisplayUserQuery, GetDisplayUserQueryVariables>(GetDisplayUserDocument, options);
        }
export type GetDisplayUserQueryHookResult = ReturnType<typeof useGetDisplayUserQuery>;
export type GetDisplayUserLazyQueryHookResult = ReturnType<typeof useGetDisplayUserLazyQuery>;
export type GetDisplayUserQueryResult = Apollo.QueryResult<GetDisplayUserQuery, GetDisplayUserQueryVariables>;
export const GetDisplayUsersByUserIdsDocument = gql`
    query GetDisplayUsersByUserIds($ids: [ID!]!) {
  getDisplayUsersByUserIds(ids: $ids) {
    firstName
    lastName
    avatarUrl
    businessRole
  }
}
    `;

/**
 * __useGetDisplayUsersByUserIdsQuery__
 *
 * To run a query within a React component, call `useGetDisplayUsersByUserIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisplayUsersByUserIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisplayUsersByUserIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetDisplayUsersByUserIdsQuery(baseOptions: Apollo.QueryHookOptions<GetDisplayUsersByUserIdsQuery, GetDisplayUsersByUserIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDisplayUsersByUserIdsQuery, GetDisplayUsersByUserIdsQueryVariables>(GetDisplayUsersByUserIdsDocument, options);
      }
export function useGetDisplayUsersByUserIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDisplayUsersByUserIdsQuery, GetDisplayUsersByUserIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDisplayUsersByUserIdsQuery, GetDisplayUsersByUserIdsQueryVariables>(GetDisplayUsersByUserIdsDocument, options);
        }
export type GetDisplayUsersByUserIdsQueryHookResult = ReturnType<typeof useGetDisplayUsersByUserIdsQuery>;
export type GetDisplayUsersByUserIdsLazyQueryHookResult = ReturnType<typeof useGetDisplayUsersByUserIdsLazyQuery>;
export type GetDisplayUsersByUserIdsQueryResult = Apollo.QueryResult<GetDisplayUsersByUserIdsQuery, GetDisplayUsersByUserIdsQueryVariables>;
export const GetUsersDocument = gql`
    query GetUsers {
  getUsers {
    avatarUrl
    id
    firstName
    lastName
    phone
    email
    status
    businessRole
    securityRoles
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetUsersByUserIdsDocument = gql`
    query GetUsersByUserIds($ids: [ID!]!) {
  getUsersByUserIds(ids: $ids) {
    id
    email
    status
    firstName
    lastName
    avatarUrl
    phone
    businessRole
    securityRoles
  }
}
    `;

/**
 * __useGetUsersByUserIdsQuery__
 *
 * To run a query within a React component, call `useGetUsersByUserIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersByUserIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersByUserIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetUsersByUserIdsQuery(baseOptions: Apollo.QueryHookOptions<GetUsersByUserIdsQuery, GetUsersByUserIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersByUserIdsQuery, GetUsersByUserIdsQueryVariables>(GetUsersByUserIdsDocument, options);
      }
export function useGetUsersByUserIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersByUserIdsQuery, GetUsersByUserIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersByUserIdsQuery, GetUsersByUserIdsQueryVariables>(GetUsersByUserIdsDocument, options);
        }
export type GetUsersByUserIdsQueryHookResult = ReturnType<typeof useGetUsersByUserIdsQuery>;
export type GetUsersByUserIdsLazyQueryHookResult = ReturnType<typeof useGetUsersByUserIdsLazyQuery>;
export type GetUsersByUserIdsQueryResult = Apollo.QueryResult<GetUsersByUserIdsQuery, GetUsersByUserIdsQueryVariables>;
export const InviteUserDocument = gql`
    mutation InviteUser($email: String!, $firstName: String!, $securityRoles: [SecurityRole!]!) {
  inviteUser(email: $email, firstName: $firstName, securityRoles: $securityRoles)
}
    `;
export type InviteUserMutationFn = Apollo.MutationFunction<InviteUserMutation, InviteUserMutationVariables>;

/**
 * __useInviteUserMutation__
 *
 * To run a mutation, you first call `useInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserMutation, { data, loading, error }] = useInviteUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      securityRoles: // value for 'securityRoles'
 *   },
 * });
 */
export function useInviteUserMutation(baseOptions?: Apollo.MutationHookOptions<InviteUserMutation, InviteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument, options);
      }
export type InviteUserMutationHookResult = ReturnType<typeof useInviteUserMutation>;
export type InviteUserMutationResult = Apollo.MutationResult<InviteUserMutation>;
export type InviteUserMutationOptions = Apollo.BaseMutationOptions<InviteUserMutation, InviteUserMutationVariables>;
export const LoadCurrentUserDocument = gql`
    query LoadCurrentUser {
  currentUser {
    id
    avatarUrl
    firstName
    lastName
    phone
    email
    status
    businessRole
    securityRoles
    isTheoremAdmin
  }
}
    `;

/**
 * __useLoadCurrentUserQuery__
 *
 * To run a query within a React component, call `useLoadCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoadCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<LoadCurrentUserQuery, LoadCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadCurrentUserQuery, LoadCurrentUserQueryVariables>(LoadCurrentUserDocument, options);
      }
export function useLoadCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadCurrentUserQuery, LoadCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadCurrentUserQuery, LoadCurrentUserQueryVariables>(LoadCurrentUserDocument, options);
        }
export type LoadCurrentUserQueryHookResult = ReturnType<typeof useLoadCurrentUserQuery>;
export type LoadCurrentUserLazyQueryHookResult = ReturnType<typeof useLoadCurrentUserLazyQuery>;
export type LoadCurrentUserQueryResult = Apollo.QueryResult<LoadCurrentUserQuery, LoadCurrentUserQueryVariables>;
export const RemoveRoleDocument = gql`
    mutation RemoveRole($id: ID!, $role: SecurityRole!) {
  removeRole(id: $id, role: $role)
}
    `;
export type RemoveRoleMutationFn = Apollo.MutationFunction<RemoveRoleMutation, RemoveRoleMutationVariables>;

/**
 * __useRemoveRoleMutation__
 *
 * To run a mutation, you first call `useRemoveRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRoleMutation, { data, loading, error }] = useRemoveRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useRemoveRoleMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRoleMutation, RemoveRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRoleMutation, RemoveRoleMutationVariables>(RemoveRoleDocument, options);
      }
export type RemoveRoleMutationHookResult = ReturnType<typeof useRemoveRoleMutation>;
export type RemoveRoleMutationResult = Apollo.MutationResult<RemoveRoleMutation>;
export type RemoveRoleMutationOptions = Apollo.BaseMutationOptions<RemoveRoleMutation, RemoveRoleMutationVariables>;
export const ResendInviteLinkDocument = gql`
    mutation ResendInviteLink($email: String!, $id: ID!) {
  resendInviteLink(email: $email, id: $id)
}
    `;
export type ResendInviteLinkMutationFn = Apollo.MutationFunction<ResendInviteLinkMutation, ResendInviteLinkMutationVariables>;

/**
 * __useResendInviteLinkMutation__
 *
 * To run a mutation, you first call `useResendInviteLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInviteLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInviteLinkMutation, { data, loading, error }] = useResendInviteLinkMutation({
 *   variables: {
 *      email: // value for 'email'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendInviteLinkMutation(baseOptions?: Apollo.MutationHookOptions<ResendInviteLinkMutation, ResendInviteLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendInviteLinkMutation, ResendInviteLinkMutationVariables>(ResendInviteLinkDocument, options);
      }
export type ResendInviteLinkMutationHookResult = ReturnType<typeof useResendInviteLinkMutation>;
export type ResendInviteLinkMutationResult = Apollo.MutationResult<ResendInviteLinkMutation>;
export type ResendInviteLinkMutationOptions = Apollo.BaseMutationOptions<ResendInviteLinkMutation, ResendInviteLinkMutationVariables>;
export const ResendTheoremAdminInviteLinkDocument = gql`
    mutation ResendTheoremAdminInviteLink($email: String!, $id: ID!) {
  resendTheoremAdminInviteLink(email: $email, id: $id)
}
    `;
export type ResendTheoremAdminInviteLinkMutationFn = Apollo.MutationFunction<ResendTheoremAdminInviteLinkMutation, ResendTheoremAdminInviteLinkMutationVariables>;

/**
 * __useResendTheoremAdminInviteLinkMutation__
 *
 * To run a mutation, you first call `useResendTheoremAdminInviteLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendTheoremAdminInviteLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendTheoremAdminInviteLinkMutation, { data, loading, error }] = useResendTheoremAdminInviteLinkMutation({
 *   variables: {
 *      email: // value for 'email'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendTheoremAdminInviteLinkMutation(baseOptions?: Apollo.MutationHookOptions<ResendTheoremAdminInviteLinkMutation, ResendTheoremAdminInviteLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendTheoremAdminInviteLinkMutation, ResendTheoremAdminInviteLinkMutationVariables>(ResendTheoremAdminInviteLinkDocument, options);
      }
export type ResendTheoremAdminInviteLinkMutationHookResult = ReturnType<typeof useResendTheoremAdminInviteLinkMutation>;
export type ResendTheoremAdminInviteLinkMutationResult = Apollo.MutationResult<ResendTheoremAdminInviteLinkMutation>;
export type ResendTheoremAdminInviteLinkMutationOptions = Apollo.BaseMutationOptions<ResendTheoremAdminInviteLinkMutation, ResendTheoremAdminInviteLinkMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($userInfo: UpdateUserInput!) {
  updateUser(userInfo: $userInfo)
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      userInfo: // value for 'userInfo'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;